/**
 * @license
 * @qwik.dev/core 2.0.0-beta.38-dev+d2618bd
 * Copyright QwikDev. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/QwikDev/qwik/blob/main/LICENSE
 */
import { isServer as Ce, isBrowser as Oe } from "@qwik.dev/core/build";

export { isBrowser, isServer } from "@qwik.dev/core/build";

import { p as Ne } from "@qwik.dev/core/preloader";

const je = !1;

const Fe = (t, ...n) => De(!1, t, ...n);

const De = (t, n, ...e) => {
    const s = n instanceof Error ? n : Error(n);
    console.error("%cQWIK ERROR", "", s.message, ...e, s.stack);
    t && setTimeout(() => {
        throw s;
    }, 0);
    return s;
};

/*@__INLINE__*/ const Xe = (t, n, e) => {
    let s = e >> 1;
    let o = t.length - 2 >> 1;
    for (;s <= o; ) {
        const e = s + (o - s >> 1);
        const i = t[e << 1];
        if (i === n) {
            return e << 1;
        }
        i < n ? s = e + 1 : o = e - 1;
    }
    return ~(s << 1);
};

const We = (t, n, e, s, o = !1) => {
    const i = Xe(t, n, s);
    i >= 0 ? e != null || o ? t[i + 1] = e : t.splice(i, 2) : (e != null || o) && t.splice(i ^ -1, 0, n, e);
};

const Ve = (t, n, e) => {
    const s = Xe(t, n, e);
    return s >= 0 ? t[s + 1] : null;
};

const Ue = (t, n, e) => Xe(t, n, e) >= 0;

const ze = t => {
    const n = Object.getPrototypeOf(t);
    return n === Object.prototype || n === Array.prototype || n === null;
};

const Be = t => typeof t === "object" && t !== null;

const Qe = t => Array.isArray(t);

const He = t => typeof t === "string";

const Je = t => typeof t === "function";

const Ye = (t, n = []) => {
    const e = (t => `Code(Q${t}) https://qwikdev-build-v2.qwik-8nx.pages.dev/docs/errors/#q${t}`)(t, ...n);
    return ((t, ...n) => {
        const e = De(false, t, ...n);
        debugger;
        return e;
    })(e, ...n);
};

const Ge = "<sync>";

const Ke = t => typeof t === "function" && typeof t.getSymbol === "function";

const sd = t => {
    const n = t.lastIndexOf("_") + 1;
    return t.slice(n);
};

const Ze = "q:type";

const ti = {
    ["V"]: "Virtual",
    ["F"]: "Fragment",
    ["S"]: "Signal",
    ["A"]: "Awaited",
    ["C"]: "Component",
    ["I"]: "InlineComponent",
    ["P"]: "Projection"
};

const ii = 124;

const ri = (t, n) => {
    const e = parseInt(t, 10) - 1;
    const s = e + n;
    return -(s * (s + 1) / 2 + n + 1);
};

function t(t) {
    let n = "";
    for (let e = 0; e < t.length; e++) {
        if (t.charAt(e) === "\\" && e + 1 < t.length) {
            n += t.charAt(e + 1);
            e++;
        } else {
            n += t.charAt(e);
        }
    }
    return n;
}

const si = "q:renderFn";

const oi = "q:targetEl";

const li = "⚡️";

const ui = "q:slot";

const ci = "q:s";

const fi = "[q\\:patch]";

const ai = "q:r";

const od = "q:rp";

const hi = "q:style";

const di = "style[q\\:style]";

const pi = di + ",style[q\\:sstyle]";

const $i = "q:sstyle";

const yi = "q:ctx";

const mi = "q:brefs";

const wi = (t, n) => t["qFuncs_" + n] || [];

const vi = "q:base";

const bi = "q:container-island";

const _i = "/" + bi;

const gi = "q:ignore";

const Si = "/" + gi;

const Ei = "q:container";

const ki = "/" + Ei;

const Ri = "q:template";

const Pi = "[q\\:container]:not([q\\:container=html]):not([q\\:container=text])";

const Ti = "http://www.w3.org/1999/xhtml";

const qi = "http://www.w3.org/2000/svg";

const Ai = "http://www.w3.org/1998/Math/MathML";

const Mi = "qRender";

const xi = "q:id";

const Ii = "q:key";

const Ni = "q:props";

const Ci = "q:seq";

const Oi = "q:seqIdx";

const ji = "q:p";

const Li = "q:ps";

const Di = ":on";

const Xi = ":onIdx";

const Wi = ":onFlags";

const Vi = ":cursorBoundary";

const Ui = ":nearestCursorBoundary";

const zi = ":";

const Bi = "dangerouslySetInnerHTML";

const Hi = 100;

const Ji = t => !!t && typeof t == "object" && typeof t.then === "function";

const Yi = (t, n, e) => {
    try {
        const s = t();
        return Ji(s) ? s.then(n, e) : n(s);
    } catch (t) {
        return e(t);
    }
};

const Gi = (t, n) => Ji(t) ? t.then(n) : n(t);

const Ki = t => new Promise(n => {
    setTimeout(n, t);
});

const Zi = t => {
    throw t;
};

function n(t, n = Zi) {
    let e = !1;
    let s;
    try {
        s = t();
        e = !0;
    } catch (t) {
        s = t;
    }
    if (!Ji(s)) {
        if (e) {
            return s;
        }
        return n(s);
    }
    let o = Hi;
    const i = async e => {
        for (;Ji(e); ) {
            try {
                await e;
                return await t();
            } catch (t) {
                if (!Ji(t)) {
                    e = t;
                    break;
                }
                if (! --o) {
                    e = Error("Exceeded max retry count in retryOnPromise");
                    break;
                }
                e = t;
            }
        }
        return n(e);
    };
    return e ? s.catch(i) : i(s);
}

const tr = t => li + t;

const nr = t => {
    if (t) {
        let n = 0;
        do {
            t = t.substring(0, n) + tr(t.substring(n));
        } while ((n = t.indexOf(" ", n) + 1) !== 0);
    }
    return t || null;
};

const er = t => t.charCodeAt(0) === 113 && t.charCodeAt(1) === 45 && (t.charCodeAt(3) === 58 || t.charCodeAt(3) === 112 && t.charCodeAt(4) === 58);

function e(t, n = !1) {
    if (t.endsWith("$")) {
        const [e, s] = function o(t, n = !1) {
            let e;
            let s = -1;
            if (t.startsWith("on")) {
                e = n ? "q-ep:" : "q-e:";
                s = 2;
            } else if (t.startsWith("window:on")) {
                e = n ? "q-wp:" : "q-w:";
                s = 9;
            } else if (t.startsWith("document:on")) {
                e = n ? "q-dp:" : "q-d:";
                s = 11;
            }
            return [ e, s ];
        }(t, n);
        if (s !== -1) {
            return e + ir(t.slice(s, -1));
        }
    }
    return null;
}

const ir = t => t === "DOMContentLoaded" ? "-d-o-m-content-loaded" : function n(t, e = "") {
    const s = rr(t);
    return e + s;
}(t.charAt(0) === "-" ? t.slice(1) : t.toLowerCase());

const rr = t => t.replace(/([A-Z-])/g, t => "-" + t.toLowerCase());

const sr = t => {
    const n = t.indexOf(":");
    return [ t.slice(2, n), t.slice(n + 1) ];
};

const or = new Set([ "animationIterationCount", "aspectRatio", "borderImageOutset", "borderImageSlice", "borderImageWidth", "boxFlex", "boxFlexGroup", "boxOrdinalGroup", "columnCount", "columns", "flex", "flexGrow", "flexShrink", "gridArea", "gridRow", "gridRowEnd", "gridRowStart", "gridColumn", "gridColumnEnd", "gridColumnStart", "fontWeight", "lineClamp", "lineHeight", "opacity", "order", "orphans", "scale", "tabSize", "widows", "zIndex", "zoom", "MozAnimationIterationCount", "MozBoxFlex", "msFlex", "msFlexPositive", "WebkitAnimationIterationCount", "WebkitBoxFlex", "WebkitBoxOrdinalGroup", "WebkitColumnCount", "WebkitColumns", "WebkitFlex", "WebkitFlexGrow", "WebkitFlexShrink", "WebkitLineClamp" ]);

const lr = (t, n = 0) => {
    for (let e = 0; e < t.length; e++) {
        const s = t.charCodeAt(e);
        n = (n << 5) - n + s;
        n |= 0;
    }
    return (+Math.abs(n)).toString(36);
};

const ur = t => {
    if (!t) {
        return "";
    }
    if (He(t)) {
        return t.trim();
    }
    const n = [];
    if (Qe(t)) {
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            const o = ur(s);
            o && n.push(o);
        }
    } else {
        for (const [e, s] of Object.entries(t)) {
            s && n.push(e.trim());
        }
    }
    return n.join(" ");
};

const cr = t => t.replace(/([A-Z])/g, "-$1").toLowerCase();

const fr = t => {
    if (t == null) {
        return "";
    }
    if (typeof t == "object") {
        if (Qe(t)) {
            throw Ye(0, [ t, "style" ]);
        }
        {
            const n = [];
            for (const e in t) {
                if (Object.prototype.hasOwnProperty.call(t, e)) {
                    const s = t[e];
                    s != null && typeof s !== "function" && (e.startsWith("--") ? n.push(e + ":" + s) : n.push(cr(e) + ":" + ar(e, s)));
                }
            }
            return n.join(";");
        }
    }
    return t + "";
};

function i(t, n, e) {
    if (function s(t) {
        return t === "class";
    }(t)) {
        const t = ur(n);
        n = e ? e + (t.length ? " " + t : t) : t;
    } else {
        t === "style" ? n = fr(n) : function o(t) {
            return function n(t) {
                return t.startsWith("aria-");
            }(t) || [ "spellcheck", "draggable", "contenteditable" ].includes(t);
        }(t) || typeof n === "number" ? n = (t => t != null ? t + "" : null)(n) : n === !1 || n == null ? n = null : n === !0 && function i(t) {
            return t.startsWith("preventdefault:");
        }(t) && (n = "");
    }
    return n;
}

const ar = (t, n) => {
    if (typeof n === "number" && n !== 0 && !(t => or.has(t))(t)) {
        return n + "px";
    }
    return n;
};

const hr = t => {
    let n;
    if (typeof MessageChannel !== "undefined") {
        const e = new MessageChannel;
        let s = !0;
        e.port1.onmessage = () => t();
        n = () => {
            s && e.port2.postMessage(null);
        };
        n.an = () => {
            if (s) {
                s = !1;
                e.port1.onmessage = null;
                e.port1.close();
                e.port2.close();
            }
        };
    } else {
        n = () => setTimeout(t);
    }
    return n;
};

const dr = () => ({
    isServer: Ce,
    importSymbol(t, n, e) {
        if (Ce) {
            const t = sd(e);
            const n = globalThis.__qwik_reg_symbols?.get(t);
            if (n) {
                return n;
            }
            throw Ye(6, [ e ]);
        }
        if (!n) {
            throw Ye(14, [ e ]);
        }
        if (!t) {
            throw Ye(13, [ n, e ]);
        }
        const s = pr(t.ownerDocument, t, n).toString();
        const o = new URL(s);
        o.hash = "";
        const i = o.href;
        return import(i).then(t => t[e]);
    },
    raf: t => new Promise(n => {
        requestAnimationFrame(() => {
            n(t());
        });
    }),
    chunkForSymbol(t, n) {
        return [ t, n ?? "_" ];
    }
});

const pr = (t, n, e) => {
    const s = t.baseURI;
    const o = new URL(n.getAttribute(vi) ?? s, s);
    return new URL(e, o);
};

let $r = /*#__PURE__ */ dr();

const yr = t => $r = t;

const mr = () => $r;

const cd = () => $r.isServer;

const ld = typeof document !== "undefined";

const wr = !Ce && ld;

const vr = wr ? document : void 0;

const br = wr && vr.createElement("link").relList?.supports?.("modulepreload") ? "modulePreload" : "preload";

const _r = /\.[mc]?js$/;

const gr = t => {
    let n = Sr.get(t);
    if (!n) {
        let e;
        n = ((t, n) => ({
            hn: t,
            Qt: _r.test(t) ? 0 : 3,
            dn: n,
            pn: 1,
            $n: performance.now(),
            yn: 0,
            mn: 0
        }))(t, e);
        Sr.set(t, n);
    }
    return n;
};

const Sr = new Map;

let Er = 0;

const kr = [];

const Rr = hr(function ud() {
    Tr = !1;
    if (!kr.length) {
        return;
    }
    const t = performance.now() + 10;
    let n = !1;
    for (;kr.length; ) {
        const e = kr[0];
        const s = e.pn;
        const o = 1 - s;
        if (!(o >= .99 || Er < 25)) {
            break;
        }
        kr.shift();
        Ir(e);
        if (performance.now() >= t) {
            n = !0;
            break;
        }
    }
    if (n && kr.length && !Tr) {
        Tr = !0;
        Rr();
    }
});

const Pr = hr(r);

let Tr = !1;

let qr = !1;

let Ar = !1;

const Mr = [];

const xr = () => {
    const t = Mr[Mr.length - 1];
    const n = t.wn;
    if (t.dn) {
        const e = t.Ot;
        if (e >= t.dn.length) {
            Mr.pop();
            return !1;
        }
        const s = t.dn[e];
        t.Ot = e + 1;
        const o = gr(s.hn);
        if (o.pn === 0) {
            return !0;
        }
        const i = 1 - n.pn;
        let r;
        if (i === 1 || i >= .99) {
            r = Math.min(.01, 1 - s.vn);
        } else {
            const t = 1 - s.vn * i;
            const n = s.bn;
            const e = t / n;
            r = Math.max(.02, o.pn * e);
            s.bn = e;
        }
        Mr.push({
            wn: o,
            pn: r,
            _n: t._n
        });
        return !0;
    }
    if (t._n?.has(n)) {
        Mr.pop();
        return !1;
    }
    const e = n.pn;
    n.pn = t.pn;
    if (e - n.pn < .01) {
        Mr.pop();
        return !1;
    }
    if (n.dn?.length) {
        const e = t._n || new Set;
        e.add(n);
        t._n = e;
        t.dn = n.dn;
        t.Ot = 0;
        return !1;
    }
    Mr.pop();
    return !1;
};

function r() {
    if (Ar || !Mr.length) {
        return;
    }
    qr = !1;
    Ar = !0;
    const t = wr ? performance.now() + 10 : 0;
    let n = !1;
    for (;Mr.length; ) {
        n = !0;
        const e = xr();
        if (wr && e && performance.now() >= t) {
            if (!qr) {
                qr = !0;
                Pr();
            }
            break;
        }
    }
    Ar = !1;
    n && wr && Rr();
}

const Ir = t => {
    if (t.Qt >= 2) {
        return;
    }
    Er++;
    const n = performance.now();
    t.yn = n - t.$n;
    t.Qt = 2;
    const e = vr.createElement("link");
    e.href = new URL("undefined" + t.hn, vr.baseURI).toString();
    e.rel = br;
    e.as = "script";
    e.onload = e.onerror = () => {
        Er--;
        const s = performance.now();
        t.mn = s - n;
        t.Qt = 4;
        e.remove();
        Rr();
    };
    vr.head.appendChild(e);
};

const Nr = (t, n) => {
    const e = gr(t);
    e && ((t, n) => {
        Mr.unshift({
            wn: t,
            pn: n,
            _n: void 0
        });
    })(e, n);
};

wr && document.addEventListener("qsymbol", t => {
    const {symbol: n, href: e} = t.detail;
    if (e) {
        const t = n.slice(n.lastIndexOf("_") + 1);
        (t => {
            if (!t?.length) {
                return;
            }
            if (Array.isArray(t)) {
                for (let n = t.length - 1; n >= 0; n--) {
                    const e = t[n];
                    Nr(e, 0);
                }
            } else {
                Nr(t, 0);
            }
            wr ? Pr() : r();
        })(t);
    }
});

const Cr = t => {
    for (const n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
            return !1;
        }
    }
    return !0;
};

const Or = t => ({
    write: t,
    writeRootRef(t) {
        return ((t, n) => t.write(n + ""))(this, t);
    },
    writeRootRefPath(t) {
        return ((t, n) => t.write((t => {
            let n = t[0] + "";
            for (let e = 1; e < t.length; e++) {
                n += " " + t[e];
            }
            return n;
        })(n)))(this, t);
    },
    writeRootRefDelta(t, n) {
        return ((t, n, e) => t.write(n - e + ""))(this, t, n);
    }
});

const jr = '"';

const Lr = "[";

const Fr = "]";

const Dr = ",";

const Xr = "2.0.0-beta.38-dev+d2618bd";

const Wr = t => t.nodeType === 1;

const fd = t => t.Gn;

const Vr = Symbol();

class Ur {
    [Vr]=void 0;
}

const zr = t => t === "foreignObject";

const Br = t => t === "svg" || zr(t);

const Qr = t => t === "math";

function s(t, n, e, o = !1) {
    const i = t.ownerDocument.createElementNS(e, n);
    for (let n = 0; n < t.attributes.length; n++) {
        const e = t.attributes[n];
        e.name !== zi && i.setAttribute(e.name, e.value);
    }
    if (o) {
        for (let n = 0; n < t.childNodes.length; n++) {
            const r = t.childNodes[n];
            const c = r.nodeType;
            c === 3 ? i.appendChild(r.cloneNode()) : c === 1 && i.appendChild(s(r, r.localName, e, o));
        }
    }
    return i;
}

const Hr = {
    elementNamespace: Ti,
    elementNamespaceFlag: 0
};

function o(t, n) {
    const e = !t || !!Bl(t) && (t => {
        const n = t.flags;
        return (n & 1536) === 0;
    })(t);
    const s = !e && zr(Bl(t));
    let o = Ti;
    let i = 0;
    const r = typeof n === "string" || pl(n);
    if (r && function c(t) {
        if (typeof t === "string") {
            return Br(t);
        }
        if (pl(t)) {
            return Br(Bl(t)) || (t.flags & 512) !== 0;
        }
        return !1;
    }(n)) {
        o = qi;
        i = 512;
    } else if (r && function l(t) {
        if (typeof t === "string") {
            return Qr(t);
        }
        if (pl(t)) {
            return Qr(Bl(t)) || (t.flags & 1024) !== 0;
        }
        return !1;
    }(n)) {
        o = Ai;
        i = 1024;
    } else if (t && !s && !e) {
        const n = (t.flags & 512) !== 0;
        const e = (t.flags & 1024) !== 0;
        o = n ? qi : e ? Ai : Ti;
        i = t.flags & 1536;
    }
    Hr.elementNamespace = o;
    Hr.elementNamespaceFlag = i;
    return Hr;
}

class Jr {
    flags;
    parent;
    previousSibling;
    nextSibling;
    props;
    [Vr]=void 0;
    slotParent=null;
    dirty=0;
    dirtyChildren=null;
    nextDirtyChildIndex=0;
    constructor(t, n, e, s, o) {
        this.flags = t;
        this.parent = n;
        this.previousSibling = e;
        this.nextSibling = s;
        this.props = o;
    }
    toString() {
        return Object.prototype.toString.call(this);
    }
}

class Yr extends Jr {
    key;
    firstChild;
    lastChild;
    constructor(t, n, e, s, o, i, r, c) {
        super(n, e, s, o, i);
        this.key = t;
        this.firstChild = r;
        this.lastChild = c;
    }
}

class Gr extends Yr {
    node;
    elementName;
    constructor(t, n, e, s, o, i, r, c, l, u) {
        super(t, n, e, s, o, i, r, c);
        this.node = l;
        this.elementName = u;
    }
}

class Kr extends Jr {
    node;
    text;
    constructor(t, n, e, s, o, i, r) {
        super(t, n, e, s, o);
        this.node = i;
        this.text = r;
    }
}

const Zr = [];

const ts = [];

function l(t, n) {
    const e = y(n).priority;
    let s = Zr.length;
    for (let t = 0; t < Zr.length; t++) {
        const n = y(Zr[t]).priority;
        if (e < n) {
            s = t;
            break;
        }
    }
    Zr.splice(s, 0, n);
    t.o++;
    t.l ||= new Promise(n => t.u = n);
}

function u() {
    for (let t = 0; t < Zr.length; t++) {
        const n = Zr[t];
        let e = !1;
        for (let t = 0; t < ts.length; t++) {
            const s = ts[t];
            if (pu(n, s)) {
                e = !0;
                break;
            }
        }
        if (!e) {
            return n;
        }
    }
    return null;
}

function c(t, n) {
    ts.push(t);
    h(t, n, !0);
    n.o++;
}

function f(t, n) {
    d(t, n);
    if (!(t.flags & 256)) {
        return;
    }
    l(n, t);
}

function a(t, n, e) {
    const s = y(e);
    if (!s || s === n) {
        return;
    }
    h(e, t, !1);
    d(e, t);
    $(n, s);
    s.afterFlushTasks = null;
    s.extraPromises = null;
    s.journal = null;
    s.boundaries = null;
    s.position = null;
    s.promise = null;
}

function h(t, n, e) {
    e || (t.flags &= -257);
    const s = Zr.indexOf(t);
    if (s !== -1) {
        Zr.splice(s, 1);
        n.o--;
        return !0;
    }
    return !1;
}

function d(t, n) {
    const e = ts.indexOf(t);
    if (e === -1) {
        return !1;
    }
    const s = ts.length - 1;
    e !== s && (ts[e] = ts[s]);
    ts.pop();
    n.o--;
    return !0;
}

const ns = new WeakMap;

const es = ":nodeProps";

const is = ":nodeDiff";

const rs = ":errorData";

const ss = ":signal";

const os = ":inlineComponentData";

function p(t, n, e) {
    n.position = e;
    e && dn(e) && function s(t, n, e) {
        const s = y(e);
        if (!s || s === n) {
            return;
        }
        h(e, t);
        (function o(t, n) {
            if (n === t) {
                return;
            }
            const e = n.afterFlushTasks;
            if (e && e.length > 0) {
                const n = t.afterFlushTasks;
                n ? n.push(...e) : t.afterFlushTasks = e;
            }
            const s = n.extraPromises;
            if (s && s.length > 0) {
                const n = t.extraPromises;
                n ? n.push(...s) : t.extraPromises = s;
            }
            $(t, n);
        })(n, s);
    }(t, n, e);
}

function $(t, n) {
    if (n === t) {
        return;
    }
    const e = n.journal;
    if (e && e.length > 0) {
        const n = t.journal;
        n ? n.push(...e) : t.journal = e;
    }
    const s = n.boundaries;
    if (__EXPERIMENTAL__.suspense && s && s.length > 0) {
        const n = t.boundaries ||= [];
        for (let t = 0; t < s.length; t++) {
            const e = s[t];
            n.includes(e) || n.push(e);
        }
    }
}

function y(t) {
    return ns.get(t) ?? null;
}

const ls = Symbol();

const us = Symbol();

const cs = Symbol();

const fs = Symbol();

const as = Symbol();

const hs = Symbol();

const ds = [];

const ps = {};

Object.freeze(ds);

Object.freeze(ps);

function m(t) {
    return new Proxy({}, new $s(t));
}

class $s {
    owner;
    ht=void 0;
    $=null;
    constructor(t) {
        this.owner = t;
    }
    get(t, n) {
        if (n === ls) {
            return this.owner.constProps;
        }
        if (n === us) {
            return this.owner.varProps;
        }
        if (n === cs) {
            return this.owner;
        }
        if (n === fs) {
            return this;
        }
        let s;
        if (n === "children") {
            s = this.owner.children;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            s = ws(this.owner, n);
            n in this.owner.varProps && ys(this, n);
        }
        return s instanceof Js ? s.value : s;
    }
    set(t, n, s) {
        if (n === cs) {
            this.owner = s;
        } else if (n === "children") {
            this.owner.children = s;
        } else if (n === ls) {
            this.owner.constProps = s;
        } else if (n === us) {
            this.owner.varProps = s;
        } else {
            if (typeof n === "string" && typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
            this.owner.constProps && n in this.owner.constProps && delete this.owner.constProps[n];
            this.owner.varProps === ps ? this.owner.varProps = {} : n in this.owner.varProps || (this.owner.toSort = !0);
            if (this.owner.varProps[n] !== s) {
                this.owner.varProps[n] = s;
                ms(this, n);
            }
        }
        return !0;
    }
    deleteProperty(t, n) {
        let e = delete this.owner.varProps[n];
        e && ms(this, n);
        this.owner.constProps && (e = delete this.owner.constProps[n] || e);
        if (this.owner.children != null && n === "children") {
            this.owner.children = null;
            e = !0;
        }
        return e;
    }
    has(t, n) {
        if (n === "children") {
            return this.owner.children != null;
        }
        if (n === ls || n === us) {
            return !0;
        }
        const s = n in this.owner.varProps;
        if (typeof n === "string") {
            s && ys(this, n);
            if (typeof this.owner.type === "string") {
                const t = e(n);
                t && (n = t);
            }
        }
        return s || !!this.owner.constProps && n in this.owner.constProps;
    }
    getOwnPropertyDescriptor(t, n) {
        const e = n === "children" ? this.owner.children : this.owner.constProps && n in this.owner.constProps ? this.owner.constProps[n] : this.owner.varProps[n];
        return {
            configurable: !0,
            enumerable: !0,
            value: e
        };
    }
    ownKeys() {
        const t = Object.keys(this.owner.varProps);
        this.owner.children != null && t.push("children");
        if (this.owner.constProps) {
            for (const n in this.owner.constProps) {
                t.indexOf(n) === -1 && t.push(n);
            }
        }
        return t;
    }
}

const ys = (t, n) => {
    const e = If();
    e && t.$ === null && e.$ && (t.$ = e.$);
    const s = e?.un;
    s && In(t.owner._proxy, n, t, s);
};

const ms = (t, n) => {
    const e = function s(t, n) {
        return t?.get(n);
    }(t.ht, n);
    e && Iu(t.$, t, e);
    return !!e;
};

const ws = (t, n) => t.constProps && n in t.constProps ? t.constProps[n] : t.varProps[n];

const vs = (t, n) => bs(t)?.[n] || _s(t)?.[n] || null;

const bs = t => {
    if (!t) {
        return null;
    }
    return us in t ? "children" in t ? {
        ...t[us],
        children: t.children
    } : t[us] : t;
};

const _s = t => {
    if (!t) {
        return null;
    }
    return ls in t ? t[ls] : null;
};

const gs = t => t && us in t;

const Ss = Symbol();

class Es {
    consumer;
    property;
    backRef;
    data;
    constructor(t, n, e = null, s = null) {
        this.consumer = t;
        this.property = n;
        this.backRef = e;
        this.data = s;
    }
}

const ks = Symbol();

const Rs = Symbol();

const Ps = Symbol();

function w(t, n, e) {
    t[Vr] || (Ce && function s(t) {
        return "__brand__" in t && t.__brand__ === "SsrNode";
    }(t) ? t.setProp(mi, new Map) : t[Vr] = new Map);
    const o = t[Vr];
    let i = o.get(n);
    if (!i) {
        i = new Es(t, n);
        o.set(n, i);
    }
    e && (i.data = e);
    return i;
}

const Ts = (t, n) => (e, s) => {
    const o = xe();
    o.un = w(t, ":");
    o.$ = n || void 0;
    return qe(o, () => {
        if (Je(e)) {
            return e();
        }
        if (s) {
            return e[s];
        }
        if (Tu(e)) {
            return e.value;
        }
        if (Be(e) && zu(e)) {
            In(Xu(e), Ps, Du(e), o.un);
            return e;
        }
        throw Ye(2);
    });
};

class qs {
    jt;
    ht=void 0;
    $=null;
    gn=null;
    constructor(t, n) {
        this.$ = t || If()?.$ || null;
        this.jt = n;
    }
    trigger() {
        Iu(this.$, this, this.ht);
    }
    force() {
        Iu(this.$, this, this.ht);
    }
    get untrackedValue() {
        return this.jt;
    }
    set untrackedValue(t) {
        this.jt = t;
    }
    get value() {
        const t = this.untrackedValue;
        const n = If();
        if (!n) {
            return t;
        }
        this.$ === null && (this.$ = n.$);
        const e = n.un;
        if (e) {
            const t = Ce;
            const s = this.ht ||= new Set;
            const o = __EXPERIMENTAL__.suspense && t;
            qu(s, e);
            Au(e, this);
            if (t) {
                const t = xu(n.$, this.$);
                o && t?.Sn?.(this, e, null);
                Mu(e, t);
            }
        }
        return t;
    }
    set value(t) {
        if (t !== this.jt) {
            this.jt = t;
            Iu(this.$, this, this.ht);
        }
    }
    valueOf() {}
    toString() {
        return this.constructor.name;
    }
    toJSON() {
        return {
            value: this.jt
        };
    }
}

class As {
    En;
    kn=null;
    Rn=!1;
    Pn=!0;
    constructor(t, n, e) {
        this.En = t;
        if (n !== void 0) {
            this.info = n;
            this.Tn = e;
        }
    }
    get track() {
        return this.qn ||= Ts(this.En, this.En.$);
    }
    get abortSignal() {
        return (this.An ||= new AbortController).signal;
    }
    cache() {}
    get previous() {
        const t = this.En.jt;
        if (t !== Ss) {
            return t;
        }
    }
    cleanup(t) {
        typeof t === "function" && (this.Mn ||= []).push(t);
    }
}

class Ms extends qs {
    Lt;
    h;
    [Vr]=void 0;
    constructor(t, n, e = 17, s) {
        super(t || If()?.$, Ss);
        this.Lt = n;
        this.h = e;
        if (!s) {
            return;
        }
        const o = s.initial;
        o !== void 0 && (this.jt = typeof o === "function" ? o() : o);
        const i = s.concurrency;
        if (i !== void 0 && i >= 0 && i !== 1) {
            this.Xt = i;
            this.Wt = [];
        }
        s.timeout && (this.Vt = s.timeout);
        s.eagerCleanup && (this.h |= 32);
        s.clientOnly && (this.h |= 576);
        s.allowStale === !1 && (this.h |= 128);
        const r = s.expires ?? (s.interval ? Math.abs(s.interval) : void 0);
        r && (this.expires = r);
        (s.poll === !1 || s.interval !== void 0 && s.interval < 0) && (this.h |= 256);
    }
    invalidate(t) {
        if (arguments.length > 0) {
            this.xn = t;
            this.Tn = this.Tn === void 0 ? 1 : this.Tn + 1;
        }
        if (this.h & 512) {
            this.In(!0, this.h & 128);
            return;
        }
        this.h |= 1;
        const e = xe();
        e.$ = this.$ || void 0;
        const s = n(Ae.bind(this, e, this.p));
        Ji(s) && s.catch(t => {
            this.$ ? this.$.handleError(t, null) : console.error("Error during computation", t);
        });
    }
    get value() {
        return super.value;
    }
    set value(t) {
        this.h &= -2;
        this.untrackedError = void 0;
        if (this.h & 512) {
            this.untrackedPending = !1;
            this.xn = void 0;
            if (this.Wt) {
                for (let t = 0; t < this.Wt.length; t++) {
                    this.Wt[t].Pn = !1;
                }
            } else {
                this.lt && (this.lt.Pn = !1);
            }
            this.Nn();
            super.value = t;
            this.Cn();
            return;
        }
        super.value = t;
    }
    get untrackedValue() {
        this.p();
        if (this.lt?.kn) {
            if (this.jt === Ss || Ce) {
                throw this.lt?.kn;
            }
            return this.jt;
        }
        if (this.Ft) {
            throw this.Ft;
        }
        if (Ce && this.h & 64 && this.jt === Ss) {
            throw Ye(35);
        }
        return this.jt;
    }
    set untrackedValue(t) {
        this.jt = t;
    }
    get pending() {
        const t = this.untrackedPending;
        const n = If();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.un;
            if (t) {
                qu(this.wt ||= new Set, t);
                Au(t, this);
                Mu(t, this.$);
            }
        }
        return t;
    }
    set untrackedPending(t) {
        if (t !== !!this.Dt) {
            this.Dt = t;
            Iu(this.$, this, this.wt);
        }
    }
    get untrackedPending() {
        this.p();
        if (Ce && this.lt?.kn) {
            throw this.lt?.kn;
        }
        return !!this.Dt;
    }
    get loading() {
        return this.pending;
    }
    get untrackedLoading() {
        return this.untrackedPending;
    }
    set untrackedLoading(t) {
        this.untrackedPending = t;
    }
    get error() {
        const t = this.untrackedError;
        const n = If();
        if (n && (this.$ ||= n.$ || null)) {
            const t = n.un;
            if (t) {
                qu(this.vt ||= new Set, t);
                Au(t, this);
                Mu(t, this.$);
            }
        }
        return t;
    }
    set untrackedError(t) {
        if (t !== this.Ft) {
            this.Ft = t;
            Iu(this.$, this, this.vt);
        }
    }
    get untrackedError() {
        this.p();
        if (Ce && this.lt?.kn) {
            throw this.lt?.kn;
        }
        return this.Ft;
    }
    get expires() {
        return this.qt || 0;
    }
    set expires(t) {
        this.Nn();
        this.qt = t;
        this.qt && this.On() && this.Cn();
    }
    get poll() {
        return !(this.h & 256);
    }
    set poll(t) {
        t ? this.h &= -257 : this.h |= 256;
        if (this.qt && this.On()) {
            this.Nn();
            this.Cn();
        }
    }
    get interval() {
        const t = this.qt || 0;
        return this.h & 256 ? -t : t;
    }
    set interval(t) {
        t < 0 ? this.h |= 256 : this.h &= -257;
        this.expires = Math.abs(t);
    }
    In(t, n) {
        this.h |= 1;
        this.Nn();
        n && (this.jt = Ss);
        t && (this.ht?.size || this.wt?.size || this.vt?.size) && Promise.resolve().then(() => this.p());
    }
    abort(t) {
        this.lt && this.jn(this.lt, t);
    }
    bt() {
        if (!(this.h & 32) || this.On()) {
            return;
        }
        if (!Oe) {
            return;
        }
        setTimeout(() => {
            this.On() || this.abort();
        });
    }
    async promise() {
        this.p();
        for (;this.lt?.kn; ) {
            await (this.lt?.kn);
        }
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        if (this.h & 512) {
            return this.Ln();
        }
        const t = this.Lt;
        Pu(t);
        const e = this.lt;
        if (e && !e.Rn) {
            e.Rn = !0;
            e.An?.abort();
            this.Fn(e);
        }
        const s = new As(this, this.xn, this.Tn);
        this.lt = s;
        let o;
        try {
            o = this.Dn(t.resolved, s);
        } catch (t) {
            if (Ji(t)) {
                throw t;
            }
            s.Tn === this.Tn && (this.xn = void 0);
            this.h &= -2;
            this.Xn(s, t);
            return;
        }
        if (Ji(o)) {
            this.h |= 512;
            this.h &= -2;
            let t = o;
            const e = () => {
                const n = t ?? this.Dn(this.Lt.resolved, s);
                t = void 0;
                return n;
            };
            s.kn = this.Wn(s, () => n(e));
            return;
        }
        s.Tn === this.Tn && (this.xn = void 0);
        this.h &= -2;
        this.untrackedError = void 0;
        super.value = o;
    }
    Dn(t, n) {
        const e = t;
        if (this.h & 1024) {
            let t = If();
            t?.un && (t = {
                ...t,
                un: void 0
            });
            return Ae(t, e, [ n ]);
        }
        const s = this.$ ||= If()?.$ || null;
        const o = w(this, ".");
        s && Rn(s, o);
        const i = xe();
        i.$ = s || void 0;
        i.un = o;
        return Ae(i, e, [ n ]);
    }
    Ln() {
        if (Ce && this.h & 64) {
            this.Dt = !0;
            this.$?.serializationCtx.At.add(this);
            return;
        }
        this.Nn();
        this.h &= -2;
        const t = this.lt;
        t && this.jn(t);
        const n = this.Xt === 0 ? Infinity : this.Xt ?? 1;
        if (this.Wt ? this.Wt.length >= n : t?.kn) {
            this.h |= 1;
            return;
        }
        const e = this.Tn;
        const s = new As(this, this.xn, e);
        this.lt = s;
        this.Wt && this.Wt.push(s);
        s.kn = this.Vn(s);
    }
    async Vn(t) {
        let e = this.Lt.resolved;
        if (!e) {
            this.untrackedPending = !0;
            e = await this.Lt.resolve();
            if (t.An?.signal.aborted) {
                t.kn = null;
                return;
            }
        }
        this.Vt && (this.Un = setTimeout(() => {
            const n = Error(`timeout ${this.Vt}ms`);
            this.Xn(t, n);
            t.An?.abort(n);
        }, this.Vt));
        return this.Wn(t, () => n(() => this.Dn(e, t)));
    }
    async Wn(t, n) {
        try {
            const e = n();
            let s;
            if (Ji(e)) {
                this.untrackedPending = !0;
                s = await e;
            } else {
                s = e;
            }
            t.kn = null;
            if (t.Pn) {
                const n = this.Wt;
                if (n) {
                    let e = !1;
                    for (let s = n.length - 1; s >= 0; s--) {
                        n[s] === t ? e = !0 : e && (n[s].Pn = !1);
                    }
                }
                this.untrackedError = void 0;
                super.value = s;
            }
        } catch (n) {
            t.kn = null;
            this.Xn(t, n);
        }
        if ((() => t === this.lt)()) {
            clearTimeout(this.Un);
            t.Tn === this.Tn && (this.xn = void 0);
            if (this.h & 1) {
                this.p();
            } else {
                this.untrackedPending = !1;
                this.Cn();
            }
        }
    }
    Xn(t, n) {
        if (t !== this.lt || !t.Pn) {
            return;
        }
        t.Pn = !1;
        if (n instanceof Error && n.name === "AbortError") {
            return;
        }
        this.untrackedError = n;
        this.untrackedValue = Ss;
    }
    async an() {
        this.Nn();
        clearTimeout(this.Un);
        const t = this.lt;
        t && this.jn(t);
        this.Wt ? await Promise.all(this.Wt.map(t => t.kn)) : await (t?.kn);
    }
    Nn() {
        if (this.zn !== void 0) {
            clearTimeout(this.zn);
            this.zn = void 0;
        }
    }
    Cn() {
        if (Ce || !this.qt) {
            return;
        }
        this.Nn();
        const t = !(this.h & 256);
        const n = this.h & 128 && !t;
        this.zn = setTimeout(() => this.In(t, n), this.qt);
        this.zn?.unref?.();
    }
    On() {
        return !!(this.ht?.size || this.wt?.size || this.vt?.size);
    }
    jn(t, n) {
        if (t.Rn) {
            return;
        }
        t.Rn = !0;
        t.An?.abort(n);
        t.kn = Gi(t.kn, () => this.Bn(t));
    }
    Fn(t) {
        const n = t.Mn;
        const e = t => {
            const n = this.$?.handleError;
            n ? n(t, null) : console.error("Error in async signal cleanup", t);
        };
        let s;
        if (n) {
            for (let t = 0; t < n.length; t++) {
                try {
                    const o = n[t]();
                    Ji(o) && (s = (s ? s.then(() => o) : o).catch(e));
                } catch (t) {
                    e(t);
                }
            }
            n.length = 0;
        }
        return s;
    }
    Bn(t) {
        const n = () => {
            t.kn = null;
            const n = this.Wt;
            if (n) {
                const e = n.indexOf(t);
                e !== -1 && n.splice(e, 1);
            }
            this.p();
        };
        const e = this.Fn(t);
        if (e) {
            return e.then(n);
        }
        n();
    }
}

const xs = t => (n, ...e) => t.call(null, $a(n), ...e);

class Is extends Ms {
    constructor(t, n) {
        super(t, n, 17);
    }
    Qn=!1;
    p() {
        if (!(this.h & 1)) {
            return;
        }
        Pu(this.Lt);
        const t = jf(this.Lt.resolved);
        const {deserialize: n, initial: e} = t;
        const s = t.update;
        const o = this.jt === Ss ? e : this.jt;
        const i = Ff(() => this.Qn ? s?.(o) || o : n(o), this, ".", this.$);
        this.Qn = !0;
        this.h &= -2;
        const r = this.Qn && i !== "undefined" || i !== this.jt;
        if (r) {
            this.jt = i;
            Iu(this.$, this, this.ht);
        }
    }
}

class Ns extends Ms {
    constructor(t, n, e = 17, s) {
        super(t, n, 1536 | e, s);
    }
}

const Cs = (t, n) => {
    const e = t;
    e.invalidate({
        __v: n
    });
    e.p();
};

const Os = (t, n) => new Ms(n?.container || null, t, Cu(n?.serializationStrategy || "always"), n);

const js = (t, n) => new Ns(n?.container || null, t, Cu(n?.serializationStrategy || "always"), n);

const Ls = t => new Is(null, t);

const Fs = t => new qs(null, t);

const Ds = /*#__PURE__*/ xs(Os);

const Xs = /*#__PURE__*/ xs(js);

const Ws = xs(Ls);

const Vs = t => t.value;

const Us = (t, n) => t[n];

const zs = t => {
    if (t.length === 1) {
        if (Tu(t[0])) {
            return t[0].gn ||= new Js(null, Vs, t, null);
        }
        if (zu(t[0])) {
            return new Js(null, Vs, t, null);
        }
        return t[0].value;
    }
    return new Js(null, Us, t, null);
};

const Bs = (...t) => {
    const n = t[0];
    const e = t.length < 2 ? "value" : t[1];
    if (!Be(n)) {
        return n[e];
    }
    if (Tu(n)) {
        if (n instanceof Js) {
            return n;
        }
        return zs(t);
    }
    if (gs(n)) {
        const s = n[ls];
        const o = n[us];
        if (s && Object.prototype.hasOwnProperty.call(s, e)) {
            return s[e];
        }
        if (Object.prototype.hasOwnProperty.call(o, e)) {
            const n = o[e];
            return Qs(n, t);
        }
    } else {
        const s = Xu(n);
        if (s) {
            const n = s[e];
            return Qs(n, t);
        }
    }
    return n[e];
};

const Qs = (t, n) => Tu(t) ? t : zs(n);

const Hs = (t, n) => {
    const e = Bs(t, n);
    if (e === as) {
        return t[n];
    }
    return e;
};

class Js extends qs {
    ct;
    ut;
    Pt;
    h;
    _=void 0;
    [Vr]=void 0;
    constructor(t, n, e, s, o = 1) {
        super(t, Ss);
        this.ct = e;
        this.ut = n;
        this.Pt = s;
        this.h = o;
    }
    invalidate() {
        this.h |= 1;
        try {
            this.p();
        } catch (t) {
            if (this.$ && this._) {
                this.$.setHostProp(this._, ss, this);
                yn(this.$, this._, 32);
            }
        }
        if (this.h & 2) {
            this.h &= -3;
            Iu(this.$, this, this.ht);
        }
    }
    get untrackedValue() {
        this.p();
        return this.jt;
    }
    p() {
        if (!(this.h & 1)) {
            return;
        }
        const t = Ff(() => this.ut(...this.ct), this, ".", this.$);
        this.h &= -3;
        const n = t !== this.jt;
        if (n) {
            this.h |= 2;
            this.jt = t;
        }
    }
    st() {
        return this.ut === Vs && Tu(this.ct[0]) ? this.ct[0] : this;
    }
    set value(t) {
        throw Ye(31);
    }
    get value() {
        return super.value;
    }
}

class Ys {
    data;
    constructor(t) {
        this.data = t;
    }
}

Object.prototype.hasOwnProperty;

class Gs {
    type;
    children;
    flags;
    toSort;
    key;
    varProps;
    constProps;
    dev;
    _proxy=null;
    constructor(t, n, e, s, o, i, r, c) {
        this.type = t;
        this.children = s;
        this.flags = o;
        this.toSort = !!r;
        this.key = i === null || i === void 0 ? null : typeof i === "string" ? i : "" + i;
        this.varProps = !n || Cr(n) ? ps : n;
        this.constProps = !e || Cr(e) ? null : e;
    }
    get props() {
        return this._proxy ||= m(this);
    }
}

const Ks = (t, n, e) => {
    let s = t[n];
    if (!s) {
        t[n] = e;
        return !0;
    }
    Array.isArray(s) ? s.push(e) : s = t[n] = [ s, e ];
};

const Zs = t => t instanceof Gs;

const to = (t, n, e) => {
    if (typeof t === "string") {
        const s = Se(n);
        return qf(s, () => {
            ea(ia(s, t));
            return e();
        });
    }
    return e();
};

function v(t, n) {
    return to(this, n, () => {
        const t = na[0];
        t.value = n.type === "number" ? n.valueAsNumber : n.value;
    });
}

function b(t, n) {
    return to(this, n, () => {
        const t = na[0];
        t.value = n.checked;
    });
}

function _(t, n) {
    return to(this, n, () => {
        if (na) {
            for (let t = 0; t < na.length; t++) {
                const n = na[t];
                n instanceof Ns && n.h & 64 && n.p();
            }
        }
    });
}

const no = "bind:value";

const eo = "bind:checked";

const io = "passive:";

const ro = "preventdefault:";

const so = Object.prototype.hasOwnProperty;

const oo = (t, n, e, s, o = !1) => {
    let i = t;
    let r = o;
    if (n.length > 0) {
        if (!r) {
            i = {
                ...i
            };
            r = !0;
        }
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            delete i[e];
        }
    }
    if (e.length > 0) {
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (s.has(ir(n.slice(15)))) {
                if (!r) {
                    i = {
                        ...i
                    };
                    r = !0;
                }
                delete i[n];
            }
        }
    }
    return i;
};

const lo = t => {
    if (t.startsWith("on") && t.endsWith("$")) {
        return ir(t.slice(2, -1));
    }
    if (t.startsWith("window:on") && t.endsWith("$")) {
        return ir(t.slice(9, -1));
    }
    if (t.startsWith("document:on") && t.endsWith("$")) {
        return ir(t.slice(11, -1));
    }
    return null;
};

const uo = (t, n, s, o, i = !1) => {
    let r = t;
    let c = i;
    for (let t = 0; t < n.length; t++) {
        const i = n[t];
        const l = lo(i);
        const u = e(i, o.has(l));
        if (u) {
            if (!c) {
                r = {
                    ...r
                };
                c = !0;
            }
            const t = s.get(u);
            (t === void 0 || t < s.get(i)) && (r[u] = r[i]);
            delete r[i];
        }
    }
    return r;
};

const co = (t, n, e, s, o, i, r) => new Gs(t, n, e, s, o, i, !1, r);

const fo = (t, n, e, s, o, i, r) => {
    let c = !1;
    let l = !1;
    let u = !1;
    let f = null;
    let a = null;
    if (typeof t === "string") {
        const t = new Set;
        const s = [];
        const o = [];
        const i = [];
        const r = [];
        const h = [];
        const d = [];
        const p = new Map;
        const $ = new Map;
        if (e) {
            let n = 0;
            for (const o in e) {
                p.set(o, n++);
                if (o.startsWith(io)) {
                    i.push(o);
                    t.add(ir(o.slice(8)));
                } else {
                    o.startsWith(ro) ? h.push(o) : lo(o) !== null ? s.push(o) : o === eo ? a = e[o] : o === no && (f = e[o]);
                }
            }
        }
        if (n) {
            let e = 0;
            for (const s in n) {
                $.set(s, e++);
                if (s.startsWith(io)) {
                    r.push(s);
                    t.add(ir(s.slice(8)));
                } else {
                    s.startsWith(ro) ? d.push(s) : lo(s) !== null ? o.push(s) : s === eo ? a = n[s] : s === no && (f = n[s]);
                }
            }
        }
        if (e) {
            const n = e;
            e = oo(e, i, h, t, l);
            l = l || e !== n;
            e = uo(e, s, p, t, l);
            l = l || e !== n;
        }
        if (n) {
            const e = n;
            n = oo(n, r, d, t, u);
            u = u || n !== e;
            n = uo(n, o, $, t, u);
            u = u || n !== e;
            c = c || o.length > 0;
        }
        if (a || f) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n ||= {};
            if (a) {
                n && so.call(n, eo) && delete n[eo];
                if (e && so.call(e, eo)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[eo];
                }
                n.checked = a;
                const t = la(null, "_chk", b, null, [ a ]);
                if (e && so.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ks(n, "q-e:input", t) || c;
                }
                c = Ks(n, "q-e:input", t) || c;
            } else if (f) {
                n && so.call(n, no) && delete n[no];
                if (e && so.call(e, no)) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    delete e[no];
                }
                n.value = f;
                const t = la(null, "_val", v, null, [ f ]);
                if (e && so.call(e, "q-e:input")) {
                    if (!l) {
                        e = {
                            ...e
                        };
                        l = !0;
                    }
                    const t = e["q-e:input"];
                    delete e["q-e:input"];
                    c = Ks(n, "q-e:input", t) || c;
                }
                c = Ks(n, "q-e:input", t) || c;
            }
        }
        if (n && so.call(n, "className")) {
            if (!u) {
                n = {
                    ...n
                };
                u = !0;
            }
            n.class = n.className;
            n.className = void 0;
            c = !0;
        }
        if (e && so.call(e, "className")) {
            if (!l) {
                e = {
                    ...e
                };
                l = !0;
            }
            e.class = e.className;
            e.className = void 0;
        }
    }
    if (n) {
        for (const t in n) {
            if (t === "children") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                s ||= n.children;
                delete n.children;
            } else if (t === "key") {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                i ||= n.key;
                delete n.key;
            } else if (e && t in e) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            } else if (n[t] === null) {
                if (!u) {
                    n = {
                        ...n
                    };
                    u = !0;
                }
                delete n[t];
            }
        }
    }
    return new Gs(t, n, e, s, o, i, c || !0, r);
};

const ao = (t, n, e, s) => yo(t, n, s);

const ho = (t, n, e, s, o) => yo(t, {
    ...e,
    ...n
}, o);

const po = (t, n, e, s, o, i) => yo(t, {
    ...e,
    ...n,
    children: s
}, i);

const $o = t => t.children;

const yo = (t, n, e, s, o) => fo(t, n, null, null, 0, e, o);

const mo = yo;

const wo = yo;

function g(t, n, ...e) {
    const s = {
        children: arguments.length > 2 ? e.flat(100) : null
    };
    let o = null;
    for (const t in n) {
        t == "key" ? o = n[t] : s[t] = n[t];
    }
    return fo(t, n, null, s.children, 0, o);
}

const vo = t => t.children;

const bo = (t, n) => new Gs($o, null, null, t.children, 0, n);

const _o = t => co($o, null, {
    [ci]: ""
}, t.children, 0, t.name ?? "");

const go = Symbol();

const So = () => null;

const Eo = () => null;

const ko = t => t.children;

const Ro = (t, n) => yo(bo, {
    children: yo(Po, t)
}, n);

const Po = () => null;

let To = null;

let qo = null;

function S(t, n, e, s) {
    if (e != null) {
        if (s) {
            const s = function o(t) {
                switch (t) {
                  case "xlink:href":
                  case "xlink:actuate":
                  case "xlink:arcrole":
                  case "xlink:role":
                  case "xlink:show":
                  case "xlink:title":
                  case "xlink:type":
                    return "http://www.w3.org/1999/xlink";

                  case "xml:base":
                  case "xml:lang":
                  case "xml:space":
                    return "http://www.w3.org/XML/1998/namespace";

                  default:
                    return null;
                }
            }(n);
            if (s) {
                ((t, n, e, s) => {
                    qo || (qo = t.setAttributeNS);
                    qo.call(t, n, e, s);
                })(t, s, n, e);
                return;
            }
        }
        ((t, n, e) => {
            To || (To = t.setAttribute);
            To.call(t, n, e);
        })(t, n, e);
    }
}

const Ao = Object.prototype.hasOwnProperty;

function E(t) {
    return !t.startsWith("q:") && !t.startsWith(":");
}

const Mo = (t, n = [], e = {}) => {
    let s = null;
    const o = t[ls];
    if (o) {
        for (const t in o) {
            if (!n.includes(t)) {
                s ||= {};
                s[t] = o[t];
            }
        }
    }
    const i = e;
    const r = t[us];
    for (const t in r) {
        n.includes(t) || (i[t] = r[t]);
    }
    return m(new Gs(null, i, s, null, 0, null));
};

function k(t, n, e) {
    const s = n.constProps;
    if (s && typeof s == "object" && Ao.call(s, "name")) {
        const n = s.name;
        if (t && n instanceof Js) {
            return Df(n, t, ":", e);
        }
    }
    return ws(n, "name") || "";
}

class xo {
    target;
    constructor(t) {
        this.target = t;
    }
}

class Io {
    target;
    constructor(t) {
        this.target = t;
    }
}

class No {
    target;
    text;
    constructor(t, n) {
        this.target = t;
        this.text = n;
    }
}

class Co {
    target;
    parent;
    beforeTarget;
    constructor(t, n, e) {
        this.target = t;
        this.parent = n;
        this.beforeTarget = e;
    }
}

class Oo {
    target;
    attrName;
    attrValue;
    scopedStyleIdPrefix;
    isSvg;
    constructor(t, n, e, s, o) {
        this.target = t;
        this.attrName = n;
        this.attrValue = e;
        this.scopedStyleIdPrefix = s;
        this.isSvg = o;
    }
}

const jo = t => new xo(t);

const Lo = t => new Io(t);

const Fo = (t, n) => new No(t, n);

const Do = (t, n, e) => new Co(t, n, e);

const Xo = (t, n, e, s = null, o = !1) => new Oo(t, n, e, s, o);

const Wo = () => {
    const t = Cf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Ci);
    if (s === null) {
        s = [];
        t.$.setHostProp(e, Ci, s);
    }
    let o = t.$.getHostProp(e, Oi);
    o === null && (o = 0);
    t.$.setHostProp(e, Oi, o + 1);
    for (;s.length <= o; ) {
        s.push(void 0);
    }
    return {
        val: s[o],
        set: t => s[o] = t,
        i: o,
        iCtx: t
    };
};

const Vo = t => {
    const n = Je(t) && !_a(t) ? qe(void 0, t) : t;
    return Fs(n);
};

const Uo = t => zo(Vo, t);

const zo = (t, ...n) => {
    const {val: e, set: s} = Wo();
    if (e != null) {
        return e;
    }
    t = Je(t) && !_a(t) ? jf(t, ...n) : t;
    return s(t);
};

function R(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = q(n);
    if (!e) {
        return;
    }
    const s = t.boundaries ||= [];
    if (!s.includes(e)) {
        s.push(e);
        e.value++;
    }
}

function P(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return bl(t, Vi, null) || null;
}

function T(t) {
    A(t, null);
}

function q(t) {
    if (!__EXPERIMENTAL__.suspense) {
        return null;
    }
    return bl(t, Ui, null) || P(t);
}

function A(t, n) {
    __EXPERIMENTAL__.suspense && _l(t, Ui, n);
}

function M(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    A(t, n);
    const e = t.dirtyChildren;
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const s = e[t];
        M(s, P(s) || n);
    }
}

const Bo = t => {
    if (t.an) {
        try {
            t.an();
        } catch (t) {
            Fe(t);
        }
        t.an = null;
    }
};

function x(t, e, s, o) {
    if (!s.isConnected) {
        return;
    }
    if (!o) {
        const n = Se(s);
        return qf(n, () => x(t, e, s, Of(e, s, n)));
    }
    const i = o.$;
    const r = o._;
    El(i, r);
    let c = t;
    if (r.flags & 64) {
        let n;
        if (!(r.flags & 128)) {
            n = !0;
            r.flags |= 128;
        }
        const o = n ? i.k : null;
        const l = bl(r, ji, o);
        if (l !== null) {
            c = () => t(e, s, l);
        } else {
            const n = bl(r, Li, o);
            n !== null && (c = () => t(e, s, ...n));
        }
    }
    return n(() => {
        if (!(r.flags & 32)) {
            return Ae(o, c, [ e, s ]);
        }
    }, t => i.handleError(t, r));
}

function I(t, n) {
    if (!n.isConnected) {
        return;
    }
    const e = Se(n);
    return qf(e, () => {
        const s = Of(t, n, e);
        typeof this === "string" && ea(ia(s.$, this));
        const o = na[0];
        return x(o, t, n, s);
    });
}

function N(t) {
    return t.R === t.T ? t.q : null;
}

function C(t) {
    return t.M || N(t);
}

function O(t, n) {
    const e = function s(t) {
        return t ? t.nextSibling : null;
    }(n);
    const o = N(t);
    return e === o ? null : e;
}

const Qo = Object.prototype.hasOwnProperty;

function j(t, n, e, s, o, i) {
    _l(n, e, i);
    mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
}

function L(t, n, e, s) {
    return {
        $: t,
        N: n,
        O: e,
        j: s,
        L: [],
        D: [],
        X: [],
        R: null,
        M: null,
        W: null,
        q: null,
        T: null,
        U: null,
        B: null,
        H: null,
        J: null,
        Y: null,
        G: 0,
        K: 0,
        Z: !0,
        tt: !1,
        nt: {
            et: new Ys({
                j: s,
                it: !0
            }),
            rt: new Ys({
                j: s,
                it: !1
            })
        }
    };
}

function F(t, n, e, s, o) {
    const i = t ?? L(n, e, s, o);
    (function r(t, n, e, s, o) {
        t.$ = n;
        t.N = e;
        t.O = s;
        t.j = o;
        t.nt.et.data.j = o;
        t.nt.rt.data.j = o;
        t.D.length = 0;
        t.X.length = 0;
    })(i, n, e, s, o);
    return i;
}

const Ho = (t, n, e, s, o, i, r) => D(F(r, t, n, o, i), e, s);

const Jo = (t, n, e, s, o, i, r, c, l = !1, u) => D(F(u, t, n, r, c), e, s, o, i, l);

function D(t, n, e, s = Jl(e), o = null, i = !1) {
    X(t, n, e, s, o, i);
    const r = G(t);
    if (Ji(r)) {
        return r.finally(() => {
            K(t);
        });
    }
    K(t);
}

function X(t, n, e, s = Jl(e), o = null, i = !1) {
    const r = t.tt;
    t.tt = i || r;
    t.R = e;
    t.W = null;
    t.M = s;
    t.q = o;
    t.T = e;
    B(t, n, !0);
    try {
        if (t.R.flags & 32) {
            return;
        }
        for (;t.L.length; ) {
            for (;t.G < t.K; ) {
                if (typeof t.Y === "string") {
                    mt(t, t.Y);
                } else if (typeof t.Y === "number") {
                    mt(t, t.Y + "");
                } else if (t.Y && typeof t.Y === "object") {
                    if (Zs(t.Y)) {
                        const n = t.Y.type;
                        if (typeof n === "string") {
                            nt(t);
                            ct(t, t.Y, n);
                            const e = t.Y.constProps && Qo.call(t.Y.constProps, Bi) || Qo.call(t.Y.varProps, Bi);
                            e ? t.W || Z(t, !1) : U(t, t.Y.children, !0);
                        } else if (typeof n === "function") {
                            if (n === vo) {
                                nt(t);
                                dt(t, "F", t.Y.key);
                                U(t, t.Y.children, !0);
                            } else if (n === _o) {
                                nt(t);
                                J(t) || U(t, t.Y.children, !0);
                            } else if (n === bt) {
                                H(t);
                                U(t, t.Y.children, !0, !0);
                            } else if (n === Eo) {
                                tt(t);
                            } else if (n === So) {
                                tt(t);
                            } else {
                                nt(t);
                                pt(t, n);
                            }
                        }
                    } else if (Array.isArray(t.Y)) {
                        U(t, t.Y, !1);
                    } else if (Tu(t.Y)) {
                        dt(t, "S", null);
                        const n = t.Y instanceof Js ? t.Y.st() : t.Y;
                        const e = t.M?.[Vr]?.get(".")?.backRef;
                        let s = e?.has(n);
                        e && n instanceof Js && (s = xt(e, n));
                        if (!s) {
                            const e = t.W || t.M;
                            U(t, W(t, () => Df(n, e, ".", t.$)), !0);
                        }
                    } else if (Ji(t.Y)) {
                        dt(t, "A", null);
                        t.D.push(t.Y, t.W || t.M);
                    }
                } else {
                    t.Y === go || mt(t, "");
                }
                V(t);
            }
            tt(t);
            Y(t);
            z(t);
        }
    } finally {
        t.tt = r;
    }
}

function W(t, e) {
    try {
        return e();
    } catch (s) {
        if (Ji(s)) {
            const o = s.then(() => n(e));
            t.D.push(o, t.W || t.M);
            return null;
        }
        throw s;
    }
}

function V(t) {
    if (!t.Z) {
        t.Z = !0;
        return;
    }
    t.G++;
    if (t.G < t.K) {
        t.Y = t.J[t.G];
    } else if (t.L.length > 0 && t.L[t.L.length - 1] === !1) {
        return z(t);
    }
    t.W !== null ? t.W = null : t.M = O(t, t.M);
}

function U(t, n, e, s = !1) {
    if (!s && (n == null || e && Qe(n) && n.length === 0)) {
        Z(t);
        return;
    }
    B(t, n, e);
    if (e) {
        const n = !s && t.tt || !!t.W || !Jl(t.M);
        t.tt = n;
        t.H = null;
        t.U = null;
        t.B = null;
        t.R = t.W || t.M;
        t.M = Jl(t.R);
        t.W = null;
    }
    t.Z = !1;
}

function z(t) {
    const n = t.L.pop();
    if (n) {
        t.tt = t.L.pop();
        t.H = t.L.pop();
        t.U = t.L.pop();
        t.B = t.L.pop();
        t.W = t.L.pop();
        t.M = t.L.pop();
        t.R = t.L.pop();
    }
    t.Y = t.L.pop();
    t.K = t.L.pop();
    t.G = t.L.pop();
    t.J = t.L.pop();
    V(t);
}

function B(t, n, e) {
    t.L.push(t.J, t.G, t.K, t.Y);
    e && t.L.push(t.R, t.M, t.W, t.B, t.U, t.H, t.tt);
    t.L.push(e);
    if (Array.isArray(n)) {
        t.G = 0;
        t.K = n.length;
        t.J = n;
        t.Y = t.K > 0 ? n[0] : null;
    } else if (n === void 0) {
        t.G = 0;
        t.Y = null;
        t.J = null;
        t.K = 0;
    } else {
        t.G = 0;
        t.Y = n;
        t.J = null;
        t.K = 1;
    }
}

function Q(t) {
    if (t.W) {
        return C(t);
    }
    return O(t, t.M) || N(t);
}

function H(t) {
    const n = t.Y;
    const e = n.key;
    t.M = bl(t.R, e, n => Tl(t.$.rootVNode, n));
    t.M = t.M && t.M.flags & 32 ? null : t.M;
    if (t.M == null) {
        t.W = hl();
        _l(t.W, ui, e);
        t.W.slotParent = t.R;
        _l(t.R, e, t.W);
    }
}

function J(t) {
    const n = t.Y;
    const e = gu(t.R);
    const s = k(e, n, t.$);
    const o = ws(n, Vi) || null;
    const i = e ? bl(e, s, null) : null;
    if (i == null) {
        t.W = hl();
        _l(t.W, ui, s);
        _l(t.W, Vi, o);
        M(t.W, o);
        e && _l(e, s, t.W);
        Xl(t.N, t.R, t.W, Q(t));
        return !1;
    }
    if (i === t.M) {} else {
        const n = i.parent;
        t.W = i;
        _l(t.W, ui, s);
        _l(t.W, Vi, o);
        M(t.W, o);
        e && _l(e, s, t.W);
        Dl(t.N, t.W);
        Xl(t.N, t.R, t.W, Q(t));
        n && pl(n) && !n.firstChild && Bl(n) === Ri && Ul(t.N, n.parent, n, !0);
    }
    return !0;
}

function Y(t) {
    const n = t.H;
    if (n) {
        for (const e of n.values()) {
            if (e.flags & 32) {
                continue;
            }
            St(t.$, t.N, e, t.O);
            Ul(t.N, t.R, e, !0);
        }
        n.clear();
        t.H = null;
    }
    t.M = null;
}

function G(t) {
    for (;t.D.length; ) {
        const n = t.D.shift();
        const e = t.D.shift();
        if (Ji(n)) {
            return n.then(n => {
                X(t, n, e);
                return G(t);
            }).catch(n => {
                t.$.handleError(n, e);
                return G(t);
            });
        }
        X(t, n, e);
    }
    if (t.X.length) {
        const n = t.X.splice(0);
        return Promise.all(n).then(() => G(t));
    }
}

function K(t) {
    t.N = null;
    t.O = null;
}

function Z(t, n = !0) {
    const e = t.M && Jl(t.M);
    if (e !== null) {
        let s = e;
        for (;s; ) {
            St(t.$, t.N, s, t.O);
            s = s.nextSibling;
        }
        zl(t.N, t.M, e, n);
    }
}

function tt(t) {
    const n = N(t);
    if (t.M !== null && t.M !== n) {
        for (;t.M && t.M !== n; ) {
            const n = t.M;
            t.M = O(t, t.M);
            if (t.R === n.parent) {
                St(t.$, t.N, n, t.O);
                Ul(t.N, t.R, n, !0);
            }
        }
    }
}

function nt(t) {
    if (t.M !== null && ml(t.M)) {
        const n = t.M;
        t.M = O(t, t.M);
        Ul(t.N, t.R, n, !0);
    }
}

function et(t, n, e) {
    if (Tu(t)) {
        t.value = n;
        return !0;
    }
    if (typeof t === "function") {
        t(n);
        return !0;
    }
    if (t == null) {
        return !0;
    }
    throw Ye(15, [ e ]);
}

function it(t, e, s, o, i) {
    return n(() => Df(o, e, s, t, i));
}

function rt(t, n, e, s, o) {
    const r = t.j;
    const c = s.then(t => S(n, e, i(e, t, r), o));
    t.X.push(c);
}

function st(t, n) {
    if (n) {
        t.innerHTML = n + "";
        t.setAttribute(Ei, "html");
    }
}

function ot(t, n) {
    if (n && typeof n !== "string") {
        return !0;
    }
    t.value = function e(t) {
        let n = "";
        const e = t.length;
        let s = 0;
        let o = s;
        for (;s < e; s++) {
            const e = t.charCodeAt(s);
            if (e === 60) {
                n += t.substring(o, s) + "&lt;";
            } else if (e === 62) {
                n += t.substring(o, s) + "&gt;";
            } else if (e === 38) {
                n += t.substring(o, s) + "&amp;";
            } else if (e === 34) {
                n += t.substring(o, s) + "&quot;";
            } else {
                if (e !== 39) {
                    continue;
                }
                n += t.substring(o, s) + "&#39;";
            }
            o = s + 1;
        }
        return o === 0 ? t : n + t.substring(o);
    }(n || "");
    return !0;
}

function lt(t, n, e, s) {
    const r = function c(t, n) {
        const e = Vl(t.R, !0);
        const s = o(e, n);
        const i = document;
        const r = s.elementNamespaceFlag === 0 ? i.createElement(n) : i.createElementNS(s.elementNamespace, n);
        t.W = cl(r, n);
        t.W.flags |= s.elementNamespaceFlag;
        return r;
    }(t, e);
    const l = t.W;
    const u = (l.flags & 512) !== 0;
    const {constProps: f} = n;
    if (f) {
        for (const n in f) {
            let o = f[n];
            if (er(n)) {
                ut(n, o, r, l, t);
                continue;
            }
            if (n === "ref" && et(o, r, s)) {
                continue;
            }
            Tu(o) && (o = it(t.$, t.W, n, o, t.nt.et));
            if (Ji(o)) {
                rt(t, r, n, o, u);
                continue;
            }
            if (n === Bi) {
                st(r, o);
                continue;
            }
            if (e === "textarea" && n === "value" && ot(r, o)) {
                continue;
            }
            S(r, n, i(n, o, t.j), u);
        }
    }
    const a = n.key;
    a && (t.W.key = a);
    if (t.j) {
        const e = Qo.call(n.varProps, "class") || n.constProps && Qo.call(n.constProps, "class");
        e || r.setAttribute("class", t.j);
    }
    Cl(t.N, t.R, t.W, C(t));
}

function ut(t, n, e, s, o) {
    const i = t.slice(2);
    if (Array.isArray(n)) {
        const t = n;
        const s = [];
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            if (Array.isArray(e)) {
                for (let t = 0; t < e.length; t++) {
                    const n = e[t];
                    n && s.push(x.bind(null, n));
                }
            } else {
                e && s.push(x.bind(null, e));
            }
        }
        s.length > 0 && ((e._qDispatch ||= {})[i] = s.length === 1 ? s[0] : s);
    } else {
        n && ((e._qDispatch ||= {})[i] = x.bind(null, n));
    }
    t.charAt(2) !== "e" && gl(o.N, s, t, "");
    (function r(t, n) {
        const e = window;
        e && (e._qwikEv ||= []).push(n);
    })(0, i);
}

function ct(t, n, e) {
    if (t.tt) {
        lt(t, n, e, null);
    } else {
        const s = t.M && pl(t.M);
        const o = s && e === Bl(t.M);
        const i = n.key;
        const r = s && t.M.key;
        if (o && i === r) {
            at(t, e, i);
        } else {
            const s = ft(e, i);
            ht(t, e, i, s, t.R) && lt(t, n, e, null);
        }
    }
    const s = n.varProps;
    const o = t.W || t.M;
    s && function i(t, n, e, s) {
        t.tt || El(t.$, n);
        const o = n.props;
        const i = (n.flags & 1536) === 0;
        for (const r in e) {
            const c = e[r];
            const l = o && i && !Qo.call(o, r) ? r.toLowerCase() : r;
            if (o && Qo.call(o, l)) {
                const e = o[l];
                if (l !== r) {
                    _l(n, l, null);
                    _l(n, r, e);
                }
                Pt(c, e) || Yo(t, n, r, c, s);
            } else {
                c != null && Yo(t, n, r, c, s);
            }
        }
        if (o) {
            for (const i in o) {
                Qo.call(e, i) || i.charAt(0) === ":" || er(i) || Yo(t, n, i, null, s);
            }
        }
    }(t, o, s, null);
}

const Yo = (t, n, e, s, o) => {
    if (er(e)) {
        ut(e, s, n.node, n, t);
        return;
    }
    if (e === ji || e === Li) {
        _l(n, e, s);
        n.flags |= 192;
        return;
    }
    const i = s;
    if (e === "ref") {
        const t = n.node;
        if (et(s, t, o)) {
            return;
        }
    }
    const r = n[Vr]?.get(e);
    if (Tu(s)) {
        const o = s instanceof Js ? s.st() : s;
        if (r?.backRef?.has(o)) {
            return;
        }
        r && Rn(t.$, r);
        const i = n;
        s = it(t.$, i, e, o, t.nt.rt);
    } else {
        r && Rn(t.$, r);
    }
    if (Ji(s)) {
        const o = n;
        const r = s.then(n => {
            j(t.N, o, e, n, t.j, i);
        });
        t.X.push(r);
        return;
    }
    j(t.N, n, e, s, t.j, i);
};

function ft(t, n) {
    if (n == null) {
        return null;
    }
    return t ? t + ":" + n : n;
}

function at(t, n, e) {
    const s = ft(n, e);
    if (s && t.H?.has(s)) {
        t.H.delete(s);
        return !0;
    }
    return !1;
}

function ht(t, n, e, s, o, i) {
    t.W = function r(t, n, e) {
        let s = null;
        if (t.U === null) {
            const o = t.M;
            if (o) {
                const s = pl(o) ? Bl(o) : null;
                const i = wt(o) || vt(o, t.$.k);
                if (i === e && s === n) {
                    return o;
                }
            }
            t.U = new Map;
            t.B = [];
            const i = N(t);
            let r = t.M;
            for (;r && r !== i; ) {
                const o = pl(r) ? Bl(r) : null;
                const i = wt(r) || vt(r, t.$.k);
                s === null && i == e && o == n ? s = r : i === null ? t.B.push(o, r) : t.U.set(ft(o, i), r);
                r = r.nextSibling;
            }
        } else if (e === null) {
            for (let e = 0; e < t.B.length; e += 2) {
                if (t.B[e] === n) {
                    s = t.B[e + 1];
                    t.B.splice(e, 2);
                    break;
                }
            }
        } else {
            const o = ft(n, e);
            const i = t.U.get(o);
            if (i) {
                s = i;
                t.U.delete(o);
            }
        }
        (function o(t, n) {
            if (!n) {
                if (t.M) {
                    const n = pl(t.M) ? Bl(t.M) : null;
                    const e = wt(t.M) || vt(t.M, t.$.k);
                    if (e != null) {
                        const s = ft(n, e);
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                        t.U?.delete(s);
                    }
                }
                return;
            }
            const e = N(t);
            let s = t.M;
            for (;s && s !== n && s !== e; ) {
                const n = pl(s) ? Bl(s) : null;
                const e = wt(s) || vt(s, t.$.k);
                if (e != null) {
                    const o = ft(n, e);
                    t.H ||= new Map;
                    t.H.set(o, s);
                    t.U?.delete(o);
                }
                s = s.nextSibling;
            }
        })(t, s);
        return s;
    }(t, n, e);
    if (t.W) {
        s || Xl(t.N, o, t.W, C(t));
        t.M = t.W;
        t.W = null;
        return !1;
    }
    if (s != null) {
        const n = t.H?.get(s) || null;
        if (n) {
            t.H.delete(s);
            if (i && t.M) {
                const n = wt(t.M) || vt(t.M, t.$.k);
                if (n != null) {
                    const e = pl(t.M) ? Bl(t.M) : null;
                    const s = ft(e, n);
                    if (s != null) {
                        t.H ||= new Map;
                        t.H.set(s, t.M);
                    }
                }
            }
            n !== t.M && Xl(t.N, o, n, C(t));
            t.M = n;
            t.W = null;
            return !1;
        }
    }
    return !0;
}

function dt(t, n, e) {
    const s = n === "F";
    const o = wt(t.M);
    const i = t.M && wl(t.M);
    const r = i && o === e && (!s || !!e);
    if (r) {
        at(t, null, o);
        return;
    }
    if (e === null || t.tt) {
        Ol(t.N, t.R, t.W = hl(), Q(t));
        t.W.key = e;
        return;
    }
    if (ht(t, null, e, ft(null, e), t.R, !0)) {
        Ol(t.N, t.R, t.W = hl(), Q(t));
        t.W.key = e;
    }
}

function pt(t, n) {
    const e = n[ba];
    let s = t.W || t.M;
    const o = t.Y;
    if (e) {
        const n = o.props;
        let i = !1;
        const [r] = e;
        const c = r.ot;
        const l = vt(s, t.$.k);
        const u = o.key || c;
        const f = wt(s) || l;
        const a = u === f;
        const h = c === l;
        if (a) {
            if (h) {
                at(t, null, u);
            } else {
                $t(t, s, r, n);
                s = t.W;
                i = !0;
            }
        } else {
            if (ht(t, null, u, u, t.R)) {
                $t(t, s, r, n);
                i = !0;
            }
            s = t.W || t.M;
        }
        if (s) {
            const e = bl(s, Ni, t.$.k);
            if (!i) {
                const c = function l(t, n, e, s) {
                    let o = !1;
                    if (e) {
                        const t = _t(n[ls], e[ls], e[fs], s, !1);
                        o ||= t;
                        const i = _t(n[us], e[us], e[fs], s, !0);
                        o ||= i;
                        e[cs] = n[cs];
                    } else if (n) {
                        _l(t, Ni, n);
                        e = n;
                    }
                    return o;
                }(s, n, e, t.$);
                if (c && o.key == null) {
                    $t(t, s, r, n);
                    s = t.W;
                    i = !0;
                }
                i ||= c;
            }
            if (i) {
                _l(s, si, r);
                s.flags &= -33;
                yn(t.$, s, 4, t.O);
            }
        }
        (function d(t, n, e) {
            const s = Array.isArray(n) ? n : [ n ];
            const o = t => new Gs(bt, null, null, [], 0, t);
            const i = [];
            if (e) {
                const t = e.props;
                if (t) {
                    for (const n in t) {
                        if (E(n)) {
                            const t = n;
                            We(i, t, o(t), 0);
                        }
                    }
                }
            }
            if (i.length === 0 && n == null) {
                return;
            }
            for (let t = 0; t < s.length; t++) {
                const n = s[t];
                const e = (Zs(n) && ws(n, ui) || "") + "";
                const r = Xe(i, e, 0);
                let c;
                r >= 0 ? c = i[r + 1] : i.splice(~r, 0, e, c = o(e));
                const l = n === !1;
                l || c.children.push(n);
            }
            for (let t = i.length - 2; t >= 0; t -= 2) {
                i.splice(t, 1);
            }
            U(t, i, !0);
        })(t, o.children, s);
    } else {
        const e = o.key;
        const i = wt(s);
        const r = e === i;
        const c = vt(s, t.$.k);
        const l = c == null;
        if (s && !l || !s) {
            yt(t);
            s = t.W;
        } else if (r) {
            at(t, null, e);
        } else {
            ht(t, null, e, e, t.R) && yt(t);
            s = t.W || t.M;
        }
        if (s) {
            let e = s;
            for (;e && (!wl(e) || bl(e, si, null) === null); ) {
                e = e.parent || gu(e);
            }
            (function i(t, n, e, s) {
                const o = t.props ||= {};
                o[os] = {
                    componentFn: n,
                    subscriptionHost: e,
                    props: s
                };
            })(s, n, e, o.props);
            yn(t.$, s, 8, t.O);
        }
    }
}

function $t(t, n, e, s) {
    n && kn(t.$, n);
    Ol(t.N, t.R, t.W = hl(), Q(t));
    const o = t.Y;
    _l(t.W, si, e);
    _l(t.W, Ni, s);
    t.W.key = o.key;
}

function yt(t) {
    Ol(t.N, t.R, t.W = hl(), Q(t));
    const n = t.Y;
    _l(t.W, Ni, n.props);
    n.key && (t.W.key = n.key);
}

function mt(t, n) {
    if (t.M !== null) {
        const e = bu(t.M);
        if (e === 3) {
            if (n !== Ql(t.M)) {
                Hl(t.N, t.M, n);
                return;
            }
            return;
        }
    }
    Cl(t.N, t.R, t.W = al(document.createTextNode(n), n), C(t));
}

function wt(t) {
    if (t == null || ml(t)) {
        return null;
    }
    return t.key;
}

function vt(t, n) {
    if (t == null || ml(t)) {
        return null;
    }
    const e = bl(t, si, n);
    return e ? e.ot : null;
}

function bt() {}

function _t(t, n, e, s, o = !0) {
    if (gt(t) && gt(n)) {
        return !1;
    }
    e.$ = s;
    let i = !1;
    if (t) {
        for (const s in t) {
            if (s === "children" || s === mi) {
                continue;
            }
            const r = t[s];
            const c = n?.[s];
            if (!n || !Pt(r, c) && !Tt(r, c)) {
                if (s === "class") {
                    if (At(r, c)) {
                        continue;
                    }
                } else if (s === "style" && qt(r, c)) {
                    continue;
                }
                if (!o) {
                    return !0;
                }
                {
                    n && (n[s] = r);
                    const t = ms(e, s);
                    t || (i = !0);
                }
            }
        }
    }
    if (n) {
        for (const s in n) {
            if (s === "children" || s === mi) {
                continue;
            }
            if ((!t || !Qo.call(t, s)) && o) {
                delete n[s];
                const t = ms(e, s);
                t || (i = !0);
            }
        }
    }
    return i;
}

function gt(t) {
    if (!t) {
        return !0;
    }
    return Cr(t);
}

function St(t, n, e, s = null) {
    let o = e;
    const i = s && dn(s) ? y(s) : null;
    if (ml(e)) {
        Rt(o);
        return;
    }
    let r = null;
    for (;;) {
        i && o !== s && dn(o) && a(t, i, o);
        const c = o.flags;
        if (c & 3) {
            kn(t, o);
            Rt(o);
            const i = c & 2 && bl(o, si, null) !== null;
            if (i) {
                const e = t.getHostProp(o, Ci);
                if (e) {
                    for (let n = 0; n < e.length; n++) {
                        const i = e[n];
                        if (Be(i)) {
                            const n = Ru(i);
                            if (n && i.h & 1) {
                                i.h |= 16;
                                yn(t, o, 128, s);
                                continue;
                            }
                            (i instanceof Ms || i instanceof Js) && (i.h & 4 || kn(t, i));
                            (n || i instanceof Ms && (i.h & 512 || i.lt)) && Bo(i);
                        }
                    }
                }
                const i = o.props;
                if (i) {
                    const e = Object.keys(i);
                    for (let o = 0; o < e.length; o++) {
                        const r = e[o];
                        if (E(r)) {
                            const e = i[r];
                            if (e) {
                                i[r] = null;
                                const o = typeof e === "string" ? Tl(t.rootVNode, e) : e;
                                let c = Jl(o);
                                for (;c; ) {
                                    St(t, n, c, s);
                                    c = c.nextSibling;
                                }
                                kt(t, n, o);
                            }
                        }
                    }
                }
            }
            const r = vl(o);
            if (r) {
                if (o === e) {
                    const n = Jl(o);
                    if (n) {
                        bn(n);
                        return;
                    }
                    Et(t, o);
                }
            } else {
                const t = Jl(o);
                if (t) {
                    o = t;
                    continue;
                }
            }
        } else {
            c & 4 && Rt(o);
        }
        if (o === e) {
            return;
        }
        const l = o.nextSibling;
        if (l) {
            o = l;
            continue;
        }
        r = o.parent;
        for (;r; ) {
            if (r === e) {
                return;
            }
            const t = r.nextSibling;
            if (t) {
                o = t;
                break;
            }
            r = r.parent;
        }
        if (r == null) {
            return;
        }
    }
}

function Et(t, n) {
    if (!n.slotParent) {
        return;
    }
    const e = t.getHostProp(n, ui);
    e != null && t.getHostProp(n.slotParent, e) === n && _l(n.slotParent, e, null);
}

function kt(t, n, e) {
    const s = e.parent;
    if (s) {
        const o = s.flags;
        if (o & 1 && Bl(s) === Ri) {
            Et(t, e);
            Ul(n, s, e, !0);
        }
    }
}

function Rt(t) {
    t.flags |= 32;
}

function Pt(t, n) {
    if (t === n) {
        return !0;
    }
    return t instanceof Js && n instanceof Js && Mt(n, t);
}

function Tt(t, n) {
    if (t === n) {
        return !0;
    }
    if (Tu(t) && Tu(n)) {
        const e = t instanceof Js ? t.st() : t;
        const s = n instanceof Js ? n.st() : n;
        return jf(() => e.value === s.value);
    }
    return !1;
}

function qt(t, n) {
    if (t === n) {
        return !0;
    }
    return fr(t) === fr(n);
}

function At(t, n) {
    if (t === n) {
        return !0;
    }
    return ur(t) === ur(n);
}

function Mt(t, n) {
    if (t === n) {
        return !0;
    }
    return n.ut === t.ut && function e(t, n) {
        if (t === n) {
            return !0;
        }
        if (!t || !n || t.length !== n.length) {
            return !1;
        }
        for (let e = 0; e < t.length; e++) {
            if (t[e] !== n[e]) {
                return !1;
            }
        }
        return !0;
    }(n.ct, t.ct);
}

function xt(t, n) {
    if (!(n instanceof Js)) {
        return !1;
    }
    for (let e = 0; e < t.length; e++) {
        const s = t[e];
        if (s instanceof Js && Mt(s, n)) {
            return !0;
        }
    }
    return !1;
}

const Go = (t, n, e, s, o) => {
    const i = Me(t.sn, n, t);
    if (e) {
        i.un = w(e, ":");
        i.$ = t;
    }
    let r;
    t.ensureProjectionResolved(n);
    let c = !1;
    s === null && (s = t.getHostProp(n, si));
    if (Ke(s)) {
        o = o || t.getHostProp(n, Ni) || ps;
        "children" in o && delete o.children;
        r = s.getFn(i);
    } else if (_a(s)) {
        const t = s;
        r = () => Ae(i, t, [ o || ps, null, 0 ]);
    } else {
        c = !0;
        const t = s;
        r = () => Ae(i, t, [ o || ps ]);
    }
    const l = Ce;
    const u = (e = 0) => Yi(() => {
        if (!c) {
            t.setHostProp(n, Oi, null);
            t.setHostProp(n, Xi, null);
        }
        e > 0 && dl(n) && kn(t, n);
        return Gi(r(o), t => Gi(i.cn, () => t));
    }, s => {
        if (l && !c) {
            const t = n;
            if (t.dirty & 4) {
                t.dirty &= -5;
                if (e < Hi) {
                    return u(e + 1);
                }
            }
        }
        const o = t.getHostProp(n, Di);
        if (o) {
            return function i(t, n, e) {
                const s = Ot(n);
                let o = n;
                const i = "q-e:qvisible";
                return Gi(s, n => {
                    const s = !n;
                    let r = null;
                    for (const c in e) {
                        if (Object.prototype.hasOwnProperty.call(e, c)) {
                            let l = n;
                            let u = c;
                            if (s) {
                                if (c !== i && !c.startsWith("q-d:") && !c.startsWith("q-w:")) {
                                    continue;
                                }
                                if (!r) {
                                    r = Lt();
                                    const n = Ce;
                                    n && t.ft(r) || (o = jt(o, r));
                                }
                                l = r;
                            }
                            if (l) {
                                l.type === "script" && c === i && (u = "q-d:qinit");
                                Nt(l, u, e[c]);
                            }
                        }
                    }
                    return o;
                });
            }(t, s, o);
        }
        return s;
    }, t => {
        if (Ji(t) && e < Hi) {
            return t.then(() => u(++e));
        }
        if (e >= Hi) {
            throw Error("Max retry count of component execution reached");
        }
        throw t;
    });
    return u();
};

function Nt(t, n, e) {
    const s = t.constProps ||= {};
    const o = s[n];
    const i = e.qrls;
    o == null ? s[n] = i : Array.isArray(o) ? o.push(...i) : s[n] = [ o, ...i ];
    const r = t.varProps[n];
    if (r) {
        Array.isArray(o) ? o.push(...s[n]) : t.varProps[n] = [ o, ...i ];
        s[n] = void 0;
    }
    const c = e.capture;
    const l = e.preventdefault;
    const u = e.stoppropagation;
    if (!c && !l && !u) {
        return;
    }
    const [, f] = sr(n);
    c && Ct(t, f, "capture");
    l && Ct(t, f, "preventdefault");
    u && Ct(t, f, "stoppropagation");
}

function Ct(t, n, e) {
    const s = `${e}:${n}`;
    const o = t.varProps;
    o === ps && (t.varProps = {});
    t.varProps[s] = !0;
}

function Ot(t) {
    const n = [ t ];
    for (;n.length; ) {
        const t = n.shift();
        if (Zs(t)) {
            if (typeof t.type === "string") {
                return t;
            }
            n.push(t.children);
        } else if (Qe(t)) {
            n.push(...t);
        } else {
            if (Ji(t)) {
                return Gi(t, t => Ot(t));
            }
            if (Tu(t)) {
                return Ot(t.untrackedValue);
            }
        }
    }
    return null;
}

function jt(t, n) {
    if (Zs(t)) {
        if (t.type !== vo) {
            return co(vo, null, null, [ t, n ], 0, null);
        }
        t.children == null ? t.children = n : Qe(t.children) ? t.children.push(n) : t.children = [ t.children, n ];
        return t;
    }
    if ((t => typeof t !== "object" && typeof t !== "function" || t === null || t === void 0)(t)) {
        return co(vo, null, null, [ t, n ], 0, null);
    }
    if (Qe(t) && t.length > 0) {
        jt(t[0], n);
        return t;
    }
    return t;
}

function Lt() {
    return new Gs("script", null, {
        hidden: ""
    }, null, 0, null);
}

function Ft(t, n, e, s) {
    const o = s(t, n);
    o.key = e;
    return o;
}

function Dt(t, n, e, s, o, i) {
    const r = Array(i - o + 1);
    for (let c = o; c <= i; c++) {
        const i = n[c] ?? (n[c] = e(t[c], c));
        r[c - o] = Ft(t[c], c, i, s);
    }
    return r;
}

function Xt(t, n, e) {
    let s = n ? n.previousSibling : t.lastChild;
    for (let t = 1; t < e && s; t++) {
        s = s.previousSibling;
    }
    return s;
}

function Wt(t, n, e, s, o, i, r) {
    const c = t;
    const l = o.length;
    const u = Jl(e);
    const f = L(c, n, s, null);
    const a = Array(l);
    if (u === null) {
        if (l > 0) {
            return Jo(c, n, Dt(o, a, i, r, 0, l - 1), e, null, null, s, null, !0, f);
        }
        return;
    }
    if (l === 0) {
        zl(n, e, u, !0);
        return;
    }
    let h = 0;
    let d = l - 1;
    let p = u;
    for (;p && h <= d && p.key === (a[h] ??= i(o[h], h)); ) {
        p = p.nextSibling;
        h++;
    }
    if (p === null) {
        if (h > d) {
            return;
        }
        return Jo(c, n, Dt(o, a, i, r, h, d), e, null, null, s, null, !0, f);
    }
    if (h > d) {
        zl(n, e, p, !0);
        return;
    }
    const $ = p.previousSibling;
    let y = e.lastChild;
    for (;y !== $ && d >= h && y.key === (a[d] ??= i(o[d], d)); ) {
        y = y.previousSibling;
        d--;
    }
    const w = y ? y.nextSibling : p;
    if (h > d) {
        let t = p;
        for (;t && t !== w; ) {
            const s = t.nextSibling;
            Ul(n, e, t, !0);
            t = s;
        }
        return;
    }
    if (y === $) {
        const t = w;
        return Jo(c, n, Dt(o, a, i, r, h, d), e, t, t, s, null, !0, f);
    }
    for (let t = h; t <= d; t++) {
        a[t] ??= i(o[t], t);
    }
    const m = d - h + 1;
    const b = new Map;
    for (let t = h; t <= d; t++) {
        b.set(a[t], t - h);
    }
    const v = function _(t, n = null) {
        const e = [];
        let s = t;
        for (;s; ) {
            e.push(s);
            if (s === n) {
                break;
            }
            s = s.nextSibling;
        }
        return e;
    }(p, y);
    const g = [];
    const S = new Map;
    for (let t = 0; t < v.length; t++) {
        const s = v[t];
        const o = s.key;
        if (b.has(o)) {
            S.set(o, g.length);
            g.push(s);
        } else {
            Ul(n, e, s, !0);
        }
    }
    const E = new Int32Array(m);
    E.fill(-1);
    const k = [];
    const R = [];
    for (let t = 0; t < m; t++) {
        const n = S.get(a[h + t]);
        if (n !== void 0) {
            E[t] = n;
            R.push(t);
            k.push(n);
        }
    }
    const P = new Uint8Array(m);
    const q = function T(t) {
        const n = t.length;
        if (n === 0) {
            return [];
        }
        const e = [];
        const s = Array(n).fill(-1);
        for (let o = 0; o < n; o++) {
            const n = t[o];
            let i = 0;
            let r = e.length;
            for (;i < r; ) {
                const s = i + r >> 1;
                t[e[s]] < n ? i = s + 1 : r = s;
            }
            i > 0 && (s[o] = e[i - 1]);
            i === e.length ? e.push(o) : e[i] = o;
        }
        const o = [];
        let i = e[e.length - 1];
        for (;i !== -1; ) {
            o.push(i);
            i = s[i];
        }
        o.reverse();
        return o;
    }(k);
    for (let t = 0; t < q.length; t++) {
        P[R[q[t]]] = 1;
    }
    let M = d;
    let A = w;
    const x = () => {
        for (;M >= h; ) {
            const t = M - h;
            if (P[t] === 1) {
                A = g[E[t]];
                M--;
                continue;
            }
            const i = E[t];
            if (i !== -1) {
                const t = g[i];
                const s = A === null ? e.lastChild === t : t.nextSibling === A;
                s || Xl(n, e, t, A);
                A = t;
                M--;
                continue;
            }
            let l = M;
            for (;l > h; ) {
                const t = l - 1 - h;
                if (P[t] === 1 || E[t] !== -1) {
                    break;
                }
                l--;
            }
            const u = M - l + 1;
            const d = Jo(c, n, Dt(o, a, null, r, l, M), e, A, A, s, null, !0, f);
            return Gi(d, () => {
                const t = Xt(e, A, u);
                A = t;
                M = l - 1;
                return x();
            });
        }
    };
    return x();
}

function Vt(t, n, e) {
    t.dirty &= -2;
    const s = n.getHostProp(t, Ci);
    if (!s || s.length === 0) {
        return;
    }
    let o;
    for (let i = 0; i < s.length; i++) {
        const r = s[i];
        if (r instanceof ku) {
            const s = r;
            if (!(s.h & 4)) {
                continue;
            }
            if (s.h & 1) {
                (e.afterFlushTasks ||= []).push(s);
            } else {
                const i = !!(s.h & 8);
                const r = Eu(s, n, t);
                Ji(r) && (i ? o = o ? o.then(() => r) : r : (e.extraPromises ||= []).push(r));
            }
        }
    }
    return o;
}

function Ut(t, n) {
    const e = t.props ||= {};
    e[is] = n;
}

function zt(t, n) {
    t.dirty &= -513;
    const e = function s(t) {
        const n = t.props;
        return n?.[rs] ?? null;
    }(t);
    if (!e) {
        return;
    }
    (function o(t, n) {
        const e = t.props ||= {};
        e[rs] = n;
    })(t, null);
    const i = t;
    const r = i.parent;
    const c = i.nextSibling;
    const l = Il(n, document, i, e);
    const u = pl(i) && r || i;
    const f = u === i ? null : c;
    Cl(n, u, l, f);
    t.dirty &= -65;
    t.dirtyChildren = null;
}

function Bt(t, n, e, s) {
    t.dirty &= -3;
    const o = t;
    let i = function r(t) {
        const n = t.props;
        return n?.[is];
    }(t);
    if (!i) {
        return;
    }
    Ut(t, null);
    Tu(i) && (i = i.value);
    return Ho(n, e, i, o, s, null);
}

function Qt(t, n, e, s) {
    const o = t;
    const i = n.getHostProp(o, si);
    if (i && !i.resolved) {
        return i.resolve();
    }
    t.dirty &= -5;
    if (!i) {
        return;
    }
    const r = n.getHostProp(o, Ni) || null;
    return Jt(n, o, o, i, r, e, s);
}

function Ht(t, n, e, s) {
    t.dirty &= -9;
    const o = t;
    const i = function r(t) {
        const n = t.props;
        const e = n?.[os] || null;
        e && delete n[os];
        return e;
    }(t);
    if (!i) {
        return;
    }
    return Jt(n, o, i.subscriptionHost || n.rootVNode, i.componentFn, i.props, e, s);
}

function Jt(t, e, s, o, i, r, c) {
    const l = Yi(() => Go(t, e, s, o, i), s => {
        const o = t.getHostProp(e, $i);
        return n(() => Ho(t, r, s, e, c, nr(o)));
    }, n => {
        t.handleError(n, e);
    });
    if (Ji(l)) {
        return l;
    }
    return;
}

function Yt(t, n, e, s, o, i = null) {
    n.push(Xo(t.node, e, s, i, (t.flags & 512) !== 0));
    o || (t.props && s == null ? delete t.props[e] : (t.props ||= {})[e] = s);
}

function Gt(t, n) {
    t.dirty &= -17;
    if (!(t.flags & 1)) {
        return;
    }
    const e = function s(t) {
        const n = t.props ||= {};
        return n[es] ?? null;
    }(t);
    if (!e || e.size === 0) {
        return;
    }
    const o = t;
    for (const [t, s] of e.entries()) {
        let e = s.value;
        Tu(e) && (e = e.value);
        const i = s.isConst;
        Yt(o, n, t, e, i, s.scopedStyleIdPrefix);
    }
    (function i(t) {
        const n = t.props ||= {};
        delete n[es];
    })(t);
}

function Kt(t, n) {
    t.dirty &= -129;
    const e = n.getHostProp(t, Ci);
    if (!e || e.length === 0) {
        return;
    }
    for (let t = 0; t < e.length; t++) {
        const n = e[t];
        if (n instanceof ku && n.h & 16) {
            n.h &= -17;
            const t = n;
            Bo(t);
        }
    }
}

function Zt(t, e) {
    t.dirty &= -33;
    const s = e.getHostProp(t, ss);
    if (!s) {
        return;
    }
    const o = s.ht;
    const i = xe();
    i.$ = e;
    return Gi(n(() => qe.call(s, i, s.p)), () => {
        if (s.h & 2) {
            s.h &= -3;
            return Iu(e, s, o);
        }
    });
}

function tn(t, n, e, s) {
    t.dirty &= -257;
    const o = t;
    const i = n.getHostProp(o, Ni) || null;
    if (!i) {
        return;
    }
    let r = vs(i, "items");
    Tu(r) && (r = jf(r));
    const c = vs(i, "key$");
    const l = vs(i, "item$");
    const u = c.resolved;
    const f = l.resolved;
    if (u !== void 0 && f !== void 0) {
        return Wt(n, e, o, s, r, u, f);
    }
    return Gi(c.resolve(), t => Gi(l.resolve(), i => Wt(n, e, o, s, r, t, i)));
}

let Ko = null;

const Zo = (t, n, e) => {
    Ko || (Ko = t.insertBefore);
    Ko.call(t, n, e);
};

function nn(t) {
    let n = null;
    let e = null;
    let s = null;
    const o = new Set;
    const r = () => {
        if (s) {
            if (s.length === 1) {
                Zo(n, s[0], e);
            } else {
                const t = n.ownerDocument || n;
                const o = t.createDocumentFragment();
                for (let t = 0; t < s.length; t++) {
                    o.appendChild(s[t]);
                }
                Zo(n, o, e);
            }
            s = null;
            n = null;
            e = null;
            o.clear();
        }
    };
    for (let c = 0; c < t.length; c++) {
        const l = t[c];
        if (l instanceof Co) {
            if (n === l.parent && e === l.beforeTarget) {
                s || (s = []);
                s.push(l.target);
                o.add(l.target);
                continue;
            }
            if (!s) {
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (n === l.parent) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            if (o.has(l.target) || e && l.target === e || n && l.target === n) {
                r();
                n = l.parent;
                e = l.beforeTarget;
                s = [ l.target ];
                o.add(l.target);
                continue;
            }
            Zo(l.parent, l.target, l.beforeTarget);
            continue;
        }
        if (l instanceof xo) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            l.target.remove();
            continue;
        }
        if (l instanceof Io) {
            (o.has(l.target) || e && l.target === e || n && l.target === n) && r();
            const t = l.target;
            t.textContent = "";
            continue;
        }
        if (l instanceof No) {
            l.target.nodeValue = l.text;
        } else if (l instanceof Oo) {
            const t = l.target;
            const e = l.attrName;
            const s = l.attrValue;
            const o = s != null ? i(e, s, l.scopedStyleIdPrefix) : null;
            const c = o == null || o === !1;
            if (tl(t, e)) {
                t[e] = nl(o);
            } else if (e === Bi) {
                n === t && r();
                t.innerHTML = o;
                t.setAttribute(Ei, "html");
            } else {
                c ? t.removeAttribute(e) : e === "value" && e in t ? t.value = o : S(t, e, o, l.isSvg);
            }
        }
    }
    r();
}

const tl = (t, n) => {
    const e = n == "allowfullscreen" || n == "async" || n == "autofocus" || n == "autoplay" || n == "checked" || n == "controls" || n == "default" || n == "defer" || n == "disabled" || n == "formnovalidate" || n == "inert" || n == "ismap" || n == "itemscope" || n == "loop" || n == "multiple" || n == "muted" || n == "nomodule" || n == "novalidate" || n == "open" || n == "playsinline" || n == "readonly" || n == "required" || n == "reversed" || n == "selected";
    return e && n in t;
};

const nl = t => {
    if (t === "false") {
        return !1;
    }
    return !!t;
};

const el = (t => () => queueMicrotask(t))(sn);

const rl = hr(sn);

let sl = !1;

function en() {
    if (!sl) {
        sl = !0;
        el();
    }
}

function rn() {
    if (!sl) {
        sl = !0;
        rl();
    }
}

function sn() {
    sl = !1;
    const t = performance.now();
    const n = t + 15;
    let e = null;
    for (;e = u(); ) {
        if (on(e, n)) {
            rn();
            return;
        }
    }
}

function on(t, n) {
    const e = Ce;
    const s = y(t);
    const o = s.promise;
    if (o) {
        return;
    }
    const i = s.container;
    if (!t.dirty) {
        ln(i, t, s, e);
        return;
    }
    const r = s.journal ||= [];
    let l = null;
    for (;l = s.position; ) {
        if (s.promise) {
            return;
        }
        if (!(l.dirty & 1023)) {
            __EXPERIMENTAL__.suspense && T(l);
            p(i, s, fn(l, t, i));
            continue;
        }
        if (l.flags & 32) {
            if (l.dirty & 128) {
                Kt(l, i);
            } else if (l.dirty & 64) {
                const n = cn(i, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            }
            l.dirty &= -1024;
            p(i, s, fn(l, t, i));
            continue;
        }
        let e;
        try {
            if (l.dirty & 1) {
                e = Vt(l, i, s);
            } else if (l.dirty & 2) {
                e = Bt(l, i, r, t);
            } else if (l.dirty & 4) {
                e = Qt(l, i, r, t);
            } else if (l.dirty & 8) {
                e = Ht(l, i, r, t);
            } else if (l.dirty & 256) {
                e = tn(l, i, r, t);
            } else if (l.dirty & 16) {
                Gt(l, r);
            } else if (l.dirty & 32) {
                e = Zt(l, i);
            } else if (l.dirty & 64) {
                const n = cn(i, s, l, t);
                if (n !== null) {
                    l = n;
                    continue;
                }
            } else {
                l.dirty & 512 && zt(l, r);
            }
        } catch (t) {
            i.handleError(t, l);
        }
        if (e && Ji(e)) {
            R(s, l);
            const n = e;
            s.promise = n;
            c(t, i);
            const o = l;
            n.catch(t => {
                s.promise === n && i.handleError(t, o);
            }).finally(() => {
                if (s.promise !== n) {
                    return;
                }
                s.promise = null;
                f(t, i);
                en();
            });
            return;
        }
        if (performance.now() >= n) {
            return !0;
        }
    }
    ln(i, t, s, e);
}

function ln(t, n, e, s) {
    if (!(n.dirty & 1023)) {
        h(n, t);
        s || function o(t, n) {
            const e = y(t);
            const s = e.journal;
            if (s && s.length > 0) {
                nn(s);
                e.journal = null;
            }
            (function o(t, n) {
                const e = n.afterFlushTasks;
                if (!e || e.length === 0) {
                    n.afterFlushTasks = null;
                    return;
                }
                for (let n = 0; n < e.length; n++) {
                    const s = e[n];
                    Eu(s, t, s.dt);
                }
                n.afterFlushTasks = null;
            })(n, e);
        }(n, t);
        (function i(t) {
            if (!__EXPERIMENTAL__.suspense) {
                return;
            }
            const n = t.boundaries;
            if (!n) {
                return;
            }
            t.boundaries = null;
            for (let t = 0; t < n.length; t++) {
                const e = n[t];
                e.value = Math.max(0, e.value - 1);
            }
        })(e);
        (function r(t) {
            __EXPERIMENTAL__.suspense && t.props && Vi in t.props && _l(t, Vi, null);
        })(n);
        if (e.extraPromises) {
            Promise.all(e.extraPromises).then(() => {
                un(t);
            });
            return;
        }
        un(t);
    }
}

function un(t) {
    t.$t();
}

function cn(t, n, e, s) {
    const o = e.dirtyChildren;
    if (!o || o.length === 0) {
        e.dirty &= -65;
        T(e);
        return null;
    }
    (function i(t, n) {
        let e = 0;
        for (let s = 0; s < t.length; s++) {
            const o = t[s];
            if (o.parent === n) {
                if (e !== s) {
                    const n = t[e];
                    t[e] = o;
                    t[s] = n;
                }
                e++;
            }
        }
    })(o, e);
    e.nextDirtyChildIndex = 0;
    const r = fn(o[0], s, t);
    p(t, n, r);
    return r;
}

function fn(t, n, e) {
    if (t === n) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    let s = null;
    t.slotParent && t.slotParent.dirty & 64 ? s = t.slotParent : t.parent && t.parent.dirty & 64 && (s = t.parent);
    if (!s) {
        if (n.dirty & 1023) {
            return n;
        }
        return null;
    }
    const o = s.dirtyChildren;
    let i = s.nextDirtyChildIndex;
    const r = o.length;
    let c = r;
    for (;c-- > 0; ) {
        const t = o[i];
        if (t.dirty & 1023) {
            if (e && an(e, t)) {
                i++;
                i === r && (i = 0);
                continue;
            }
            s.nextDirtyChildIndex = (i + 1) % r;
            return t;
        }
        i++;
        i === r && (i = 0);
    }
    s.dirty &= -65;
    s.dirtyChildren = null;
    s.nextDirtyChildIndex = 0;
    __EXPERIMENTAL__.suspense && T(s);
    return fn(s, n, e);
}

function an(t, n) {
    if (!P(n)) {
        return !1;
    }
    dn(n) || hn(t, n, 0);
    return !0;
}

function hn(t, n, e) {
    if (dn(n)) {
        en();
        return n;
    }
    const s = {
        afterFlushTasks: null,
        extraPromises: null,
        journal: null,
        container: t,
        position: n,
        priority: e,
        promise: null,
        boundaries: null
    };
    (function o(t, n) {
        ns.set(t, n);
    })(n, s);
    const i = n;
    i.flags |= 256;
    l(t, i);
    en();
    return i;
}

function dn(t) {
    return (t.flags & 256) !== 0;
}

function pn(t, n) {
    if (!(n.flags & 1)) {
        n.dirty & 16 && function e(t, n) {
            n.dirty &= -17;
            const e = n.getProp(es);
            if (!e || e.size === 0) {
                return;
            }
            for (const [s, o] of e.entries()) {
                let e = o.value;
                Tu(e) && (e = e.value);
                const r = i(s, e, o.scopedStyleIdPrefix);
                t.addBackpatchEntry(n.id, s, r);
            }
        }(t, n);
        n.dirty & 32 && Zt(n, t);
        n.dirty &= -1024;
        return;
    }
    let e = null;
    if (n.dirty & 1) {
        const s = function o(t, n) {
            n.dirty &= -2;
            const e = n.getProp(Ci);
            if (!e || e.length === 0) {
                return null;
            }
            let s = null;
            for (let o = 0; o < e.length; o++) {
                const i = e[o];
                if (i instanceof ku) {
                    const e = i;
                    if (!(e.h & 4)) {
                        continue;
                    }
                    const o = Eu(e, t, n);
                    s = s ? s.then(() => o) : o;
                }
            }
            return s;
        }(t, n);
        Ji(s) && (e = s);
    }
    if (n.dirty & 256) {
        const s = async function o(t, n) {
            n.dirty &= -257;
            const e = n;
            const s = t.getHostProp(e, Ni) || null;
            if (!s) {
                return;
            }
            let o = vs(s, "items");
            Tu(o) && (o = jf(o));
            const i = await vs(s, "key$").resolve();
            const r = await vs(s, "item$").resolve();
            const c = [];
            for (let t = 0; t < o.length; t++) {
                const n = o[t];
                const e = r(n, t);
                const s = i(n, t);
                e.key = s;
                c.push(e);
            }
            await t.renderJSX(c, {
                currentStyleScoped: null,
                parentComponentFrame: t.getComponentFrame(0)
            });
        }(t, n);
        e = e ? e.then(() => s) : s;
    }
    n.dirty &= -1020;
    if (e) {
        return e;
    }
}

const ol = [];

function $n(t) {
    for (let n = 0; n < ol.length; n++) {
        const e = ol[n];
        const s = ol[n + 1] || t;
        s.dirty |= 64;
        s.dirtyChildren ||= [];
        s.dirtyChildren.includes(e) || s.dirtyChildren.push(e);
    }
}

function yn(t, n, e, s = null) {
    const o = n.dirty;
    n.dirty |= e;
    if (function i() {
        return Ce;
    }()) {
        const e = pn(t, n);
        Ji(e) && (t.l = t.l ? t.l.then(() => e) : e);
        return e;
    }
    const r = e & 1023;
    if ((r ? o & 1023 : o) || n === s) {
        return;
    }
    const c = n.slotParent || n.parent;
    if (s && r && c && !c.dirty) {
        (function t(n, e) {
            ol.push(n);
            let s = P(n);
            let o = n.slotParent || n.parent;
            for (;o; ) {
                const t = o.dirty & 1023;
                const i = dn(o);
                __EXPERIMENTAL__.suspense && (s ||= P(o) || (t ? q(o) : null));
                if (o === e || t) {
                    A(n, s);
                    $n(o);
                    if (i) {
                        const t = y(o);
                        t.position !== o && (t.position = n);
                    }
                    ol.length = 0;
                    return;
                }
                if (i) {
                    const t = y(o);
                    t.position !== o && (t.position = n);
                }
                ol.push(o);
                o = o.slotParent || o.parent;
            }
            ol.length = 0;
            ((t, ...n) => {
                const e = De(!1, t, ...n);
                debugger;
                throw e;
            })("Cursor root not found in current path!");
        })(n, s);
        return;
    }
    if (c && c.dirty & 1023) {
        A(n, P(n) || q(c));
        r && (c.dirty |= 64);
        c.dirtyChildren ||= [];
        c.dirtyChildren.includes(n) || c.dirtyChildren.push(n);
        if (r && n.dirtyChildren) {
            const t = function e(t) {
                for (;t; ) {
                    if (dn(t)) {
                        return t;
                    }
                    t = t.parent || t.slotParent;
                }
                return null;
            }(n);
            if (t) {
                const e = y(t);
                let s = e.position;
                if (s) {
                    for (;s !== t; ) {
                        s = s.slotParent || s.parent;
                        if (s === n) {
                            e.position = n;
                            break;
                        }
                    }
                }
            }
        }
    } else {
        dn(n) ? A(n, P(n)) : function l(t) {
            ol.push(t);
            let n = P(t);
            let e = t.slotParent || t.parent;
            for (;e; ) {
                const s = dn(e);
                __EXPERIMENTAL__.suspense && (n ||= P(e) || (s ? q(e) : null));
                if (s) {
                    A(t, n);
                    $n(e);
                    ol.length = 0;
                    return !0;
                }
                ol.push(e);
                e = e.slotParent || e.parent;
            }
            A(t, n);
            ol.length = 0;
            return !1;
        }(n) || hn(t, n, 0);
    }
}

function mn(t, n) {
    t.push(n);
}

const ll = (t, n) => {
    let e;
    for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
        t = Object.getPrototypeOf(t);
    }
    return e || function() {
        return this[n];
    };
};

const ul = t => {
    let n = null;
    return e => {
        n || (n = ll(e, t));
        return n.call(e);
    };
};

const cl = (t, n, e = null) => {
    const s = new Gr(e, -4087, null, null, null, null, null, null, t, n);
    t.vNode = s;
    return s;
};

const fl = t => {
    const n = new Gr(null, -4095, null, null, null, null, void 0, void 0, t, void 0);
    t.vNode = n;
    return n;
};

const al = (t, n) => {
    const e = new Kr(-4084, null, null, null, null, t, n);
    return e;
};

const hl = () => {
    const t = new Yr(null, -4094, null, null, null, null, null, null);
    return t;
};

const dl = t => t instanceof Jr;

const pl = t => (t.flags & 1) === 1;

const $l = t => {
    const n = t.flags;
    return (n & 5) !== 0;
};

const yl = t => {
    const n = t.flags;
    return (n & 1) === 1 && t.firstChild !== void 0 && t.lastChild !== void 0;
};

const ml = t => (t.flags & 4) === 4;

const wl = t => (t.flags & 2) === 2;

const vl = t => {
    const n = t.flags;
    return (n & 2) === 2 && bl(t, ui, null) !== null;
};

const ad = t => t;

const bl = (t, n, e) => {
    if (pl(t) || wl(t)) {
        const s = t.props?.[n] ?? null;
        if (typeof s === "string" && e) {
            const o = e(s);
            t.props[n] = o;
            return o;
        }
        return s;
    }
    return null;
};

const _l = (t, n, e) => {
    if (e == null && t.props) {
        delete t.props[n];
    } else {
        t.props ||= {};
        t.props[n] = e;
    }
};

const gl = (t, n, e, s, o = null) => {
    if (pl(n)) {
        _l(n, e, s);
        mn(t, Xo(n.node, e, s, o, (n.flags & 512) !== 0));
    }
};

const Sl = t => {
    if (t.key) {
        return;
    }
    const n = tu(t.node, zi);
    n && (t.key = n);
};

const El = (t, n) => {
    if ((n.flags & 15) === 1) {
        const e = n;
        e.flags ^= 8;
        const s = e.node;
        const o = s.attributes;
        let i = !1;
        for (let n = 0; n < o.length; n++) {
            const r = o[n];
            const c = r.name;
            if (er(c)) {
                wn(r, c, t, s);
                continue;
            }
            if (i) {} else if (c !== zi && c) {
                if (c.startsWith(Ei)) {
                    const t = r.value;
                    t === "html" ? _l(e, "dangerouslySetInnerHTML", s.innerHTML) : t === "text" && "value" in s && _l(e, "value", s.value);
                } else {
                    const t = r.value;
                    _l(e, c, t);
                }
            } else {
                const t = r.value;
                t && (e.key = t);
                i = !0;
            }
        }
        bl(e, ji, null) === null && bl(e, Li, null) === null || (n.flags |= 64);
    }
};

const kl = t => {
    if (t.gt === "_run") {
        const n = t.getCaptured()?.[0];
        if (Ke(n)) {
            return n;
        }
    }
    return t;
};

function wn(t, n, e, s) {
    const o = t.value;
    const i = n.slice(2);
    const r = o.split("|");
    const c = [];
    for (let t = 0; t < r.length; t++) {
        const n = kl(Ln(r[t], e));
        c.push(x.bind(null, n));
    }
    (s._qDispatch ||= {})[i] = c.length === 1 ? c[0] : c;
}

function vn(t, n, e) {
    let s = Jl(n);
    for (;s; ) {
        if (ml(s)) {
            Pl(t, s);
            e(s, n);
        } else {
            pl(s) ? e(s, n) : vn(t, s, e);
        }
        s = s.nextSibling;
    }
}

function bn(t) {
    let n = t;
    if (ml(t)) {
        return;
    }
    let e = null;
    for (;;) {
        const s = Jl(n);
        if (s) {
            n = s;
            continue;
        }
        if (n === t) {
            return;
        }
        const o = n.nextSibling;
        if (o) {
            n = o;
            continue;
        }
        e = n.parent;
        for (;e; ) {
            if (e === t) {
                return;
            }
            const s = e.nextSibling;
            if (s) {
                n = s;
                break;
            }
            e = e.parent;
        }
        if (e == null) {
            return;
        }
    }
}

const Rl = (t, n, e) => {
    let s = t;
    for (;e && s && wl(s); ) {
        const t = n ? s.firstChild : s.lastChild;
        if (!t) {
            break;
        }
        if (t.flags & 5) {
            return t;
        }
        s = t;
    }
    for (;s; ) {
        let t = n ? s.nextSibling : s.previousSibling;
        if (t && t.flags & 5) {
            return t;
        }
        if (!t) {
            let e = s.parent;
            if (e && !wl(e)) {
                return null;
            }
            for (;e && !(t = n ? e.nextSibling : e.previousSibling); ) {
                e = e.parent;
                if (e && !wl(e)) {
                    return null;
                }
            }
            if (!t) {
                return null;
            }
            if (ml(t) && e && pl(e)) {
                return null;
            }
        }
        for (;t; ) {
            s = t;
            if (s.flags & 5 && yu(s)) {
                return s;
            }
            t = n ? s.firstChild : s.lastChild;
        }
    }
    return null;
};

const Pl = (t, n) => {
    const e = (t => t)(n);
    const s = e.flags;
    if ((s & 8) === 0) {
        const s = Wl(n, !0);
        const o = e.node;
        const i = fu(s);
        let r = Rl(n, !1, !0);
        const c = Rl(n, !0, !0);
        const l = o || (c && pl(c) ? c.node : c?.node) || null;
        let u = l;
        for (;r && ml(r); ) {
            if ((r.flags & 8) === 0) {
                const n = i.createTextNode(r.text);
                mn(t, Do(n, s, u));
                u = n;
                r.node = n;
                r.flags |= 8;
            }
            r = Rl(r, !1, !0);
        }
        r = n;
        for (;r && ml(r); ) {
            const n = Rl(r, !0, !0);
            const e = !n || !ml(n);
            if ((r.flags & 8) === 0) {
                if (e && o) {
                    mn(t, Fo(o, r.text));
                } else {
                    const n = i.createTextNode(r.text);
                    mn(t, Do(n, s, l));
                    r.node = n;
                }
                r.flags |= 8;
            }
            r = n;
        }
    }
};

const Tl = (t, n) => {
    let e = t;
    const s = t.node;
    const o = s.qVNodeRefs;
    let i = -1;
    let r;
    const c = typeof n === "string" ? n : "";
    if (typeof n === "string") {
        i = parseInt(c);
        r = o.get(i);
    } else {
        r = n;
        const t = r;
        const s = t.vNode;
        if (s) {
            return s;
        }
        if (__EXPERIMENTAL__.suspense && t._qSegment) {
            e = fl(r);
            Sl(e);
            t.vNode = e;
            return e;
        }
    }
    if (dl(r)) {
        e = r;
    } else {
        if (__EXPERIMENTAL__.suspense && r._qSegment) {
            e = r.vNode || fl(r);
            Sl(e);
        } else {
            let t = r;
            const n = [ r ];
            for (;t && t !== s && !t.vNode; ) {
                t = t.parentElement;
                n.push(t);
            }
            t.vNode && (e = t.vNode);
            for (let t = n.length - 2; t >= 0; t--) {
                e = Ml(e, n[t]);
            }
        }
        if (i != -1) {
            r.vNode = e;
            o.set(i, e);
        }
    }
    if (typeof n === "string") {
        const t = c.length;
        let n = xl(c, t);
        let s = 0;
        for (;n < t; ) {
            const t = c.charCodeAt(n);
            s *= 26;
            if (t >= 97) {
                s += t - 97;
            } else {
                s += t - 65;
                e = ql(e, s);
                s = 0;
            }
            n++;
        }
    }
    return e;
};

const ql = (t, n) => {
    let e = Jl(t);
    for (;e.flags >>> 12 !== n; ) {
        e = e.nextSibling;
    }
    return e;
};

const Al = [];

const Ml = (t, n) => {
    let e = Jl(t);
    for (;e && (!(e instanceof Gr) || e.node !== n); ) {
        if (wl(e)) {
            const t = e.nextSibling;
            const n = Jl(e);
            if (n) {
                t && Al.push(t);
                e = n;
            } else {
                e = t || (Al.length ? Al.pop() : null);
            }
        } else {
            const t = e.nextSibling;
            e = t || t || Al.pop();
        }
    }
    for (;Al.length; ) {
        Al.pop();
    }
    return e;
};

const xl = (t, n) => {
    let e = t.charCodeAt(0) === 45 ? 1 : 0;
    for (;e < n; ) {
        const n = t.charCodeAt(e);
        if (!(n >= 48 && n <= 57)) {
            return e;
        }
        e++;
    }
    return n;
};

const Il = (t, n, e, s) => {
    const o = n.createElement("errored-host");
    s && s instanceof Error && (o.props = {
        error: s
    });
    o.setAttribute("q:key", "_error_");
    const i = cl(o, "errored-host");
    if ($l(e)) {
        Xl(t, i, e, null);
    } else {
        const n = [];
        vn(t, e, t => {
            n.push(t);
        });
        for (let e = 0; e < n.length; e++) {
            Xl(t, i, n[e], null);
        }
    }
    return i;
};

const Nl = nn;

const Cl = (t, n, e, s) => {
    const o = pl(n);
    o && Yl(n);
    const i = e.parent;
    if (e === s) {
        if (i) {
            return;
        }
        s = null;
    }
    Fl(t, i, n, e);
    const r = e.node;
    const c = n.flags & 32;
    const l = o ? n.node : Wl(n, !1);
    l && !c && mn(t, Do(r, l, jl(t, n, s)?.node ?? null));
    Ll(n, e, s);
    c && (e.flags |= 32);
};

const Ol = (t, n, e, i) => {
    const r = pl(n);
    r && Yl(n);
    const c = e.parent;
    if (e === i) {
        if (c) {
            return;
        }
        i = null;
    }
    Fl(t, c, n, e);
    const l = n.flags & 32;
    const u = !r && n.flags & 2048 ? n.props?.[oi] : null;
    const f = u ? null : r ? n : Vl(n, !1);
    const a = u || f?.node;
    const h = jl(t, n, i);
    const d = h?.node ?? null;
    const p = vl(e);
    if (p && f && (f.flags & 1536) !== 0) {
        const r = Vl(n, !1);
        const c = jl(t, n, i)?.node ?? null;
        const {elementNamespace: l, elementNamespaceFlag: u} = o(r, e);
        vn(t, e, n => {
            if (ml(n)) {
                mn(t, Do(n.node, a, c));
            } else {
                if ((n.flags & 1536) !== u) {
                    const t = function e(t, n, i, r) {
                        let c = t;
                        let l = null;
                        let u = null;
                        let f = null;
                        for (;c; ) {
                            let e = null;
                            let a = null;
                            if (pl(c)) {
                                e = c.node;
                                const t = Bl(c);
                                const l = c.parent;
                                const h = u == null ? n : l && Vl(l, !0);
                                if (h) {
                                    const t = o(h, Bl(c));
                                    i = t.elementNamespace;
                                    r = t.elementNamespaceFlag;
                                }
                                const d = Jl(c);
                                a = s(e, t, i, !d);
                                e.remove();
                                u == null && (u = a);
                                f && f.appendChild(a);
                                c.node = a;
                                c.flags &= -1537;
                                c.flags |= r;
                                if (d) {
                                    c = d;
                                    f = a;
                                    continue;
                                }
                                if (Kl(e)) {
                                    const t = Ee(e);
                                    if (t) {
                                        const n = Jl(t.rootVNode);
                                        if (n) {
                                            c = n;
                                            f = a;
                                            continue;
                                        }
                                    }
                                }
                            }
                            if (c === t) {
                                return u;
                            }
                            const h = c.nextSibling;
                            if (h) {
                                c = h;
                                continue;
                            }
                            l = c.parent;
                            for (;l; ) {
                                if (l === t) {
                                    return u;
                                }
                                const n = l.nextSibling;
                                if (n) {
                                    c = n;
                                    return u;
                                }
                                l = l.parent;
                            }
                            if (l == null) {
                                return u;
                            }
                        }
                        return u;
                    }(n, r, l, u);
                    t && (n.node = t);
                }
                mn(t, Do(n.node, a, c));
            }
        });
    } else {
        a && !l && vn(t, e, n => {
            mn(t, Do(n.node, a, d));
        });
    }
    Ll(n, e, i);
    l && (e.flags |= 32);
};

const jl = (t, n, e) => {
    let s = null;
    e == null ? wl(n) && (s = Rl(n, !0, !1)) : s = wl(e) ? Rl(e, !0, !0) : e;
    s && ml(s) && Pl(t, s);
    return s;
};

const Ll = (t, n, e) => {
    const s = e ? e.previousSibling : t.lastChild;
    e ? e.previousSibling = n : t.lastChild = n;
    s ? s.nextSibling = n : t.firstChild = n;
    n.previousSibling = s;
    n.nextSibling = e;
    n.parent = t;
};

const Fl = (t, n, e, s) => {
    n && (s.previousSibling || s.nextSibling || n !== e) && Ul(t, n, s, !1);
};

const Dl = (t, n) => {
    let e = n;
    for (;e && wl(e); ) {
        e = e.lastChild;
    }
    e && ml(e) && (e.flags & 8) === 0 && Pl(t, e);
};

const Xl = (t, n, e, s) => {
    $l(e) ? Cl(t, n, e, s) : Ol(t, n, e, s);
};

const Wl = (t, n) => {
    for (;t && !pl(t); ) {
        if (t.flags & 2048) {
            return t.props?.[oi];
        }
        t = t.parent || (n ? t.slotParent : null);
    }
    return t ? t.node : null;
};

const Vl = (t, n) => {
    for (;t && !pl(t); ) {
        t = t.parent || (n ? t.slotParent : null);
    }
    return t;
};

const Ul = (t, n, e, s) => {
    ml(e) && Pl(t, e);
    if (s) {
        const s = bl(n, Bi, null) !== null;
        if (s) {
            return;
        }
        $l(e) ? mn(t, jo(e.node)) : vn(t, e, n => {
            mn(t, jo(n.node));
        });
    }
    const o = e.previousSibling;
    const i = e.nextSibling;
    o ? o.nextSibling = i : n.firstChild = i;
    i ? i.previousSibling = o : n.lastChild = o;
    e.previousSibling = null;
    e.nextSibling = null;
};

const zl = (t, n, e, s = !0) => {
    const o = Wl(n, !0);
    if (o && s) {
        if ($l(n)) {
            mn(t, Lo(n.node));
        } else {
            const e = Vl(n, !1);
            e && e.firstChild === n && e.lastChild === n ? mn(t, Lo(o)) : vn(t, n, n => {
                mn(t, jo(n.node));
            });
        }
    }
    const i = e.previousSibling;
    i ? i.nextSibling = null : n.firstChild = null;
    n.lastChild = i;
};

const Bl = t => {
    const n = ad(t);
    let e = n.elementName;
    if (e === void 0) {
        const t = n.node;
        const s = cu(t).toLowerCase();
        e = n.elementName = s;
        n.flags |= (t => {
            const n = uu(t);
            switch (n) {
              case qi:
                return 512;

              case Ai:
                return 1024;

              default:
                return 0;
            }
        })(t);
    }
    return e;
};

const Ql = t => {
    let n = t.text;
    n === void 0 && (n = t.text = t.node.nodeValue);
    return n;
};

const Hl = (t, n, e) => {
    Pl(t, n);
    n.text = e;
    mn(t, Fo(n.node, e));
};

const Jl = t => {
    if (ml(t)) {
        return null;
    }
    let n = t.firstChild;
    if (__EXPERIMENTAL__.suspense && n === void 0 && pl(t) && function e(t) {
        const n = t.getAttribute(od);
        if (n === null) {
            return !1;
        }
        const e = lu(t);
        return _u(e) && e.localName === "template" && e.getAttribute(ai) === n && ru(e) === null;
    }(t.node)) {
        return null;
    }
    n === void 0 && (n = Yl(t));
    return n;
};

const Yl = n => {
    const e = ad(n);
    let s = e.firstChild;
    if (s === void 0) {
        const n = e.node;
        s = e.parent && Kl(n) ? e.firstChild = e.lastChild = null : (n => {
            const e = n.node;
            const s = lu(e);
            const o = fu(e)?.qVNodeData?.get(e);
            const i = ((n, e, s, o) => {
                Sl(n);
                __EXPERIMENTAL__.suspense && e._qSegment;
                if (o) {
                    if (o.charCodeAt(0) === ii && o.charCodeAt(1) === ii) {
                        const t = (t => {
                            const n = t.indexOf("||", 2);
                            const e = t.substring(2, n);
                            const s = t.substring(n + 2);
                            return {
                                elementVNodeData: e,
                                virtualVNodeData: s
                            };
                        })(o);
                        const e = t.elementVNodeData;
                        o = t.virtualVNodeData;
                        const i = au(n, s, e);
                        if (!o) {
                            return i;
                        }
                    }
                    return function i(n, e, s, o) {
                        let i = 0;
                        let r = null;
                        let c = null;
                        let l = null;
                        const u = t => {
                            t.flags = t.flags & 4095 | i << 12;
                            i++;
                            c && (c.nextSibling = t);
                            t.previousSibling = c;
                            t.parent = n;
                            r || (n.firstChild = r = t);
                            c = t;
                        };
                        let f = 0;
                        let a = null;
                        let h = null;
                        const d = t => {
                            const n = _u(t);
                            return !n || n && En(t);
                        };
                        let p = null;
                        hu(e, ($, y, w, m, b, v) => {
                            if (mu($())) {
                                for (;d(o); ) {
                                    o = ru(o);
                                    if (!o) {
                                        throw Ye(27, [ e, $(), b ]);
                                    }
                                }
                                a = null;
                                l = null;
                                let t = 0;
                                for (;mu($()); ) {
                                    t *= 10;
                                    t += w() - 48;
                                }
                                for (;t--; ) {
                                    const n = fl(o);
                                    Sl(n);
                                    u(n);
                                    o = ru(o);
                                    for (;_u(o) && En(o); ) {
                                        o = ru(o);
                                        if (!o && t > 0) {
                                            throw Ye(27, [ e, $(), b ]);
                                        }
                                    }
                                }
                            } else if ($() === 59) {
                                _l(n, $i, y());
                            } else if ($() === 60) {
                                (p ||= []).push(n);
                                _l(n, si, y());
                            } else if ($() === 61) {
                                h || (h = Se(s));
                                const t = y();
                                h.Hn(parseInt(t, 10), n);
                            } else if ($() === 62) {
                                _l(n, Ni, y());
                            } else if ($() === 64) {
                                n.key = v();
                            } else if ($() === 91) {
                                _l(n, Ci, y());
                            } else if ($() === 94) {
                                _l(n, Oi, y());
                            } else if ($() === 96) {
                                h || (h = Se(s));
                                gn(n, y(), h);
                            } else if ($() === 63) {
                                h || (h = Se(s));
                                n.slotParent = Tl(h.rootVNode, y());
                            } else if ($() === 93) {
                                _l(n, yi, y());
                            } else if ($() === 123) {
                                w();
                                u(hl());
                                vu.push(n, r, c, l, i);
                                i = 0;
                                n = c;
                                r = c = null;
                            } else if ($() === ii) {
                                const e = y();
                                const s = decodeURIComponent(t(e));
                                const o = b + e.length + 1;
                                const i = m(o + 1) === ii;
                                let r;
                                if (i) {
                                    w();
                                    r = decodeURI(t(y()));
                                    w();
                                } else {
                                    r = t(y());
                                }
                                _l(n, s, r);
                            } else if ($() === 125) {
                                w();
                                n.lastChild = c;
                                i = vu.pop();
                                l = vu.pop();
                                c = vu.pop();
                                r = vu.pop();
                                n = vu.pop();
                            } else if ($() === 126) {
                                _l(n, ui, v());
                            } else {
                                for (;_u(o) && En(o); ) {
                                    o = ru(o);
                                }
                                const t = o && nu(o) === 3 ? o : null;
                                if (a === null) {
                                    a = t ? t.nodeValue : null;
                                    f = 0;
                                }
                                let n = 0;
                                for (;wu($()); ) {
                                    n += w() - 97;
                                    n *= 26;
                                }
                                n += w() - 65;
                                const e = a === null ? "" : a.substring(f, f + n);
                                u(l = ((t, n, e) => {
                                    const s = new Kr(-4092, null, t, null, null, n, e);
                                    return s;
                                })(l, t, e));
                                f += n;
                            }
                        });
                        if (p) {
                            h || (h = Se(s));
                            for (let t = 0; t < p.length; t++) {
                                h.ensureProjectionResolved(p[t]);
                            }
                            p = null;
                        }
                        n.lastChild = c;
                        return r;
                    }(n, o, e, s);
                }
                return au(n, s, void 0);
            })(n, e, s, o);
            return i;
        })(e);
    }
    return s;
};

let Gl = null;

const Kl = t => {
    Gl || (Gl = t.hasAttribute);
    return Gl.call(t, Ei);
};

let Zl = null;

const tu = (t, n) => {
    Zl || (Zl = t.getAttribute);
    return Zl.call(t, n);
};

const nu = ul("nodeType");

const eu = t => {
    const n = nu(t);
    return n === 3 || n === 1;
};

let iu = null;

const ru = t => {
    iu || (iu = ll(t, "nextSibling"));
    ou || (ou = ll(t, "firstChild"));
    for (;t; ) {
        t = iu.call(t);
        if (t !== null) {
            const n = nu(t);
            if (n === 3 || n === 1) {
                break;
            }
            if (n === 8) {
                const n = t.nodeValue;
                if (n?.startsWith(gi)) {
                    return _n(t, bi, iu, ou);
                }
                if (t.nodeValue?.startsWith(_i)) {
                    return _n(t, [ bi, Si ], iu, ou);
                }
                if (n?.startsWith(Ei)) {
                    for (;t && (t = iu.call(t)) && (nu(t) !== 8 || !t.nodeValue?.startsWith(ki)); ) {}
                }
            }
        }
    }
    return t;
};

function _n(t, n, e, s) {
    const o = typeof n === "string";
    const i = n.length;
    for (;t; ) {
        const r = t.nodeValue;
        let c;
        if (o) {
            c = r?.startsWith(n);
        } else {
            for (let t = 0; t < i; t++) {
                if (r?.startsWith(n[t])) {
                    c = !0;
                    break;
                }
            }
        }
        if (c) {
            t = e.call(t) || null;
            return t;
        }
        let l = s.call(t);
        l || (l = e.call(t));
        for (;!l; ) {
            l = su(t);
            if (!l) {
                break;
            }
            t = l;
            l = e.call(l);
        }
        t = l;
    }
    return null;
}

const su = ul("parentNode");

let ou = null;

const lu = t => {
    ou || (ou = ll(t, "firstChild"));
    t = t && ou.call(t);
    if (t && nu(t) === 8) {
        iu || (iu = ll(t, "nextSibling"));
        if (t.nodeValue?.startsWith(gi)) {
            return _n(t, bi, iu, ou);
        }
    }
    for (;t && !eu(t); ) {
        t = ru(t);
    }
    return t;
};

const uu = ul("namespaceURI");

const cu = ul("nodeName");

const fu = ul("ownerDocument");

const au = (t, n, e) => {
    let s = null;
    let o = 0;
    const i = () => {
        for (;_u(r) && En(r); ) {
            r = ru(r);
        }
    };
    let r = n;
    i();
    let c = null;
    for (;r; ) {
        const n = nu(r);
        let e = null;
        if (n === 3) {
            e = al(r, r.textContent ?? void 0);
        } else if (n === 1) {
            e = fl(r);
            Sl(e);
        }
        if (e) {
            e.flags = e.flags & 4095 | o << 12;
            o++;
            e.parent = t;
            c && (c.nextSibling = e);
            e.previousSibling = c;
            c = e;
        }
        s || (t.firstChild = s = c);
        r = ru(r);
        i();
    }
    t.lastChild = c || null;
    t.firstChild = s;
    if (e) {
        let n = null;
        hu(e, (e, s) => {
            if (e() === 61) {
                n || (n = Se(t.node));
                const e = s();
                n.Hn(parseInt(e, 10), t);
            } else if (e() === 96) {
                n || (n = Se(t.node));
                gn(t, s(), n);
            } else {
                s();
            }
        });
    }
    return s;
};

function gn(t, n, e) {
    if (t[Vr]) {
        const s = t[Vr];
        ((t, n) => {
            for (const [e, s] of n) {
                t.set(e, s);
            }
        })(s, e.k(n));
    } else {
        Object.defineProperty(t, Vr, {
            get() {
                const s = e.k(n);
                t[Vr] = s;
                return s;
            },
            set(n) {
                Object.defineProperty(t, Vr, {
                    value: n,
                    writable: !0,
                    enumerable: !0,
                    configurable: !0
                });
            },
            enumerable: !0,
            configurable: !0
        });
    }
}

const hu = (n, e) => {
    let s = 0;
    let o = 0;
    let i = 0;
    const r = t => t < n.length ? n.charCodeAt(t) : 0;
    const c = () => i !== 0 ? i : i = r(s);
    const l = () => {
        o = c();
        i = 0;
        s++;
        return o;
    };
    const u = () => {
        l();
        const t = s;
        for (;c() <= 58 && i !== 0 || i === 92 || i === 95 || i >= 65 && i <= 90 || i >= 97 && i <= 122; ) {
            l();
        }
        return n.substring(t, s);
    };
    const f = () => {
        if (r(s + 1) !== ii) {
            return u();
        }
        l();
        const n = decodeURIComponent(t(u()));
        l();
        return n;
    };
    for (;c() !== 0; ) {
        e(c, u, l, r, s, f);
    }
};

const du = (t, n) => {
    const e = n.flags;
    if ((e & 3) !== 0) {
        El(t, n);
        const e = [];
        const s = n.props;
        if (s) {
            for (const t in s) {
                t.startsWith(zi) || e.push(t);
            }
        }
        return e;
    }
    return [];
};

const pu = (t, n) => {
    let e = $u(t);
    for (;e; ) {
        if (e === n) {
            return !0;
        }
        e = $u(e);
    }
    return !1;
};

const $u = t => t.parent || t.slotParent;

const yu = t => {
    if (t === null || wl(t)) {
        return null;
    }
    return t.node;
};

function Sn(t = 20, n = "", e = !1, s = !1, o = !0, i = null) {
    if (this && !i) {
        try {
            i = function t(n) {
                let e = n;
                for (;e; ) {
                    if (pl(e)) {
                        const t = ke(e.node);
                        if (!t) {
                            return null;
                        }
                        return Ee(t);
                    }
                    e = e.parent;
                }
                return null;
            }(this);
        } catch {}
    }
    let r = this;
    if (t === 0) {
        return "...";
    }
    if (r === null) {
        return "null";
    }
    if (r === void 0) {
        return "undefined";
    }
    const c = [];
    do {
        if (ml(r)) {
            c.push(Mn(Ql(r)));
        } else if (wl(r)) {
            const e = r.flags >>> 12;
            const s = [ "[" + e + "]" ];
            r.dirty && s.push(" dirty:" + r.dirty);
            if (i) {
                const t = du(i, r);
                for (let n = 0; n < t.length; n++) {
                    const e = t[n];
                    if (e !== Ze && e !== "__scopedStyleIdPrefix__") {
                        const t = bl(r, e, null);
                        s.push(" " + e + "=" + Mn(t));
                    }
                }
                r.slotParent && s.push(" slotParent=(C)");
            }
            const l = (o ? "[34m" : "") + (ti[bl(r, Ze, null) || "V"] || ti.V) + (o ? "[0m" : "");
            c.push("<" + l + s.join("") + ">");
            const u = Jl(r);
            u && c.push("  " + Sn.call(u, t - 1, n + "  ", !0, !0, o));
            c.push("</" + l + ">");
        } else if (pl(r)) {
            const s = Bl(r);
            const l = [];
            dn(r) && l.push(" cursor");
            r.dirty && l.push(" dirty:" + r.dirty);
            r.dirtyChildren && l.push(` dirtyChildren[${r.dirtyChildren.length}]`);
            const u = i ? du(i, r) : [];
            for (let t = 0; t < u.length; t++) {
                const n = u[t];
                const e = bl(r, n, null);
                l.push(" " + n + "=" + Mn(e));
            }
            const f = yu(r);
            if (f) {
                const t = fu(f).qVNodeData?.get(f);
                t && l.push(" q:vnodeData=" + Mn(t));
            }
            const a = f.attributes;
            for (let t = 0; t < a.length; t++) {
                const n = a[t];
                u.indexOf(n.name) === -1 && l.push(" " + n.name + (n.value ? "=" + Mn(n.value) : ""));
            }
            c.push("<" + s + l.join("") + ">");
            if (yl(r) || e) {
                const e = Jl(r);
                e && c.push("  " + Sn.call(e, t - 1, n + "  ", !0, !0, o));
            } else {
                c.push("  \x3c!-- not materialized --!>");
            }
            c.push("</" + s + ">");
        }
        r = s && r.nextSibling || null;
    } while (r);
    return c.join("\n" + n);
}

const mu = t => 48 <= t && t <= 57;

const wu = t => 97 <= t && t <= 122;

function En(t) {
    return !t.hasAttribute(zi) || t.nodeName === "STYLE" && (t.hasAttribute($i) || t.hasAttribute(hi));
}

const vu = [];

const bu = t => {
    const n = t.flags;
    if (n & 1) {
        return 1;
    }
    if (n & 2) {
        return 11;
    }
    if (n & 4) {
        return 3;
    }
    throw Ye(26, [ n ]);
};

const _u = t => t && typeof t == "object" && nu(t) === 1;

const gu = t => {
    let n = 1;
    for (;n--; ) {
        for (;t && (!wl(t) || bl(t, si, null) === null); ) {
            const e = t.slotParent;
            const s = wl(t) && e;
            s && n++;
            t = s || t.parent;
        }
        n > 0 && (t = t.parent);
    }
    return t;
};

function kn(t, n) {
    dl(n) && pl(n) && Yl(n);
    const e = n[Vr];
    if (!e) {
        return;
    }
    for (const [, n] of e) {
        Rn(t, n);
    }
    e.clear();
}

function Rn(t, n) {
    const e = n.backRef;
    if (!e) {
        return;
    }
    for (const s of e) {
        if (s instanceof qs) {
            Pn(t, s, n);
            s instanceof Ms && Tn(s, n);
        } else if (gs(s)) {
            const t = s[fs];
            qn(t, n);
        } else if (t.yt.has(s)) {
            const e = t.yt.get(s);
            const o = Du(e);
            qn(o, n);
        }
    }
    e.clear();
}

function Pn(t, n, e) {
    const s = n.ht;
    s && s.has(e) && s.delete(e);
    if (n instanceof Js && !s?.size) {
        n._ = void 0;
        kn(t, n);
    }
}

function Tn(t, n) {
    const e = t.wt;
    e && e.has(n) && e.delete(n);
    const s = t.vt;
    s && s.has(n) && s.delete(n);
    t.bt();
}

function qn(t, n) {
    const e = t?.ht;
    if (e) {
        for (const [t, s] of e.entries()) {
            if (s.has(n)) {
                s.delete(n);
                s.size === 0 && e.delete(t);
            }
        }
    }
}

const Su = (t, n) => {
    const {val: e, set: s, iCtx: o, i} = Wo();
    if (e) {
        return;
    }
    s(1);
    const r = n?.deferUpdates === !1 ? 0 : 8;
    const c = new ku(6 | r, i, o._, t, null);
    s(c);
    const l = o.$;
    const {cn: u} = o;
    const f = Gi(u, () => Eu(c, l, o._));
    Ji(f) && (o.cn = f);
};

const Eu = (t, n, e) => {
    const s = t.Jn;
    if (s) {
        return s;
    }
    t.h &= -5;
    const o = t => n.handleError(t, e);
    let i = null;
    const r = Gi(((t, n) => {
        const e = t.Yn;
        if (e) {
            return e;
        }
        const s = t.an;
        if (!s) {
            return;
        }
        t.an = null;
        try {
            const e = s();
            if (Ji(e)) {
                const s = Promise.resolve(e).then(() => {}, t => {
                    n(t);
                }).finally(() => {
                    t.Yn === s && (t.Yn = void 0);
                });
                t.Yn = s;
                return s;
            }
        } catch (t) {
            n(t);
        }
        return;
    })(t, o), () => {
        const s = xe(n.sn, e, "qTask");
        s.$ = n;
        const r = t._t.getFn(s, () => kn(n, t));
        const c = Ts(t, n);
        const [l] = ((t, n) => {
            let e = null;
            return [ s => {
                if (typeof s == "function") {
                    if (!e) {
                        e = [];
                        t.an = () => {
                            t.an = null;
                            let s = null;
                            for (let t = 0; t < e.length; t++) {
                                const o = e[t];
                                try {
                                    const t = o();
                                    Ji(t) && (s ||= []).push(t.catch(n));
                                } catch (t) {
                                    n(t);
                                }
                            }
                            e = null;
                            if (s?.length) {
                                return Promise.all(s).then(() => {});
                            }
                        };
                    }
                    e.push(s);
                }
            }, e ?? [] ];
        })(t, o);
        const u = {
            track: c,
            cleanup: l
        };
        return Yi(() => r(u), l, s => {
            if (Ji(s)) {
                return s.then(() => {
                    t.Jn === i && (t.Jn = null);
                    return Eu(t, n, e);
                });
            }
            o(s);
        });
    });
    if (Ji(r)) {
        i = r.finally(() => {
            t.Jn === i && (t.Jn = null);
        });
        t.Jn = i;
        return i;
    }
    return r;
};

class ku extends Ur {
    h;
    Ot;
    dt;
    _t;
    an;
    Yn;
    Jn=null;
    constructor(t, n, e, s, o) {
        super();
        this.h = t;
        this.Ot = n;
        this.dt = e;
        this._t = s;
        this.an = o;
    }
}

const Ru = t => t instanceof ku;

function An(t, n) {
    const e = Se(n);
    return qf(e, () => {
        typeof this === "string" && ea(ia(e, this));
        const t = na[0];
        t.h |= 4;
        yn(e, t.dt, 1);
    });
}

const Pu = t => {
    const n = t.resolved;
    if (!n) {
        throw t.resolve();
    }
};

const Tu = t => t instanceof qs;

const qu = (t, n) => {
    t.add(n);
};

const Au = (t, n) => {
    (t.backRef ||= new Set).add(n);
};

const Mu = (t, n) => {
    if (n?.serializationCtx) {
        const e = t.consumer;
        const s = t.property;
        let o = null;
        Ru(e) ? o = e._t : e instanceof Ms ? o = e.Lt : s === ":" && (o = n.getHostProp(e, si));
        o && n.serializationCtx.Ct.add(o);
    }
};

const xu = (t, n) => {
    if (t && (!n || t === n || fd(t))) {
        return t;
    }
    return n;
};

const Iu = (t, n, e) => {
    const s = Oe;
    if (e) {
        const o = e => {
            const o = e.consumer;
            const i = e.property;
            if (Ru(o)) {
                o.h |= 4;
                yn(t, o.dt, 1);
            } else if (o instanceof qs) {
                o.invalidate();
            } else if (i === ":") {
                yn(t, o, 4);
            } else if (i === ".") {
                if (s) {
                    Ut(o, n);
                    yn(t, o, 2);
                }
            } else {
                const r = e.data;
                if (r instanceof Ys) {
                    const e = r.data;
                    const c = {
                        isConst: e.it,
                        scopedStyleIdPrefix: e.j,
                        value: n
                    };
                    if (s) {
                        (function l(t, n, e) {
                            const s = t.props ||= {};
                            let o = s[es];
                            if (!o) {
                                o = new Map;
                                s[es] = o;
                            }
                            o.set(n, e);
                        })(o, i, c);
                    } else {
                        const t = o;
                        let n = t.getProp(es);
                        if (!n) {
                            n = new Map;
                            t.setProp(es, n);
                        }
                        n.set(i, c);
                    }
                    yn(t, o, 16);
                }
            }
        };
        const i = Array.from(e);
        for (let t = 0; t < i.length; t++) {
            o(i[t]);
        }
    }
};

const Nu = t => Be(t) && typeof t[yf] === "function";

const Cu = t => {
    let n = 1;
    switch (t) {
      case "never":
        n |= 8;
        break;

      case "always":
        n |= 16;
        break;
    }
    return n;
};

const Ou = t => {
    t.h |= 4;
};

const ju = t => {
    const n = t;
    return !!n && !(n.h & 1) && n.jt !== Ss;
};

const Lu = [];

function Mn(t) {
    try {
        if (t === null) {
            return "null";
        }
        if (t === void 0) {
            return "undefined";
        }
        if (typeof t === "string") {
            return '"' + t + '"';
        }
        if (typeof t === "number" || typeof t === "boolean") {
            return t + "";
        }
        if (Ru(t)) {
            return `Task(${Mn(t._t)})`;
        }
        if (Ke(t)) {
            return `Qrl(${t.gt})`;
        }
        if (typeof t === "object" || typeof t === "function") {
            if (Lu.includes(t)) {
                return "*";
            }
            Lu.length;
            try {
                Lu.push(t);
                if (Array.isArray(t)) {
                    return dl(t) ? "(" + (bl(t, Ze, null) || "vnode") + ")" : t.map(Mn);
                }
                if (Tu(t)) {
                    return t instanceof Js ? "WrappedSignal" : t instanceof Ms ? "ComputedSignal" : "Signal";
                }
                if (zu(t)) {
                    return "Store";
                }
                if (Zs(t)) {
                    return Fu(t);
                }
                if (dl(t)) {
                    return "(" + (bl(t, Ze, null) || "vnode") + ")";
                }
            } finally {
                Lu.pop();
            }
        }
    } catch (t) {
        console.error("ERROR in qwikDebugToString", t);
        return "*error*";
    }
    return t;
}

const Fu = t => {
    if (Zs(t)) {
        if (typeof t.type === "function") {
            const n = t.type[ba];
            if (n) {
                const [t] = n;
                return "Component(" + t.gt + ")";
            }
            return "Function(" + t.type.name + ")";
        }
        let n = "<" + t.type;
        if (t.props) {
            const e = Object.entries(t.props);
            for (let t = 0; t < e.length; t++) {
                const [s, o] = e[t];
                n += " " + s + "=" + Mn(o);
            }
            const s = t.children;
            if (s != null) {
                n += ">";
                if (Array.isArray(s)) {
                    for (let t = 0; t < s.length; t++) {
                        const e = s[t];
                        n += Fu(e);
                    }
                } else {
                    n += Fu(s);
                }
                n += "</" + t.type + ">";
            } else {
                n += "/>";
            }
        }
        return n;
    }
    return t + "";
};

const Du = t => t[Rs];

const Xu = t => t?.[ks] || null;

const Wu = (t, n) => {
    const e = Du(t);
    e && e.force(n);
};

const Vu = (t, n) => {
    const e = Du(t);
    if (e) {
        return (e.ht?.get(n)?.size ?? 0) > 0;
    }
    return !1;
};

const Uu = t => Xu(t) || t;

const zu = t => ks in t;

function xn(t, n, e) {
    return new Proxy(n, new Qu(e, t || null));
}

const Bu = (t, n, e) => {
    if (ze(t) && e) {
        let s = e.yt.get(t);
        if (!s) {
            s = xn(e, t, n);
            e.yt.set(t, s);
        }
        return s;
    }
    return t;
};

class Qu {
    h;
    $;
    ht=void 0;
    constructor(t, n) {
        this.h = t;
        this.$ = n;
    }
    toString() {
        return "[Store]";
    }
    force(t) {
        const n = Xu(this);
        Iu(this.$, this, Cn(n, t, this.ht));
    }
    get(t, n) {
        if (typeof n === "symbol") {
            if (n === ks) {
                return t;
            }
            if (n === Rs) {
                return this;
            }
            return t[n];
        }
        const e = If();
        const s = t[n];
        if (e) {
            if (this.$ === null) {
                if (!e.$) {
                    return s;
                }
                this.$ = e.$;
            }
            const o = e.un;
            o && In(t, Array.isArray(t) ? Ps : n, this, o, e.$);
        }
        if (n === "toString" && s === Object.prototype.toString) {
            return this.toString;
        }
        const o = this.h;
        if (o & 1 && Be(s) && !Object.isFrozen(s) && !zu(s) && !Object.isFrozen(t)) {
            return Bu(s, this.h, this.$);
        }
        return s;
    }
    set(t, n, e) {
        if (typeof n === "symbol") {
            t[n] = e;
            return !0;
        }
        const s = this.h & 1 ? Uu(e) : e;
        if (n in t) {
            const e = t[n];
            s !== e && Nn(n, s, t, this);
        } else {
            Nn(n, s, t, this);
        }
        return !0;
    }
    deleteProperty(t, n) {
        if (typeof n != "string" || !delete t[n]) {
            return !1;
        }
        Array.isArray(t) || Iu(this.$, this, Cn(t, n, this.ht));
        return !0;
    }
    has(t, n) {
        if (n === ks) {
            return !0;
        }
        if (typeof n === "string") {
            const e = If();
            if (e) {
                const s = e.un;
                s && In(t, Array.isArray(t) ? Ps : n, this, s, e.$);
            }
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    ownKeys(t) {
        const n = If();
        const e = n?.un;
        e && In(t, Ps, this, e, n.$);
        return Reflect.ownKeys(t);
    }
    getOwnPropertyDescriptor(t, n) {
        const e = Reflect.getOwnPropertyDescriptor(t, n);
        if (Array.isArray(t) || typeof n === "symbol") {
            return e;
        }
        if (e && !e.configurable) {
            return e;
        }
        return {
            enumerable: !0,
            configurable: !0
        };
    }
}

function In(t, n, e, s, o) {
    const i = e.ht ||= new Map;
    let r = i.get(n);
    if (!r) {
        r = new Set;
        i.set(n, r);
    }
    const c = Ce;
    const l = __EXPERIMENTAL__.suspense && e instanceof Qu && c;
    qu(r, s);
    Au(s, t);
    if (c) {
        const r = xu(o, e.$);
        l && r?.Sn?.(t, s, n, i);
        Mu(s, r);
    }
}

function Nn(t, n, e, s) {
    e[t] = n;
    const o = Cn(e, t, s.ht);
    o && Iu(s.$, s, o);
}

function Cn(t, n, e) {
    let s;
    if (e) {
        if (Array.isArray(t)) {
            for (const t of e.values()) {
                s ||= new Set;
                for (const n of t) {
                    s.add(n);
                }
            }
        } else {
            s = e.get(n);
        }
    }
    const o = e?.get(Ps);
    if (o) {
        s ||= new Set;
        for (const t of o) {
            s.add(t);
        }
    }
    return s;
}

const Hu = Symbol();

const Ju = [ void 0, null, !0, !1, "", ds, ps, Ss, Ps, hs, _o, vo, NaN, Infinity, -Infinity, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER - 1, Number.MIN_SAFE_INTEGER, ":", ".", "id", "ref" ];

const Yu = [ "undefined", "null", "true", "false", "''", "EMPTY_ARRAY", "EMPTY_OBJ", "NEEDS_COMPUTATION", "STORE_ALL_PROPS", "_UNINITIALIZED", "Slot", "Fragment", "NaN", "Infinity", "-Infinity", "MAX_SAFE_INTEGER", "MAX_SAFE_INTEGER-1", "MIN_SAFE_INTEGER", "':'", "'.'", "'id'", "'ref'" ];

const Gu = [ "Plain", "RootRef", "ForwardRef", "Constant", "Array", "Object", "URL", "Date", "Regex", "QRL", "VNode", "RefVNode", "BigInt", "URLSearchParams", "ForwardRefs", "TemporalDuration", "TemporalInstant", "TemporalPlainDate", "TemporalPlainDateTime", "TemporalPlainMonthDay", "TemporalPlainTime", "TemporalPlainYearMonth", "TemporalZonedDateTime", "Error", "Promise", "Set", "Map", "Uint8Array", "Task", "Component", "Signal", "WrappedSignal", "ComputedSignal", "AsyncSignal", "SerializerSignal", "Store", "FormData", "JSXNode", "PropsProxy", "SubscriptionData", "EffectSubscription", "SubscriptionPatch", "SubscriptionDataConstTrue", "SubscriptionDataConstFalse", "EffectSubscriptionNoData" ];

function On(t, n, e) {
    let s = n.gt;
    let o = n.St;
    const i = mr();
    if (i) {
        const t = i.chunkForSymbol(s, o);
        if (t) {
            o = t[1];
            s = t[0];
        }
    }
    const r = (t => Ke(t) && t.gt == Ge)(n);
    if (r) {
        const e = n.resolved;
        o = "";
        s = t.Et(null, 0, e) + "";
    } else {
        o || (o = t.kt(n.ot));
        if (!o) {
            throw Ye(14, [ n.gt ]);
        }
        o.startsWith("./") && (o = o.slice(2));
    }
    const c = n.getCaptured();
    let l = null;
    if (c && c.length > 0) {
        let n = 0;
        let e = "";
        for (let s = 0; s < c.length; s++) {
            const o = t.Rt(c[s]);
            const i = o - n;
            n = o;
            e += (s === 0 ? "" : " ") + i;
        }
        l = e;
    }
    if (e) {
        return [ o, s, l ];
    }
    let u = `${o}#${s}`;
    l && (u += "#" + l);
    return u;
}

function jn(t, n, e, s) {
    return la(t, n, null, null, e, s);
}

function Ln(t, n) {
    const e = t.indexOf("#");
    const s = t.indexOf("#", e + 1);
    const o = t.slice(0, e);
    const i = s === -1 ? t.slice(e + 1) : t.slice(e + 1, s);
    const r = s !== -1 && s + 1 < t.length ? t.slice(s + 1) : null;
    return jn(o, i, r, n);
}

class Ku {
    rootId;
    subscriptions;
    constructor(t = 0, n = new Set) {
        this.rootId = t;
        this.subscriptions = n;
    }
}

class Zu {
    Kn;
    Zn=0;
    Tt=[];
    te=0;
    ne=new Set;
    ee=new Map;
    ie;
    re=new Map;
    se=0;
    Bt;
    oe=typeof Temporal !== "undefined";
    constructor(t) {
        this.Kn = t;
        this.Bt = t.Bt;
    }
    async serialize() {
        const t = this.se;
        this.se = 0;
        try {
            await this.outputRoots();
        } finally {
            this.se = t;
        }
    }
    async serializePatch(t, n, e, s = t) {
        const o = this.se;
        this.se = s;
        this.Bt.write(Lr);
        this.Kn.le = 0;
        try {
            this.Bt.write(t + "");
            this.Bt.write(Dr);
            this.Bt.write(Lr);
            await this.outputSelectedRoots(n);
            this.Bt.write(Fr);
            const s = this.getForwardRefsPayload();
            this.Kn.le = s?.length ?? 0;
            if (s || e !== void 0) {
                this.Bt.write(Dr);
                s ? this.outputForwardRefsArray(s) : this.Bt.write("0");
            }
            if (e !== void 0) {
                this.Bt.write(Dr);
                if (typeof e === "number") {
                    this.writeRootRef(e);
                } else if (typeof e === "string") {
                    this.outputString(e);
                } else {
                    this.Bt.write(jr);
                    this.writeRootRefPath(e);
                    this.Bt.write(jr);
                }
            }
        } finally {
            this.se = o;
        }
        this.Bt.write(Fr);
    }
    ue(t) {
        this.Bt = t;
    }
    outputArray(t, n, e) {
        this.Bt.write(Lr);
        let s = !1;
        let o;
        if (n) {
            o = t.length;
        } else {
            o = t.length - 1;
            for (;o >= 0 && t[o] === void 0; ) {
                o--;
            }
            o++;
        }
        for (let n = 0; n < o; n++) {
            s ? this.Bt.write(Dr) : s = !0;
            e(t[n], n);
        }
        this.Bt.write(Fr);
    }
    stringNeedsJsonEscape$(t) {
        for (let n = 0; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 32 || e === 34 || e === 92) {
                return !0;
            }
        }
        return !1;
    }
    maybeNumericObjectKey$(t) {
        if (t.length === 0 || t.length >= 8) {
            return t;
        }
        let n = 0;
        if (t.charCodeAt(0) === 45) {
            if (t.length === 1) {
                return t;
            }
            n = 1;
        }
        const e = t.charCodeAt(n);
        if (e < 49 || e > 57) {
            return t;
        }
        for (n++; n < t.length; n++) {
            const e = t.charCodeAt(n);
            if (e < 48 || e > 57) {
                return t;
            }
        }
        return +t;
    }
    rebaseQrlCaptureDeltas$(t, n) {
        let e = 0;
        let s = t;
        const o = n.split(" ");
        for (let t = 0; t < o.length; t++) {
            const n = e + +o[t];
            o[t] = n - s + "";
            e = n;
            s = n;
        }
        return o.join(" ");
    }
    outputShortStringConstant$(t) {
        switch (t) {
          case ":":
            this.output(3, 18);
            return !0;

          case ".":
            this.output(3, 19);
            return !0;

          case "id":
            this.output(3, 20);
            return !0;

          case "ref":
            this.output(3, 21);
            return !0;

          default:
            return !1;
        }
    }
    outputString(t) {
        const n = this.stringNeedsJsonEscape$(t) ? JSON.stringify(t) : jr + t + jr;
        let e = -1;
        let s = 0;
        for (;(e = n.indexOf("</", s)) !== -1; ) {
            this.Bt.write(n.slice(s, e));
            this.Bt.write("<\\/");
            s = e + 2;
        }
        this.Bt.write(s === 0 ? n : n.slice(s));
    }
    writeRootRef(t) {
        this.Bt.writeRootRef(t);
    }
    writeRootRefPath(t) {
        this.Bt.writeRootRefPath(t);
    }
    writeRootRefDelta(t, n) {
        this.Bt.writeRootRefDelta(t, n);
    }
    outputStringChunks(t) {
        this.Bt.write(jr);
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            typeof e === "string" ? this.Bt.write(e) : typeof e === "number" ? this.writeRootRef(e) : "base" in e ? this.writeRootRefDelta(e.id, e.base) : this.writeRootRefPath(e.path);
        }
        this.Bt.write(jr);
    }
    output(t, n, e) {
        if (t === 1) {
            this.Bt.write(t + Dr);
            if (typeof n === "number") {
                this.writeRootRef(n);
            } else if (typeof n === "string") {
                this.outputString(n);
            } else {
                this.Bt.write(jr);
                this.writeRootRefPath(n);
                this.Bt.write(jr);
            }
        } else if (t === 9 && Array.isArray(n)) {
            this.Bt.write(t + Dr);
            this.outputStringChunks(n);
        } else if (typeof n === "number") {
            this.Bt.write(t + Dr + n);
        } else if (typeof n === "string") {
            this.Bt.write(t + Dr);
            this.outputString(n);
        } else {
            this.Bt.write(t + Dr);
            this.outputArray(n, !!e, (t, n) => {
                this.writeValue(t, n);
            });
        }
    }
    getSeenRefOrOutput(t, n, e) {
        let s = this.Kn.getSeenRef(t);
        const o = !e && this.ee.get(t);
        if (s) {
            s.ie && this.isSeenInStreamedRoot(s) && (s = this.Kn.ce(t));
        } else {
            if (e) {
                return !0;
            }
            if (typeof o !== "number") {
                return this.Kn.fe(t, this.ie, n);
            }
            s = this.Kn.Rt(t, !0);
        }
        if (s.ie) {
            if (this.ie) {
                this.Kn.ae(s, t);
            } else {
                this.Kn.ae(s, t, n);
                t = this.Kn.he[n];
            }
        }
        if (typeof o === "number") {
            this.Tt[o] = s.Ot;
            this.ee.delete(t);
        }
        const i = t instanceof cc ? t.de : s.Ot;
        if (!this.ie && i === n) {
            return s;
        }
        this.output(1, i);
    }
    isSeenInStreamedRoot(t) {
        for (;t.ie; ) {
            t = t.ie;
        }
        return t.Ot < this.se;
    }
    writeValue(t, n) {
        if (df(t)) {
            this.output(3, 0);
        } else {
            switch (typeof t) {
              case "undefined":
                this.output(3, 0);
                break;

              case "boolean":
                this.output(3, t ? 2 : 3);
                break;

              case "number":
                Number.isNaN(t) ? this.output(3, 12) : Number.isFinite(t) ? t === Number.MAX_SAFE_INTEGER ? this.output(3, 15) : t === Number.MAX_SAFE_INTEGER - 1 ? this.output(3, 16) : t === Number.MIN_SAFE_INTEGER ? this.output(3, 17) : this.output(0, t) : this.output(3, t < 0 ? 14 : 13);
                break;

              case "string":
                if (t.length === 0) {
                    this.output(3, 4);
                } else {
                    if (this.outputShortStringConstant$(t)) {
                        break;
                    }
                    (t.length < 4 || this.getSeenRefOrOutput(t, n)) && this.output(0, t);
                }
                break;

              case "bigint":
                (t < 1e4 && t > -1e3 || this.getSeenRefOrOutput(t, n)) && this.output(12, t.toString());
                break;

              case "symbol":
                if (t === Ss) {
                    this.output(3, 7);
                } else if (t === Ps) {
                    this.output(3, 8);
                } else if (t === hs) {
                    this.output(3, 9);
                } else {
                    if (t !== Hu) {
                        throw Ye(20, [ typeof t ]);
                    }
                    this.output(3, 0);
                }
                break;

              case "function":
                if (t === _o) {
                    this.output(3, 10);
                } else if (t === vo) {
                    this.output(3, 11);
                } else if (Ke(t)) {
                    if (this.getSeenRefOrOutput(t, n)) {
                        const [n, e, s] = On(this.Kn, t, !0);
                        let o;
                        if (n !== "") {
                            const i = this.Kn.Rt(n);
                            const r = this.Kn.Rt(e);
                            const c = s ? this.rebaseQrlCaptureDeltas$(r, s) : null;
                            o = [ i, "#", {
                                id: r,
                                base: i
                            } ];
                            if (s) {
                                let t = 0;
                                let n = r;
                                let e = 0;
                                o.push("#");
                                for (let i = 0; i <= s.length; i++) {
                                    if (i === s.length || s[i] === " ") {
                                        if (i > e) {
                                            const r = t + +s.slice(e, i);
                                            e > 0 && o.push(" ");
                                            o.push({
                                                id: r,
                                                base: n
                                            });
                                            t = r;
                                            n = r;
                                        }
                                        e = i + 1;
                                    }
                                }
                            }
                            const l = `${i}#${r - i}${c ? "#" + c : ""}`;
                            const u = this.re.get(l);
                            if (u) {
                                const t = this.Kn.Rt(u);
                                this.output(1, t);
                                return;
                            }
                            this.re.set(l, t);
                        } else {
                            o = +e;
                        }
                        this.output(9, o);
                    }
                } else {
                    if (!_a(t)) {
                        throw Ye(34, [ t.toString() ]);
                    }
                    {
                        const [n] = t[ba];
                        this.Kn.pe.add(n.gt);
                        this.output(29, [ n ]);
                    }
                }
                break;

              case "object":
                if (t === ds) {
                    this.output(3, 5);
                } else if (t === ps) {
                    this.output(3, 6);
                } else if (t === null) {
                    this.output(3, 1);
                } else if (t instanceof cc) {
                    this.output(1, t.de);
                } else {
                    const e = this.getSeenRefOrOutput(t, n);
                    if (e) {
                        const n = this.ie;
                        this.ie = e;
                        this.writeObjectValue(t);
                        this.ie = n;
                    }
                }
                break;

              default:
                throw Ye(20, [ typeof t ]);
            }
        }
    }
    writeObjectValue(t) {
        if (gs(t)) {
            const n = t[cs];
            this.output(38, [ lc(n), n.varProps, n.constProps, t[fs].ht ]);
        } else if (t instanceof Ys) {
            const {j: n, it: e} = t.data;
            n === null ? this.output(e ? 42 : 43, 0) : this.output(39, [ n, e ]);
        } else if (t instanceof Es) {
            t.data === null ? this.output(44, [ t.consumer, t.property ]) : this.output(40, [ t.consumer, t.property, t.data ]);
        } else if (t instanceof Ku) {
            this.output(41, [ t.rootId, t.subscriptions ]);
        } else if (zu(t)) {
            const n = Du(t);
            const e = Xu(t);
            const s = n.h;
            const o = n.ht;
            const i = [];
            for (const t in e) {
                const n = e[t];
                const s = this.Kn.yt.get(n);
                s && i.push(s);
            }
            const r = [ e, s, o, ...i ];
            for (;r[r.length - 1] === void 0; ) {
                r.pop();
            }
            this.output(35, r);
        } else if (Nu(t)) {
            const n = t[yf](t);
            if (Ji(n)) {
                const t = this.resolvePromise(n, (t, n) => new tc(34, t, n, void 0, void 0));
                this.output(2, t);
            } else {
                const t = this.ie.Ot;
                this.ie = this.ie.ie;
                this.writeValue(n, t);
            }
        } else if (function n(t) {
            const n = Object.getPrototypeOf(t);
            return n == null || n === Object.prototype || n === Array.prototype;
        }(t)) {
            if (Array.isArray(t)) {
                this.output(4, t);
            } else {
                const n = [];
                for (const e in t) {
                    if (Object.prototype.hasOwnProperty.call(t, e)) {
                        const s = t[e];
                        df(s) || n.push(this.maybeNumericObjectKey$(e), s);
                    }
                }
                this.output(5, n.length ? n : 0);
            }
        } else if (this.Kn.$e(t)) {
            this.Kn.ye(t.me, 16);
            this.output(11, t.me.id);
        } else if (t instanceof qs) {
            if (t instanceof Is) {
                const n = function e(t, n) {
                    if (n === Ss) {
                        return n;
                    }
                    return Gi(t.Lt.resolved || t.Lt.resolve(), t => {
                        let e;
                        typeof t === "function" && (t = t());
                        t.serialize ? e = t.serialize(n) : typeof n === "object" && yf in n && (e = n[yf](n));
                        e === void 0 && (e = Ss);
                        return e;
                    });
                }(t, t.jt);
                if (Ji(n)) {
                    const e = this.resolvePromise(n, (n, e) => new tc(34, n, e, t.ht, t.Lt));
                    this.output(2, e);
                } else {
                    this.output(34, [ t.Lt, t.ht, n ]);
                }
                return;
            }
            if (t instanceof Js) {
                this.output(31, [ ...Fn(this.Kn, t), t.h, t._, ...t.ht || [] ]);
            } else if (t instanceof Ms) {
                let n = t.jt;
                const e = t.h & 16;
                const s = t.h & 8;
                const o = t.h & 1;
                const i = df(t.jt);
                const r = !!(t.h & 512);
                const c = r && !!t.Ft;
                const l = r && t.qt !== 0 ? t.qt : void 0;
                const u = r && t.Xt !== 1 ? t.Xt : void 0;
                const f = r && t.Vt !== 0 ? t.Vt : void 0;
                const a = r && t.h & -25 || void 0;
                o || i || c ? n = Ss : e ? n = t.jt : s && (n = Ss);
                const h = [ t.Lt, t.ht ];
                if (r) {
                    h.push(t.wt, t.vt, t.Ft);
                    h.push(a || void 0);
                }
                n === Ss && l === void 0 && u === void 0 && f === void 0 || h.push(n === void 0 ? Hu : n);
                if (r) {
                    h.push(l);
                    h.push(u);
                    h.push(f);
                }
                this.output(r ? 33 : 32, h);
            } else {
                const n = t.jt;
                const e = [ n === void 0 ? Hu : n ];
                t.ht && e.push(...t.ht);
                this.output(30, e);
            }
        } else if (t instanceof URL) {
            this.output(6, t.href);
        } else if (t instanceof Date) {
            this.output(7, Number.isNaN(t.valueOf()) ? "" : t.valueOf());
        } else if (t instanceof RegExp) {
            this.output(8, t.toString());
        } else if (t instanceof Error) {
            const n = [ t.message ];
            n.push(...Object.entries(t).flat());
            this.output(23, n);
        } else if (this.Kn.we(t)) {
            const n = this.Kn.Rt(t);
            this.Kn.ve(t, xi, n);
            this.output(10, t.id);
            const e = t.vnodeData;
            if (e) {
                nc(e, t => {
                    this.Kn.Rt(t);
                });
                this.Kn.ye(t, 16);
            }
            if (t.children) {
                const n = t.children.length;
                for (let e = 0; e < n; e++) {
                    const n = t.children[e];
                    this.Kn.ye(n, 16);
                }
            }
        } else if (typeof FormData !== "undefined" && t instanceof FormData) {
            const n = [];
            for (const [e, s] of t.entries()) {
                typeof s === "string" && n.push(e, s);
            }
            this.output(36, n);
        } else if (t instanceof URLSearchParams) {
            this.output(13, t.toString());
        } else if (t instanceof Set) {
            this.output(25, [ ...t.values() ]);
        } else if (t instanceof Map) {
            const n = [];
            for (const [e, s] of t.entries()) {
                n.push(e, s);
            }
            this.output(26, n);
        } else if (Zs(t)) {
            const n = [ t.type, t.key, t.varProps, t.constProps, t.children, t.toSort || void 0 ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(37, n);
        } else if (t instanceof ku) {
            const n = [ t._t, t.h, t.Ot, t.dt ];
            for (;n[n.length - 1] === void 0; ) {
                n.pop();
            }
            this.output(28, n);
        } else if (Ji(t)) {
            const n = this.resolvePromise(t, (t, n) => new tc(24, t, n));
            this.output(2, n);
        } else if (t instanceof tc) {
            if (t.be === 34) {
                if (t._t) {
                    this.output(34, [ t._t, t.ht, t._e ]);
                } else {
                    if (!t.ge) {
                        console.error(t._e);
                        throw Ye(33);
                    }
                    {
                        const n = this.ie.Ot;
                        this.ie = this.ie.ie;
                        this.writeValue(t._e, n);
                    }
                }
            } else {
                this.output(24, [ t.ge, t._e ]);
            }
        } else if (t instanceof Uint8Array) {
            let n = "";
            const e = t.length;
            for (let s = 0; s < e; s++) {
                n += String.fromCharCode(t[s]);
            }
            const s = btoa(n).replace(/=+$/, "");
            this.output(27, s);
        } else if (t instanceof oc) {
            const n = t.Se;
            if (this.getSeenRefOrOutput(n, this.ie.Ot, !0)) {
                let t = this.ee.get(n);
                if (t === void 0) {
                    t = this.te++;
                    this.ee.set(n, t);
                    this.Tt[t] = -1;
                }
                this.output(2, this.getForwardRefId(t));
            }
        } else if (this.oe && t instanceof Temporal.Duration) {
            this.output(15, t.toJSON());
        } else if (this.oe && t instanceof Temporal.Instant) {
            this.output(16, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDate) {
            this.output(17, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainDateTime) {
            this.output(18, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainMonthDay) {
            this.output(19, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainTime) {
            this.output(20, t.toJSON());
        } else if (this.oe && t instanceof Temporal.PlainYearMonth) {
            this.output(21, t.toJSON());
        } else if (this.oe && t instanceof Temporal.ZonedDateTime) {
            this.output(22, t.toJSON());
        } else {
            if (!dl(t)) {
                throw Ye(20, [ typeof t ]);
            }
            this.output(3, 0);
        }
    }
    resolvePromise(t, n) {
        const e = this.te++;
        t.then(s => {
            this.ne.delete(t);
            this.Tt[e] = this.Kn.Rt(n(!0, s));
        }).catch(s => {
            this.ne.delete(t);
            this.Tt[e] = this.Kn.Rt(n(!1, s));
        });
        this.ne.add(t);
        return this.getForwardRefId(e);
    }
    getForwardRefId(t) {
        return this.Kn.Ee + t;
    }
    async outputPendingRoots() {
        let t = 0;
        const {he: n} = this.Kn;
        for (;this.Zn < n.length || this.ne.size; ) {
            let e = t > 0;
            for (;this.Zn < n.length; this.Zn++) {
                e ? this.Bt.write(Dr) : e = !0;
                this.writeValue(n[this.Zn], this.Zn);
                t++;
            }
            if (this.ne.size) {
                try {
                    await Promise.race(this.ne);
                } catch {}
            }
        }
        return t;
    }
    async outputSelectedRoots(t) {
        let n = !1;
        let e = 0;
        for (;e < t.length || this.ne.size; ) {
            if (e < t.length) {
                n ? this.Bt.write(Dr) : n = !0;
                const s = t[e++];
                this.writeValue(this.Kn.he[s], s);
                continue;
            }
            try {
                await Promise.race(this.ne);
            } catch {}
        }
    }
    getForwardRefsPayload() {
        let t = this.Tt.length - 1;
        for (;t >= 0 && this.Tt[t] === -1; ) {
            t--;
        }
        if (t < 0) {
            return null;
        }
        return t === this.Tt.length - 1 ? this.Tt : this.Tt.slice(0, t + 1);
    }
    outputForwardRefsArray(t) {
        this.outputArray(t, !0, t => {
            if (typeof t === "string") {
                this.outputString(t);
            } else if (Array.isArray(t)) {
                this.Bt.write(jr);
                this.writeRootRefPath(t);
                this.Bt.write(jr);
            } else {
                this.writeRootRef(t);
            }
        });
    }
    async outputRoots() {
        this.Bt.write(Lr);
        const t = await this.outputPendingRoots();
        const n = this.getForwardRefsPayload();
        this.Kn.ke = this.Kn.he.length;
        this.Kn.Re = !!n;
        const e = n?.length ?? 0;
        if (n) {
            t > 0 && this.Bt.write(Dr);
            this.Bt.write(14 + Dr);
            this.outputForwardRefsArray(n);
        }
        this.Bt.write(Fr);
        this.Kn.Pe = this.Kn.he.length + (this.Kn.Re ? 1 : 0);
        this.Kn.le = e;
    }
}

class tc {
    be;
    ge;
    _e;
    ht;
    _t;
    constructor(t, n, e, s, o) {
        this.be = t;
        this.ge = n;
        this._e = e;
        this.ht = s;
        this._t = o;
    }
}

const nc = (t, n) => {
    const e = t.length;
    for (let s = 0; s < e; s++) {
        const e = t[s];
        if (ec(e)) {
            for (const t in e) {
                const s = e[t];
                if (s == null || typeof s === "string" || typeof s === "number" && t === xi || t === Ni && (Cr(s) || ic(e, s))) {
                    continue;
                }
                n(s);
            }
        }
    }
};

const ec = t => typeof t === "object" && t !== null && !Cr(t);

const ic = (t, n, e = !1) => {
    if (e || !Object.prototype.hasOwnProperty.call(t, si)) {
        return !1;
    }
    const s = n[cs];
    return Cr(s.varProps) && !rc(n) && !sc(t[mi]);
};

const rc = t => !!t[fs].ht?.size;

const sc = t => t instanceof Map && t.has(":");

function Fn(t, n) {
    n.Pt && n.Pt[0] === "{" && (n.Pt = `(${n.Pt})`);
    const e = t.Et(n.Pt, n.ct.length, n.ut);
    return [ e, n.ct ];
}

class oc {
    Se;
    constructor(t) {
        this.Se = t;
    }
}

const lc = t => new oc(t);

let uc = () => !1;

class cc {
    de;
    constructor(t) {
        this.de = t;
    }
}

class fc {
    NodeConstructor;
    DomRefConstructor;
    kt;
    ve;
    yt;
    Bt;
    Te=new Map;
    qe=new Map;
    Ae=0;
    Me=[];
    he=[];
    xe=[];
    Ie;
    Ee=0;
    Pe=0;
    le=0;
    ke=0;
    Re=!1;
    At=new Set;
    Ct=new Set;
    Nt=new Set;
    pe=new Set;
    Ne;
    ye=(t, n) => {
        t.vnodeData[0] |= n;
    };
    constructor(t, n, e, s, o, i) {
        this.NodeConstructor = t;
        this.DomRefConstructor = n;
        this.kt = e;
        this.ve = s;
        this.yt = o;
        this.Bt = i;
        this.Ne = new Zu(this);
    }
    async zt() {
        await this.Ne.serialize();
    }
    async Ce(t, n, e, s) {
        await this.Ne.serializePatch(t, n, e, s);
    }
    ue(t) {
        this.Bt = t;
        this.Ne.ue(t);
    }
    getSeenRef(t) {
        return this.Te.get(t);
    }
    fe(t, n, e) {
        const s = {
            Ot: e,
            ie: n
        };
        this.Te.set(t, s);
        return s;
    }
    Oe(t) {
        const n = [];
        for (;t.ie; ) {
            n.unshift(t.Ot);
            t = t.ie;
        }
        n.unshift(t.Ot);
        return n;
    }
    ae(t, n, e) {
        const s = this.Oe(t);
        const o = e === void 0;
        e === void 0 && (e = this.he.length);
        this.he[e] = new cc(s);
        o && (this.xe[e] = n);
        t.ie = null;
        t.Ot = e;
        o && this.Ie?.(e, this.he[e], n);
    }
    Rt(t, n = !1) {
        let e = this.Te.get(t);
        let s;
        if (e) {
            e.ie && this.ae(e, t);
            s = e.Ot;
        } else {
            s = this.he.length;
            e = {
                Ot: s
            };
            this.Te.set(t, e);
            this.he.push(t);
            this.xe.push(t);
            this.Ie?.(s, t, t);
        }
        return n ? e : s;
    }
    ce(t) {
        const n = this.he.length;
        const e = {
            Ot: n
        };
        this.Te.set(t, e);
        this.he.push(t);
        this.xe.push(t);
        this.Ie?.(n, t, t);
        return e;
    }
    je(t, n) {
        const e = this.he.length;
        const s = {
            Ot: e
        };
        this.Te.set(n, s);
        this.he.push(t);
        this.xe.push(n);
        return e;
    }
    we(t) {
        return !!this.NodeConstructor && t instanceof this.NodeConstructor;
    }
    $e(t) {
        return !!this.DomRefConstructor && t instanceof this.DomRefConstructor;
    }
    Le(t) {
        const n = this.Te.get(t);
        return n && (n.ie ? void 0 : n.Ot);
    }
    Et(t, n, e) {
        const s = t == null;
        s && (t = e.serialized || e.toString());
        let o = this.qe.get(t);
        if (o === void 0) {
            o = this.Ae + this.Me.length;
            this.qe.set(t, o);
            if (s) {
                this.Me.push(t);
            } else {
                let e = "(";
                for (let t = 0; t < n; t++) {
                    e += (t == 0 ? "p" : ",p") + t;
                }
                this.Me.push(e += ")=>" + t);
            }
        }
        return o;
    }
    Fe(t, n) {
        this.Ae = t;
        if (n) {
            this.qe.clear();
            for (let t = 0; t < n.length; t++) {
                this.qe.set(n[t], t);
            }
        }
    }
}

const ac = (t, n, e, s, o, i) => {
    if (!i) {
        const t = [];
        i = Object.assign(Or(n => {
            t.push(n);
        }), {
            toString: () => t.join("")
        });
    }
    uc = n ? t => t instanceof n : () => !1;
    return new fc(t, n, e, s, o, i);
};

const hc = (t, n) => t[n];

const dc = (t, n = new WeakSet) => {
    const e = typeof Temporal !== "undefined";
    if (t == null || typeof t === "string" || typeof t === "number" || typeof t === "boolean" || typeof t === "bigint") {
        return !0;
    }
    if (typeof t === "object") {
        if (n.has(t)) {
            return !0;
        }
        n.add(t);
        const s = Object.getPrototypeOf(t);
        zu(t) && (t = Xu(t));
        if (s == Object.prototype) {
            for (const e in t) {
                if (!dc(jf(hc, t, e), n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (s == Array.prototype) {
            for (let e = 0; e < t.length; e++) {
                if (!(e in t)) {
                    return !1;
                }
                if (!dc(t[e], n)) {
                    return !1;
                }
            }
            return !0;
        }
        if (Ru(t)) {
            return !0;
        }
        if (gs(t)) {
            return !0;
        }
        if (Ji(t)) {
            return !0;
        }
        if (Zs(t)) {
            return !0;
        }
        if (Nu(t)) {
            return !0;
        }
        if (t instanceof Error) {
            return !0;
        }
        if (t instanceof URL) {
            return !0;
        }
        if (t instanceof Date) {
            return !0;
        }
        if (e && t instanceof Temporal.Duration) {
            return !0;
        }
        if (e && t instanceof Temporal.Instant) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDate) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainDateTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainMonthDay) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainTime) {
            return !0;
        }
        if (e && t instanceof Temporal.PlainYearMonth) {
            return !0;
        }
        if (e && t instanceof Temporal.ZonedDateTime) {
            return !0;
        }
        if (t instanceof RegExp) {
            return !0;
        }
        if (t instanceof URLSearchParams) {
            return !0;
        }
        if (t instanceof FormData) {
            return !0;
        }
        if (t instanceof Set) {
            return !0;
        }
        if (t instanceof Map) {
            return !0;
        }
        if (t instanceof Uint8Array) {
            return !0;
        }
        if (t instanceof Ys) {
            return !0;
        }
        if (uc?.(t)) {
            return !0;
        }
    } else if (typeof t === "function") {
        if (Ke(t) || _a(t) || t === _o || t === vo) {
            return !0;
        }
    } else if (t === hs || t === Ss || t === Ps) {
        return !0;
    }
    return !1;
};

const pc = (t, n) => {
    let e = dl(t) ? Sn.call(t, 1, "", !0).replaceAll(/\n.*/gm, "") : typeof t === "function" ? t + "" : (t => {
        const n = new WeakSet;
        return JSON.stringify(t, (t, e) => {
            if (Be(e)) {
                if (n.has(e)) {
                    return `[Circular ${e.constructor.name}]`;
                }
                n.add(e);
            }
            return e;
        }, 2);
    })(t);
    e.length > 500 && (e = e.slice(0, 500) + '"...');
    e = e.replace(/\n/g, "\n" + n);
    return e.includes("\n") ? e = `\n${n}${e}` : e;
};

let $c = !1;

const yc = (t, n = !1, e = "", s = 20) => {
    const o = n ? "[31m" : "";
    const i = n ? "[0m" : "";
    const r = e === "";
    const c = [];
    for (let r = 0; r < t.length; r++) {
        if (s && r > 2 * s) {
            c.push("...");
            break;
        }
        const l = t[r];
        let u = t[++r];
        if (l === 0) {
            const t = typeof u !== "number" && typeof u !== "string";
            t && ($c = !0);
            const n = `{${Be(u) ? u.constructor.name : typeof u}}`;
            c.push(`${o}${n}${i} ${pc(u, e + "  ")}`);
        } else {
            if (l === 3) {
                u = wc(u);
            } else if (typeof u === "string") {
                u = JSON.stringify(u);
                u.length > 120 && (u = u.slice(0, 120) + '"...');
            } else {
                l === 14 ? u = `[\n${e}  ${u.join(`\n${e}  `)}\n${e}]` : Array.isArray(u) && (u = u.length ? `[\n${yc(u, n, e + "  ")}\n${e}]` : "[]");
            }
            c.push(`${o}${mc(l)}${i} ${u}`);
        }
    }
    const l = c.map((t, n) => `${e}${r ? n + " " : ""}${t}`).join("\n");
    if (r) {
        const n = $c ? "" : `(${JSON.stringify(t).length} chars)`;
        $c = !1;
        return `\n${l}\n${n}`;
    }
    return l;
};

const mc = t => Gu[t] || `Unknown(${t})`;

const wc = t => Yu[t] || `Unknown(${t})`;

function Dn(t, n, e, s = 0) {
    const o = Xn(t, n, s);
    for (;!o.next().done; ) {}
}

function* Xn(t, n, e = 0) {
    const s = (t, n) => t === 1 && typeof n === "string" && n.indexOf(" ") !== -1;
    const o = t => t === 14;
    const i = n => {
        const e = t[n + 1].split(" ");
        const s = parseInt(e[0], 10);
        let o = t;
        let i = 1;
        let r = 0;
        let c = 0;
        let l = null;
        for (let n = 0; n < e.length; n++) {
            l = o;
            r = (n === 0 ? s : parseInt(e[n], 10)) * 2;
            c = r + 1;
            const u = o;
            i = u[r];
            o = u[c];
            if (i === 1) {
                const n = typeof o === "string" ? parseInt(o, 10) : o;
                const e = n * 2;
                i = t[e];
                o = t[e + 1];
            }
        }
        if (l) {
            l[r] = 1;
            l[c] = n / 2;
        }
        t[n] = i;
        t[n + 1] = o;
    };
    for (let r = e; r < t.length; r += 2) {
        s(t[r], t[r + 1]) ? i(r) : o(t[r]) && (n.Tt = t[r + 1]);
        yield;
    }
}

const vc = new WeakMap;

const bc = /^[A-Za-z0-9+/]*$/;

const _c = t => {
    const n = t.Ut === void 0;
    t.Ut ??= new Map;
    return n;
};

const gc = (t, n) => {
    if (n) {
        t.Ut.clear();
        t.Ut = void 0;
    }
};

const Sc = (t, n, e) => {
    switch (n) {
      case 0:
        return e;

      case 1:
        return t.k(e);

      case 2:
        const s = t.Ht(e);
        return s === -1 || s === void 0 ? hs : t.k(s);

      case 14:
        return e;

      case 3:
        return Ju[e];

      case 4:
        return Array(e.length / 2);

      case 5:
        return {};

      case 9:
        {
            let n;
            if (typeof e === "string") {
                const s = e;
                const o = s.indexOf("#");
                const i = s.indexOf("#", o + 1);
                const r = +s.slice(0, o);
                const c = i === -1 ? +s.slice(o + 1) : +s.slice(o + 1, i);
                const l = r + c;
                const u = t.k(r);
                const f = t.k(l);
                n = jn(u, f, i !== -1 ? s : null, t);
            } else {
                n = jn("", e + "", null, t);
            }
            return n;
        }

      case 28:
        return new ku(-1, -1, null, null, null);

      case 6:
        return new URL(e);

      case 7:
        return new Date(e);

      case 15:
        return Temporal.Duration.from(e);

      case 16:
        return Temporal.Instant.from(e);

      case 17:
        return Temporal.PlainDate.from(e);

      case 18:
        return Temporal.PlainDateTime.from(e);

      case 19:
        return Temporal.PlainMonthDay.from(e);

      case 20:
        return Temporal.PlainTime.from(e);

      case 21:
        return Temporal.PlainYearMonth.from(e);

      case 22:
        return Temporal.ZonedDateTime.from(e);

      case 8:
        const o = e.lastIndexOf("/");
        return RegExp(e.slice(1, o), e.slice(o + 1));

      case 23:
        return Error();

      case 29:
        return va(null);

      case 30:
        return new qs(t, 0);

      case 31:
        return new Js(t, null, null, null);

      case 32:
        return new Ms(t, null);

      case 33:
        return new Ns(t, null, void 0, {});

      case 34:
        return new Is(t, null);

      case 35:
        {
            const n = e;
            const s = n[0];
            const o = n[1];
            const i = Sc(t, s, o);
            const r = Bu(i, 0, t);
            tf(s) && t.Ut.set(i, {
                t: s,
                v: o
            });
            n[0] = 0;
            n[1] = i;
            return r;
        }

      case 13:
        return new URLSearchParams(e);

      case 36:
        return new FormData;

      case 37:
        return new Gs(null, null, null, null, 0, null);

      case 12:
        return BigInt(e);

      case 25:
        return new Set;

      case 26:
        return new Map;

      case 24:
        let i;
        let r;
        const c = new Promise((t, n) => {
            i = t;
            r = n;
        });
        vc.set(c, [ i, r ]);
        c.catch(() => {});
        return c;

      case 27:
        {
            if (!(t => {
                if (typeof t !== "string" || !bc.test(t)) {
                    return !1;
                }
                const n = t.length % 4;
                if (n === 0) {
                    return !0;
                }
                if (n === 1) {
                    return !1;
                }
                const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(t[t.length - 1]);
                return (e & (n === 2 ? 15 : 3)) === 0;
            })(e)) {
                throw Ye(38);
            }
            const t = e.length;
            const n = Math.floor(t / 4);
            const s = t % 4;
            const o = n * 3 + (s ? s - 1 : 0);
            return new Uint8Array(o);
        }

      case 38:
        return m(null);

      case 10:
        return Wn(t, e);

      case 11:
        const l = Wn(t, e);
        if (dl(l)) {
            Yl(l);
            return yu(l);
        }
        throw Ye(17, [ typeof l ]);

      case 39:
        return new Ys({});

      case 42:
        return new Ys({
            j: null,
            it: !0
        });

      case 43:
        return new Ys({
            j: null,
            it: !1
        });

      case 40:
      case 44:
        return new Es(null, null, null, null);

      case 41:
        return new Ku;

      default:
        throw Ye(18, [ n ]);
    }
};

function Wn(t, n) {
    return n ? t.rootVNode ? Tl(t.rootVNode, n) : void 0 : t.element?.ownerDocument;
}

const Ec = (t, n, e) => {
    let s = null;
    let o = null;
    if (Je(t)) {
        o = t;
    } else {
        if (!He(t)) {
            throw Ye(7, [ t ]);
        }
        s = t;
    }
    return la(s, n, null, o, e);
};

const kc = (t, n, e) => la(null, n, t, null, e);

const Rc = (t, n) => la(null, t, null, null, n);

const Pc = (t, n, e) => {
    const s = Rc(t, e);
    return s;
};

const Tc = (t, n, e, s) => la(t, e, null, n, s);

const qc = (t, n, e, s, o) => {
    const i = Tc(t, n, e, o);
    i.De(s);
    return i;
};

const Ac = (t, n, e, s) => {
    const o = Ec(t, n, s);
    return o;
};

const Mc = (t, n, e, s) => {
    const o = kc(t, n, s);
    return o;
};

const xc = (t, n) => {
    typeof globalThis.__qwik_reg_symbols === "undefined" && (globalThis.__qwik_reg_symbols = new Map);
    globalThis.__qwik_reg_symbols.set(n, t);
    return t;
};

const Ic = () => {
    const t = globalThis.process;
    return t?.getBuiltinModule?.("node:async_hooks")?.AsyncLocalStorage;
};

function Vn(t) {
    return t === null || typeof t === "string" || typeof t === "number" || typeof t === "boolean";
}

const Nc = (t, n, e) => new Js(null, t, n, e || null);

class Cc {
    Xe;
    yt;
    We=null;
    Gn=!1;
    sn;
    k;
    fn;
    Ve=0;
    Jt=null;
    Ue=null;
    l=null;
    u=null;
    o=0;
    constructor(t, n) {
        this.fn = t;
        this.sn = n;
        this.Xe = Xr;
        this.yt = new WeakMap;
        this.k = () => {
            throw Error("Not implemented");
        };
    }
    trackSignalValue(t, n, e, s) {
        return Df(t, n, e, this, s);
    }
    serializationCtxFactory(t, n, e, s) {
        return ac(t, n, e, this.setHostProp.bind(this), this.yt, s);
    }
    $t() {
        if (this.o === 0) {
            this.u?.();
            this.l = null;
        }
    }
}

const Oc = Symbol();

const hd = t => {
    const n = () => {
        throw Error("Internal server component must be handled by the SSR renderer.");
    };
    n[Oc] = t;
    return n;
};

class jc {}

const Lc = (t, n, e = null) => {
    n.catch(n => {
        try {
            t.handleError(n, e);
        } catch {}
    });
};

function Un(t, n, e) {
    return () => {
        t.currentStyleScoped = n;
        t.parentComponentFrame = e;
    };
}

async function zn(t, e, s) {
    const o = [ e ];
    const i = t => o.push(t);
    const r = n => {
        Lc(t, n);
        o.push(n);
        o.push(Promise);
    };
    await (async () => {
        for (;o.length; ) {
            try {
                const e = o.pop();
                if (e === jc) {
                    const t = o.pop();
                    await n(() => o.push(t()));
                    continue;
                }
                if (typeof e === "function") {
                    if (e === Promise) {
                        o.push(await o.pop());
                    } else {
                        const n = e.apply(t);
                        Ji(n) && await n;
                    }
                    continue;
                }
                Bn(t, i, r, e, s);
            } finally {
                const n = t.streamHandler.waitForPendingFlush();
                Ji(n) && await n;
            }
        }
    })();
}

function Bn(t, n, e, s, o) {
    if (s == null) {
        t.textNode("");
    } else if (typeof s === "boolean") {
        t.textNode("");
    } else if (typeof s === "number") {
        t.textNode(s + "");
    } else if (typeof s === "string") {
        t.textNode(s);
    } else if (typeof s === "object") {
        if (Array.isArray(s)) {
            for (let t = s.length - 1; t >= 0; t--) {
                n(s[t]);
            }
        } else if (Tu(s)) {
            (function e(t, n) {
                const e = n instanceof Js ? n.st() : n;
                if (e instanceof Ms) {
                    const n = e.qt;
                    if (n && !(e.h & 256)) {
                        t.Rt(e);
                        t.At.add(e);
                    }
                }
            })(t.serializationCtx, s);
            t.openFragment(ps);
            const o = t.getOrCreateLastNode();
            const i = s instanceof Js ? s.st() : s;
            n(t.closeFragment);
            n(() => Df(i, o, ".", t));
            n(jc);
        } else if (Ji(s)) {
            t.openFragment(ps);
            n(t.closeFragment);
            e(s);
            n(() => t.streamHandler.flush());
        } else if (function i(t) {
            return !!t[Symbol.asyncIterator];
        }(s)) {
            n(async () => {
                for await (const n of s) {
                    await zn(t, n, {
                        currentStyleScoped: o.currentStyleScoped,
                        parentComponentFrame: o.parentComponentFrame
                    });
                    await t.streamHandler.flush();
                }
            });
        } else {
            const i = s;
            const r = i.type;
            if (typeof r === "string") {
                (function e(t, n) {
                    const e = ws(t, "class") != null;
                    if (!e && n) {
                        t.constProps || (t.constProps = {});
                        t.constProps.class = "";
                    }
                })(i, o.currentStyleScoped);
                let s = null;
                const c = t.openElement(r, i.key, i.varProps, i.constProps, o.currentStyleScoped, s, !!(i.flags & 4));
                c && t.htmlNode(c);
                n(t.closeElement);
                if (r === "head") {
                    t.emitQwikLoaderAtTopIfNeeded();
                    t.emitPreloaderPre();
                    n(t.additionalHeadNodes);
                } else if (r === "body") {
                    n(t.additionalBodyNodes);
                } else {
                    const n = t;
                    if (!t.isHtml && !n._didAddQwikLoader && !t.Mt) {
                        t.emitQwikLoaderAtTopIfNeeded();
                        t.emitPreloaderPre();
                        n._didAddQwikLoader = !0;
                    }
                }
                const l = i.children;
                l != null && n(l);
            } else if (Je(r)) {
                if (__EXPERIMENTAL__.suspense && (t => typeof t === "function" && Oc in t)(r)) {
                    n(() => (t => t[Oc])(r)(t, i, o, n));
                    return;
                }
                if (r === vo) {
                    const e = i.key != null ? {
                        [Ii]: i.key
                    } : {};
                    t.openFragment(e);
                    n(t.closeFragment);
                    const s = i.children;
                    s != null && n(s);
                } else if (r === _o) {
                    const e = o.parentComponentFrame;
                    if (e) {
                        const s = e.componentNode.id || "";
                        const r = {};
                        r["q:sparent"] = s;
                        t.openProjection(r);
                        const c = e.componentNode;
                        const l = t.getOrCreateLastNode();
                        const u = k(c, i, t);
                        r[ui] = u;
                        n(Un(o, o.currentStyleScoped, o.parentComponentFrame));
                        n(t.closeProjection);
                        const f = i.children || null;
                        const a = e.consumeChildrenForSlot(l, u) || f;
                        f && a !== f && t.addUnclaimedProjection(e, "", f);
                        n(a);
                        n(Un(o, e.projectionScopedStyle, e.projectionComponentFrame));
                    } else {
                        let n = ps;
                        t.openFragment(n);
                        t.closeFragment();
                    }
                } else if (r === Eo) {
                    t.commentNode(ws(i, "data") || "");
                } else if (r === Ro) {
                    t.streamHandler.flush();
                    const s = i.children;
                    let r;
                    r = Je(s) ? s({
                        async write(n) {
                            await zn(t, n, {
                                currentStyleScoped: o.currentStyleScoped,
                                parentComponentFrame: o.parentComponentFrame
                            });
                            await t.streamHandler.flush();
                        }
                    }) : s;
                    Ji(r) ? e(r) : n(r);
                } else if (r === So) {
                    t.htmlNode(ws(i, "data"));
                } else if (r === ko) {
                    t.streamHandler.streamBlockStart();
                    n(() => t.streamHandler.streamBlockEnd());
                    n(i.children);
                } else if (_a(r)) {
                    const e = {};
                    t.openComponent(e);
                    const s = t.getOrCreateLastNode();
                    const c = t.getParentComponentFrame();
                    c.distributeChildrenIntoSlots(i.children, o.currentStyleScoped, o.parentComponentFrame);
                    const l = ((t, n, e) => {
                        const s = t.getOrCreateLastNode();
                        const [o] = e[ba];
                        const i = n.props;
                        i && i.children && delete i.children;
                        s.setProp(si, o);
                        s.setProp(Ni, i);
                        n.key !== null && s.setProp(Ii, n.key);
                        return Go(t, s, s, o, i);
                    })(t, i, r);
                    n(Un(o, o.currentStyleScoped, o.parentComponentFrame));
                    n(() => t.closeComponent());
                    if (Ji(l)) {
                        Lc(t, l, s);
                        n(async () => {
                            await t.streamHandler.flush();
                            const e = await l;
                            const i = nr(s.getProp($i));
                            n(e);
                            n(Un(o, i, c));
                        });
                    } else {
                        n(l);
                        const t = nr(s.getProp($i));
                        n(Un(o, t, c));
                    }
                } else {
                    const s = {
                        [Ii]: i.key
                    };
                    t.openFragment(s);
                    n(t.closeFragment);
                    const o = t.getParentComponentFrame();
                    const c = ((t, n, e, s) => {
                        const o = t.getOrCreateLastNode();
                        return Go(t, o, n, e, s.props);
                    })(t, o && o.componentNode, r, i);
                    Ji(c) ? e(c) : n(c);
                }
            }
        }
    }
}

const Fc = () => na;

const Dc = async t => {
    const [n, e] = na;
    const s = await n(t);
    s && typeof s === "object" ? e.r ? Object.assign(e.r, s) : e.r = xn(n.$, s, 1) : e.r = s;
    return {
        r: e.r
    };
};

const Xc = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e) {
        return e;
    }
    const i = la(null, "_rsc", Dc, null, [ t, {} ], o.$);
    const r = js(i, {
        timeout: n?.timeout,
        container: o.$,
        concurrency: 0
    });
    r.p();
    const c = {
        __brand: "resource",
        signal: r,
        get value() {
            return r.promise().then(() => r.error ? Promise.reject(r.error) : r.value.r);
        },
        get loading() {
            return r.loading;
        }
    };
    s(c);
    return c;
};

const Wc = ({value: t, onResolved: n, onPending: e, onRejected: s}) => {
    if (Ji(t)) {
        return t.then(n, s);
    }
    const o = Vc(t);
    const i = o ? t.signal : t;
    if (e && i.loading) {
        return e();
    }
    if (s && i.error) {
        return s(i.error);
    }
    const r = o ? i.value?.r : i.value;
    return Ji(r) ? r.then(n, s) : n(r);
};

const Vc = t => t && t.__brand === "resource";

function Qn(t, n, e, s) {
    let o = null;
    const i = e;
    const r = t => {
        o == null ? o = t : typeof o === "string" && typeof t === "string" ? o += "|" + t : o = [ ...typeof o === "string" ? [ o ] : o, "|", ...typeof t === "string" ? [ t ] : t ];
    };
    const c = n => {
        !n.gt.startsWith("_") && (Array.isArray(n.xt) || s && n.It) && (n = la(null, "_run", I, null, [ n ]));
        return function e(t, n) {
            const [e, s, o] = On(t, n, !0);
            const i = `${e}#${s}`;
            if (!o) {
                return i;
            }
            const r = [ i, "#" ];
            let c = 0;
            let l = 0;
            for (let t = 0; t <= o.length; t++) {
                if (t === o.length || o[t] === " ") {
                    if (t > l) {
                        const n = c + +o.slice(l, t);
                        if (l > 0) {
                            r.push(" ");
                            r.push({
                                id: n,
                                base: c
                            });
                        } else {
                            r.push(n);
                        }
                        c = n;
                    }
                    l = t + 1;
                }
            }
            return r;
        }(t, n);
    };
    if (Array.isArray(i)) {
        for (let e = 0; e < i.length; e++) {
            const o = i[e];
            if (Ke(o)) {
                r(c(o));
                Hn(t, n, o);
            } else if (o != null) {
                const e = Qn(t, n, o, s);
                e && r(e);
            }
        }
    } else if (Ke(i)) {
        o = c(i);
        Hn(t, n, i);
    }
    return o;
}

function Hn(t, n, e) {
    const s = sr(n);
    if (s) {
        const [n, o] = s;
        const i = ((t, n) => t + ":" + n)(n, o);
        t.Nt.add(i);
        t.Ct.add(e);
    }
}

const Uc = (t, n, e) => {
    Qc(e?.passive ? "q-ep:" : "q-e:", t, n, e);
};

const zc = (t, n, e) => {
    Qc(e?.passive ? "q-dp:" : "q-d:", t, n, e);
};

const Bc = (t, n, e) => {
    Qc(e?.passive ? "q-wp:" : "q-w:", t, n, e);
};

const Qc = (t, n, e, s) => {
    const {isAdded: o, addEvent: i} = Hc();
    if (o) {
        return;
    }
    if (e) {
        if (Array.isArray(n)) {
            for (let o = 0; o < n.length; o++) {
                const r = n[o];
                i(t + rr(r), e, s);
            }
        } else {
            i(t + rr(n), e, s);
        }
    }
};

const Hc = () => {
    const t = Cf();
    const n = t._;
    const e = n;
    let s = t.$.getHostProp(e, Di);
    if (s === null) {
        s = {};
        t.$.setHostProp(e, Di, s);
    }
    let o = t.$.getHostProp(e, Xi);
    o === null && (o = 0);
    t.$.setHostProp(e, Xi, o + 1);
    let i = t.$.getHostProp(e, Wi);
    if (i === null) {
        i = [];
        t.$.setHostProp(e, Wi, i);
    }
    for (;i.length <= o; ) {
        i.push(!1);
    }
    return {
        isAdded: i[o],
        addEvent: (t, n, e) => {
            i[o] = !0;
            let r = s[t];
            r || (s[t] = r = {
                qrls: [],
                capture: !1,
                preventdefault: !1,
                stoppropagation: !1
            });
            r.qrls.push(n);
            e?.capture && (r.capture = !0);
            e?.preventdefault && (r.preventdefault = !0);
            e?.stoppropagation && (r.stoppropagation = !0);
        }
    };
};

const Jc = function(t, n) {
    const e = Se(n);
    return qf(e, () => {
        typeof this === "string" && ea(ia(e, this));
        const s = na?.[1];
        const o = s ?? n.getAttribute("data-qwik-inspector");
        if (!o || !t.detail.files.some(t => o.startsWith(t))) {
            return;
        }
        const i = na?.[0];
        if (!i || i.flags & 32) {
            return;
        }
        yn(e, i, 4);
        const r = n.ownerDocument;
        r.__hmrDone = r.__hmrT;
    });
};

let Yc;

function Jn(t) {
    const n = If();
    if (!n) {
        return;
    }
    Yc ||= kc(Jc, "_hmr");
    const e = n._;
    const s = Yc.w([ e, t ]);
    zc("qHmr", s);
}

function Yn(t, n, e, s, o) {
    const i = hl();
    _l(i, ui, o);
    i.parent = n;
    _l(n, o, i);
    _l(i, si, e);
    _l(i, Ni, s);
    i.dirty = 4;
    hn(t, i, 1);
    return i;
}

function Gn(t, n) {
    _l(t, oi, n);
    t.flags |= 2048;
}

function Kn(t, n, e) {
    _l(n, Ni, e);
    yn(t, n, 4);
}

function Zn(t, n, e, s) {
    _l(n, s, null);
    const o = [];
    St(t, o, e);
    Nl(o);
    if (e.flags & 2048) {
        const t = bl(e, oi, null);
        t && t.replaceChildren();
        _l(e, oi, null);
        e.flags &= -2049;
    }
}

let Gc = Promise.resolve();

const Kc = new Set([ "constructor", "prototype", "toString", "valueOf", "toJSON", "then" ]);

const Zc = (t, n) => {
    if (typeof t === "number") {
        return !0;
    }
    return typeof t === "string" && t !== "__proto__" && (typeof n !== "function" || !Kc.has(t));
};

function* te(t, n, e = Array(n.length / 2)) {
    for (let s = 0; s < n.length; s += 2) {
        e[s / 2] = yield* ee(t, n[s], n[s + 1]);
        yield;
    }
    return e;
}

function* ne(t, n, e = Array(n.length / 2)) {
    const s = _c(t);
    const o = n.length / 2;
    const i = new Uint8Array(o);
    const r = t.k;
    const c = s => {
        if (!i[s]) {
            i[s] = 1;
            const o = s * 2;
            const r = n[o];
            const c = n[o + 1];
            e[s] = r === 0 ? c : Sc(t, r, c);
        }
        return e[s];
    };
    t.k = t => c(typeof t === "string" ? parseInt(t, 10) : t);
    try {
        for (let t = 0; t < o; t++) {
            c(t);
            yield;
        }
        for (let s = 0; s < o; s++) {
            const o = s * 2;
            const i = n[o];
            const r = n[o + 1];
            const c = e[s];
            n[o] = 0;
            n[o + 1] = c;
            tf(i) && (yield* ie(t, c, i, r));
            yield;
        }
    } finally {
        t.k = r;
        gc(t, s);
    }
    return e;
}

function* ee(t, n, e) {
    if (n === 0) {
        return e;
    }
    const s = Sc(t, n, e);
    tf(n) && (yield* ie(t, s, n, e));
    return s;
}

function* ie(t, n, e, s) {
    if (e === 0) {
        return;
    }
    if (e === 5 && s !== 0 && !Array.isArray(s)) {
        throw Error("Invalid Object payload");
    }
    e !== 4 && Array.isArray(s) && (s = yield* te(t, s));
    switch (e) {
      case 4:
        yield* te(t, s, n);
        break;

      case 5:
        if (s === 0) {
            break;
        }
        for (let t = 0; t < s.length; t += 2) {
            const e = s[t];
            const o = s[t + 1];
            if (!Zc(e, o)) {
                continue;
            }
            n[e] = o;
        }
        break;

      case 25:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.add(e[n]);
                yield;
            }
            break;
        }

      case 26:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.set(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 24:
        {
            const t = n;
            const [e, o] = s;
            const [i, r] = vc.get(t);
            if (e) {
                if (vc.has(o)) {
                    throw Ye(37);
                }
                i(o);
            } else {
                r(o);
            }
            break;
        }

      case 23:
        {
            const t = s;
            n.message = t[0];
            for (let e = 1; e < t.length; e += 2) {
                const s = t[e];
                const o = t[e + 1];
                Zc(s, o) && (n[s] = o);
                yield;
            }
            break;
        }

      case 28:
        {
            const t = n;
            const e = s;
            t._t = e[0];
            t.h = e[1];
            t.Ot = e[2];
            t.dt = e[3];
            break;
        }

      case 29:
        n[ba][0] = s[0];
        break;

      case 30:
        {
            const t = n;
            const e = s;
            t.jt = e[0];
            t.ht = new Set(e.slice(1));
            se(t.ht, t);
            break;
        }

      case 31:
        {
            const e = n;
            const o = s;
            e.ut = t.getSyncFn(o[0]);
            e.ct = o[1];
            e.jt = Ss;
            e.h = o[2];
            e.h |= 1;
            e._ = o[3];
            e.ht = new Set(o.slice(4));
            (function i(t) {
                if (t._ !== null && dl(t._)) {
                    const n = t._;
                    const e = t.ht;
                    let s = !1;
                    if (e) {
                        for (const o of e) {
                            const e = o.property;
                            if (He(e)) {
                                const o = bl(n, e, null);
                                if (o !== null) {
                                    t.jt = o;
                                    s = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (!s) {
                        const e = Jl(n);
                        e && n.firstChild === n.lastChild && ml(e) && (t.jt = Ql(e));
                    }
                }
            })(e);
            se(e.ht, e);
            break;
        }

      case 33:
        {
            const t = n;
            const e = s;
            t.Lt = e[0];
            e[1] && (t.ht = new Set(e[1]));
            e[2] && (t.wt = new Set(e[2]));
            e[3] && (t.vt = new Set(e[3]));
            e[4] && (t.Ft = e[4]);
            t.h = e[5] ?? 0;
            t.h & 64 && (t.Dt = !0);
            const o = e.length > 6;
            o && (t.jt = e[6]);
            t.jt === Ss && (t.h |= 1);
            const i = e[7] ?? 0;
            t.expires = Math.abs(i);
            i < 0 && (t.h |= 256);
            if (e[8] !== void 0 && e[8] !== 1) {
                t.Xt = e[8] ?? 1;
                t.Wt = [];
            }
            t.Vt = e[9] ?? 0;
            se(t.ht, t);
            se(t.wt, t);
            se(t.vt, t);
            break;
        }

      case 34:
      case 32:
        {
            const o = n;
            const i = s;
            o.Lt = i[0];
            const r = o.Lt.resolve(t).catch(() => {});
            Gc = Gc.finally(() => r);
            i[1] && (o.ht = new Set(i[1]));
            const c = i.length > 2;
            c && (o.jt = i[2]);
            e !== 34 && o.jt !== Ss && (o.h &= -2);
            se(o.ht, o);
            break;
        }

      case 36:
        {
            const t = n;
            const e = s;
            for (let n = 0; n < e.length; n++) {
                t.append(e[n++], e[n]);
                yield;
            }
            break;
        }

      case 37:
        {
            const t = n;
            const [e, o, i, r, c, l] = s;
            t.type = e;
            t.key = o;
            t.varProps = i;
            t.constProps = r || null;
            t.children = c;
            t.toSort = !!l;
            break;
        }

      case 38:
        {
            const t = n;
            const e = s;
            let o = e[0];
            if (o === hs) {
                o = new Gs(vo, null, null, null, 0, null);
                o.varProps = e[1];
                o.constProps = e[2];
                o._proxy = t;
            }
            t[cs] = o;
            const i = t[fs];
            i.ht = e[3];
            oe(i.ht, t);
            break;
        }

      case 39:
        {
            const t = n;
            t.data.j = s[0];
            t.data.it = s[1];
            break;
        }

      case 42:
      case 43:
        break;

      case 40:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = e[2];
            re(t);
            break;
        }

      case 41:
        {
            const t = n;
            const e = s;
            t.rootId = e[0];
            t.subscriptions = e[1];
            break;
        }

      case 44:
        {
            const t = n;
            const e = s;
            t.consumer = e[0];
            t.property = e[1];
            t.data = null;
            re(t);
            break;
        }

      case 27:
        {
            const t = n;
            const e = atob(s);
            for (let n = 0; n < e.length; n++) {
                t[n] = e.charCodeAt(n);
                (n & 31) === 31 && (yield);
            }
            break;
        }

      case 35:
        {
            const e = Uu(n);
            const o = t.Ut.get(e);
            if (o) {
                t.Ut.delete(e);
                yield* ie(t, e, o.t, o.v);
            }
            const [, i, r] = s;
            const c = Du(n);
            c.h = i;
            c.ht = r;
            oe(c.ht, e);
            break;
        }

      default:
        throw Ye(16, [ e ]);
    }
}

function re(t) {
    const n = Ce;
    const e = t.consumer;
    if (n && !e) {
        return;
    }
    e[Vr] ||= new Map;
    e[Vr].set(t.property, t);
}

function se(t, n) {
    if (t) {
        for (const e of t) {
            e.backRef ||= new Set;
            e.backRef.add(n);
        }
    }
}

function oe(t, n) {
    if (t) {
        for (const [, e] of t) {
            se(e, n);
        }
    }
}

const tf = t => t >= 23 || t === 4 || t === 5;

const nf = new WeakMap;

const ef = Symbol();

const rf = (t, n) => {
    if (!Array.isArray(n) || dl(n) || (t => Be(t) && ef in t)(n)) {
        return n;
    }
    let e = nf.get(n);
    if (!e) {
        const s = Array(n.length / 2).fill(void 0);
        e = new Proxy(s, new sf(t, n));
        nf.set(n, e);
    }
    return e;
};

class sf {
    $;
    ze;
    constructor(t, n) {
        this.$ = t;
        this.ze = n;
    }
    get(t, n, e) {
        if (n === ef) {
            return t;
        }
        const s = typeof n === "number" ? n : typeof n === "string" ? parseInt(n, 10) : NaN;
        if (Number.isNaN(s) || s < 0 || s >= this.ze.length / 2) {
            return Reflect.get(t, n, e);
        }
        const o = s * 2;
        const i = this.ze[o];
        const r = this.ze[o + 1];
        if (i === 0) {
            return r;
        }
        const c = this.$;
        const l = _c(c);
        try {
            const e = Sc(c, i, r);
            Reflect.set(t, n, e);
            this.ze[o] = 0;
            this.ze[o + 1] = e;
            tf(i) && ((t, n, e, s) => {
                const o = _c(t);
                try {
                    const o = ie(t, n, e, s);
                    for (;!o.next().done; ) {}
                } finally {
                    gc(t, o);
                }
            })(c, e, i, r);
            return e;
        } finally {
            gc(c, l);
        }
    }
    has(t, n) {
        if (n === ef) {
            return !0;
        }
        return Object.prototype.hasOwnProperty.call(t, n);
    }
    set(t, n, e, s) {
        if (n === ef) {
            return !1;
        }
        const o = Reflect.set(t, n, e, s);
        const i = typeof n === "number" ? n : parseInt(n, 10);
        if (Number.isNaN(i) || i < 0 || i >= this.ze.length / 2) {
            return o;
        }
        const r = i * 2;
        this.ze[r] = 0;
        this.ze[r + 1] = e;
        return !0;
    }
}

const of = t => {
    if (!t.Be) {
        t.Be = !0;
        t.Qe();
    }
};

const lf = (t, n, e) => {
    const s = {
        He: t,
        Qe: void 0,
        Be: !1
    };
    const o = hr(() => {
        ((t, n, e) => {
            t.Be = !1;
            const s = performance.now() + 10;
            let o = 0;
            try {
                for (;;) {
                    const e = t.He.next();
                    if (e.done) {
                        n(e.value);
                        return;
                    }
                    if ((31 & ++o) === 0 && performance.now() >= s) {
                        of(t);
                        return;
                    }
                }
            } catch (t) {
                e(t);
            }
        })(s, t => {
            o.an?.();
            n(t);
        }, t => {
            o.an?.();
            e(t);
        });
    });
    s.Qe = o;
    return s;
};

async function le(t) {
    const n = ac(null, null, () => "", () => {}, new WeakMap);
    n.Rt(t);
    await n.zt();
    return n.Bt.toString();
}

async function ue(t) {
    if (t == null) {
        throw Error("No state data to deserialize");
    }
    const n = JSON.parse(t);
    if (!Array.isArray(n) || n.length < 2 || typeof n[0] !== "number") {
        throw Error("Invalid state data");
    }
    const e = Array(n.length / 2);
    const s = ae(n, () => e);
    s.Qt = e;
    await uf(ne(s, n, e));
    return e[0];
}

const uf = t => new Promise((n, e) => {
    const s = lf(t, n, e);
    of(s);
});

function ce(t, n) {
    if (typeof t === "string") {
        t = parseInt(t, 10);
        return n[t];
    }
    return n[t];
}

function fe(t) {
    let n;
    const e = ae(t, () => n);
    n = rf(e, t);
    e.Qt = n;
    return e;
}

function ae(t, n) {
    const e = {
        k: t => ce(t, n()),
        Ht: t => e.Tt?.[+t],
        getSyncFn: () => () => {},
        yt: new WeakMap,
        element: null,
        Tt: null
    };
    Dn(t, e);
    return e;
}

const cf = (t, n) => {
    const e = new WeakSet;
    return jf(ff, t, e, "_", n);
};

const ff = (t, n, e, s) => {
    const o = Uu(t);
    if (o == null) {
        return t;
    }
    if (hf(o)) {
        if (typeof o === "object") {
            if (n.has(o)) {
                return t;
            }
            n.add(o);
        }
        if (Tu(o)) {
            return t;
        }
        if (dc(o)) {
            return t;
        }
        if (o.__brand || o.__brand__) {
            return t;
        }
        const i = typeof o;
        switch (i) {
          case "object":
            if (Ji(o)) {
                return t;
            }
            if ((t => t && typeof t.nodeType === "number")(o)) {
                return t;
            }
            if (Qe(o)) {
                let s = 0;
                for (let t = 0; t < o.length; t++) {
                    if (!(t in o)) {
                        throw Ye(3, [ o ]);
                    }
                    const i = o[t];
                    if (t !== s) {
                        throw Ye(3, [ o ]);
                    }
                    ff(i, n, e + "[" + t + "]");
                    s = t + 1;
                }
                return t;
            }
            if (o instanceof Jr) {
                return t;
            }
            if (ze(o)) {
                for (const [t, s] of Object.entries(o)) {
                    ff(s, n, e + "." + t);
                }
                return t;
            }
            break;
        }
        let r;
        r = s || "Value cannot be serialized";
        e !== "_" && (r += ` in ${e},`);
        if (i === "object") {
            r += ` because it's an instance of "${t?.constructor.name}". You might need to use 'noSerialize()' or use an object literal instead. Check out https://qwik.dev/docs/advanced/dollar/`;
        } else if (i === "function") {
            const n = t.name;
            r += ` because it's a function named "${n}". You might need to convert it to a QRL using $(fn):\n\nconst ${n} = $(${t + ""});\n\nPlease check out https://qwik.dev/docs/advanced/qrl/ for more information.`;
        }
        throw Ye(3, [ r ]);
    }
    return t;
};

const af = /*#__PURE__*/ new WeakSet;

const hf = t => {
    if (Be(t) || Je(t)) {
        return !af.has(t) && !($f in t);
    }
    return !0;
};

const df = t => !!t && (Be(t) || typeof t === "function") && (af.has(t) || $f in t);

const pf = t => {
    (Be(t) && t !== null || typeof t === "function") && af.add(t);
    return t;
};

const $f = Symbol();

const yf = Symbol();

const mf = t => /*#__PURE__*/ Object.freeze({
    id: rr(t)
});

const wf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return;
    }
    o.$.setContext(o._, t, n);
    s(1);
};

const vf = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e !== void 0) {
        return e;
    }
    const i = o.$.resolveContext(o._, t);
    if (typeof n === "function") {
        return s(qe(void 0, n, i));
    }
    if (i !== void 0) {
        return s(i);
    }
    if (n !== void 0) {
        return s(n);
    }
    throw Ye(8, [ t.id ]);
};

const bf = t => {
    const n = Nf();
    const e = n._;
    if (!e) {
        return;
    }
    return n.$?.resolveContext(e, t);
};

const _f = /*#__PURE__*/ mf("qk-error");

const dd = (t, n = t => t.boundary.untrackedValue > 0) => {
    if (t === null) {
        return !0;
    }
    const e = t.reveal;
    const s = t.item;
    const o = e.items;
    switch (e.order) {
      case "together":
        for (let t = 0; t < o.length; t++) {
            if (n(o[t])) {
                return !1;
            }
        }
        return !0;

      case "sequential":
        for (let t = 0; t < o.length; t++) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      case "reverse":
        for (let t = o.length - 1; t >= 0; t--) {
            const e = o[t];
            if (e === s) {
                return !0;
            }
            if (n(e)) {
                return !1;
            }
        }
        return !0;

      default:
        return !0;
    }
};

const pd = new WeakMap;

class $d {
    id;
    collapsed;
    count=0;
    pendingItems=new Set;
    orderCode;
    constructor(t, n, e) {
        this.id = t;
        this.collapsed = e;
        this.orderCode = yd(n);
    }
    register(t) {
        this.pendingItems.add(t.item);
        const n = this.count++;
        return {
            attrs: ` q:g="${this.id}" q:i="${n}" q:o="${this.orderCode}"` + (this.collapsed ? " q:c" : ""),
            showFallback: this.canReveal(t) || !this.collapsed,
            resolve: () => {
                this.pendingItems.delete(t.item);
            }
        };
    }
    canReveal(t) {
        return dd(t, t => this.pendingItems.has(t));
    }
    script() {
        return this.count === 0 ? "" : `qO.g(${this.id},${this.count},"${this.orderCode}");`;
    }
}

const yd = t => {
    switch (t) {
      case "sequential":
        return "s";

      case "reverse":
        return "r";

      case "together":
        return "t";

      default:
        return "p";
    }
};

const wd = () => {
    if (!__EXPERIMENTAL__.suspense) {
        return !1;
    }
    const t = If()?.$;
    return t?.outOfOrderStreaming === !0 && !fd(t);
};

const gf = (t, n, e, s, o) => {
    let i;
    for (const t of o) {
        if (!s.has(t)) {
            s.add(t);
            (i ||= new Set).add(t);
        }
        (t.backRef ||= new Set).add(e);
    }
    i && Iu(t, n, i);
};

const Sf = new WeakMap;

function* he(t, n) {
    if (!__EXPERIMENTAL__.suspense) {
        return;
    }
    const e = t;
    const s = e.element.querySelectorAll(`script[type="qwik/state"][q\\:instance="${e.Jt}"]${fi}`);
    const o = Ef(t);
    for (let i = 0; i < s.length; i++) {
        const r = s[i];
        if (n !== void 0 && r.getAttribute(ai) !== n) {
            continue;
        }
        if (o.has(r)) {
            continue;
        }
        o.add(r);
        yield* de(t, e, r.textContent);
        yield;
    }
}

const Ef = t => {
    let n = Sf.get(t);
    if (!n) {
        n = new WeakSet;
        Sf.set(t, n);
    }
    return n;
};

function* de(t, n, e) {
    if (!e) {
        return;
    }
    const [s, o, i, r] = JSON.parse(e);
    yield* function* c(t, n, e, s) {
        const o = n.Yt.length / 2;
        if (e !== o) {
            return;
        }
        for (let t = 0; t < s.length; t++) {
            n.Yt[e * 2 + t] = s[t];
            yield;
        }
        yield* Xn(n.Yt, t, e * 2);
        n.Gt = rf(t, n.Yt);
        n.Gt.length = n.Yt.length / 2;
        n.Kt = n.Tt;
    }(t, n, s, o);
    kf(n, i || void 0);
    ((t, n) => {
        if (!__EXPERIMENTAL__.suspense || !n) {
            return;
        }
        for (let e = 0; e < n.length; e++) {
            const s = n[e];
            const o = t.k(s.rootId);
            const i = s.subscriptions;
            if (o instanceof qs) {
                i instanceof Set && gf(t, o, o, o.ht ||= new Set, i);
            } else {
                if (!(i instanceof Map)) {
                    continue;
                }
                const n = Du(o);
                const e = Xu(o);
                if (!n || !e) {
                    continue;
                }
                const s = n.ht ||= new Map;
                for (const [o, r] of i) {
                    let i = s.get(o);
                    if (!i) {
                        i = new Set;
                        s.set(o, i);
                    }
                    gf(t, n, e, i, r);
                }
            }
        }
    })(t, r === void 0 ? void 0 : n.k(r));
}

const kf = (t, n) => {
    if (!n) {
        return;
    }
    const e = t.Kt ||= [];
    for (let t = 0; t < n.length; t++) {
        const s = n[t];
        s !== void 0 && e.push(s);
    }
    t.Tt = e;
};

const Rf = (t, n) => {
    const e = t;
    e.qVNodeDataReady ? n() : (e.qVNodeDataCallbacks ||= []).push(n);
};

function pe(t, n) {
    const e = t.qVNodeDataState ||= {
        Zt: [],
        tn: null
    };
    t.qProcessVNodeDataPatch ||= n => pe(t, me(t, n));
    t.qVNodeDataReady = !1;
    e.Zt.push(n);
    $e(t, e);
}

function $e(t, n) {
    if (n.tn) {
        return;
    }
    const e = n.Zt.shift();
    if (!e) {
        ye(t);
        return;
    }
    n.tn = lf(function* s(t, n, e) {
        for (;t.qVNodeDataState === n; ) {
            if (e.next().done) {
                return;
            }
            yield;
        }
    }(t, n, e), () => {
        if (t.qVNodeDataState === n) {
            n.tn = null;
            $e(t, n);
        }
    }, e => {
        n.tn = null;
        Fe(e);
        ye(t);
    });
    of(n.tn);
}

function ye(t) {
    if (t.qVNodeDataReady) {
        return;
    }
    t.qVNodeDataReady = !0;
    t.qVNodeDataState = void 0;
    const n = t.qVNodeDataCallbacks;
    t.qVNodeDataCallbacks = void 0;
    if (n) {
        for (let t = 0; t < n.length; t++) {
            n[t]();
        }
    }
}

function* me(t, n) {
    const e = n?.closest("[q\\:container]");
    const s = n?.getAttribute("q:r");
    const o = e && (s ? e.querySelector(`[q\\:rp="${s}"]`) : e);
    e && o && (yield* we(t, s || void 0, e, o, n.textContent));
}

function* we(t, n, e, s, o) {
    const i = "q:container";
    const r = "/" + i;
    const c = "q:ignore";
    const l = "/" + c;
    const u = "q:container-island";
    const f = "/" + u;
    const a = "q:rp";
    const h = t;
    const d = h.qVNodeData ||= new WeakMap;
    const p = t.body;
    const $ = p.getAttribute;
    const y = p.hasAttribute;
    const w = ((t, n) => {
        let e;
        for (;t && !(e = Object.getOwnPropertyDescriptor(t, n)?.get); ) {
            t = Object.getPrototypeOf(t);
        }
        return e || function() {
            return this[n];
        };
    })(p, "nodeType");
    const m = function*(t) {
        const n = t.querySelectorAll('script[type="qwik/vnode"]');
        for (let t = 0; t < n.length; t++) {
            const e = n[t];
            const s = e.closest("[q\\:container]");
            s.qVNodeRefs ||= new Map;
            if (e.hasAttribute("q:patch")) {
                h.qProcessVNodeDataPatch?.(e);
                yield;
                continue;
            }
            const o = e.textContent;
            const i = __EXPERIMENTAL__.suspense && e.getAttribute("q:r");
            i ? (s.qSegmentVnodeData ||= new Map).set(i, o) : s.qVnodeData = o;
            yield;
        }
        const e = t.querySelectorAll("[q\\:shadowroot]");
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            const s = n.shadowRoot;
            s && (yield* m(s));
            yield;
        }
    };
    const b = t => {
        const n = w.call(t);
        if (n === 1) {
            if ($.call(t, i) !== null) {
                return 3;
            }
            if (y.call(t, "q:shadowroot")) {
                return 6;
            }
            if (__EXPERIMENTAL__.suspense && $.call(t, a) !== null) {
                return 130;
            }
            return y.call(t, ":") ? 2 : 0;
        }
        if (n === 8) {
            const n = t.nodeValue || "";
            if (n.startsWith(u)) {
                return 65;
            }
            if (n.startsWith(c)) {
                return 16;
            }
            if (n.startsWith(i)) {
                return 9;
            }
            if (n.startsWith(f)) {
                return 64;
            }
            if (n.startsWith(l)) {
                return 32;
            }
            if (n.startsWith(r)) {
                return 8;
            }
        }
        return 0;
    };
    const v = t => {
        for (;t && (t = t.nextSibling) && b(t) === 0; ) {}
        return t;
    };
    const _ = function*(n, e, s, o, i, r, c, l) {
        const u = __EXPERIMENTAL__.suspense && l !== void 0;
        const f = i.length;
        let h = 0;
        let p = -1;
        let y = 0;
        let w = 0;
        let m = 0;
        let g = -1;
        let E = null;
        const k = () => {
            let t = 0;
            for (;Pf(m = i.charCodeAt(y)); ) {
                t += 1 << m - 33;
                y++;
                if (y >= f) {
                    break;
                }
            }
            return t;
        };
        if (!s) {
            return;
        }
        do {
            if (s === o) {
                return;
            }
            E = null;
            const R = s == e ? 2 : b(s);
            if (R === 3) {
                const t = s;
                let e = s;
                for (;e && !(E = v(e)); ) {
                    e = e.parentNode;
                }
                yield* _(n, t, s, E, t.qVnodeData || "", t.qVNodeRefs, t);
            } else if (R === 16) {
                let t = s;
                do {
                    t = n.nextNode();
                    if (!t) {
                        throw Error(`Island inside \x3c!--${s?.nodeValue}--\x3e not found!`);
                    }
                } while (b(t) !== 65);
            } else if (R === 64) {
                E = s;
                let t;
                do {
                    E = n.nextNode();
                    if (!E) {
                        throw Error("Ignore block not closed!");
                    }
                    t = b(E);
                } while (t !== 32 && t !== 65);
                E = null;
            } else if (R === 9) {
                E = s;
                do {
                    E = v(E);
                    if (!E) {
                        throw Error(`\x3c!--${s?.nodeValue}--\x3e not closed!`);
                    }
                } while (b(E) !== 8);
                yield* _(n, s, s, E, "", null, c);
            } else if (R === 6) {
                E = v(s);
                const n = s;
                const e = n?.shadowRoot;
                e && (yield* _(t.createTreeWalker(e, 129), null, e, null, "", null, null));
            }
            if ((R & 2) === 2) {
                if (u && s !== e) {
                    const t = s;
                    t._qSegment = l;
                }
                if (p < h) {
                    p === -1 && (p = 0);
                    y = w;
                    if (y < f) {
                        p += k();
                        if (m === 126) {
                            g = p;
                            y++;
                            m = y < f ? i.charCodeAt(w) : 33;
                        }
                        w = Tf(i, y, f);
                    } else {
                        p = Number.MAX_SAFE_INTEGER;
                    }
                }
                const t = __EXPERIMENTAL__.suspense && !u && R === 130 ? $.call(s, a) : null;
                if (h === p) {
                    g !== h || u && s === e || r.set(u ? ri(l, h) : h, s);
                    const t = i.substring(y, w);
                    if (u && s === e) {
                        const n = d.get(s);
                        n === void 0 || n === "" ? d.set(s, t) : n.charCodeAt(0) !== ii || n.charCodeAt(1) !== ii || n.endsWith(t) || d.set(s, n + t);
                    } else {
                        d.set(s, t);
                    }
                }
                h++;
                if (__EXPERIMENTAL__.suspense && t !== null) {
                    yield* S(c, s, t);
                    E = v(s);
                    E && (n.currentNode = E);
                }
            }
            yield;
        } while (s = E || n.nextNode());
    };
    const g = function*(n, e, s, o) {
        n.qVNodeRefs ||= new Map;
        const i = t.createTreeWalker(t, 129);
        i.currentNode = e;
        yield* _(i, e, e, v(e), s, n.qVNodeRefs, n, o);
    };
    const S = function*(t, n, e, s) {
        s ||= t?.qSegmentVnodeData?.get(e);
        t && s && (yield* g(t, n, s, e));
    };
    if (e && s && o !== void 0) {
        e.qVNodeRefs ||= new Map;
        __EXPERIMENTAL__.suspense && n !== void 0 ? yield* S(e, s, n, o) : yield* g(e, s, o);
        return;
    }
    yield* m(t);
    const E = t.createTreeWalker(t, 129);
    yield* _(E, null, E.firstChild(), null, "", null, null);
}

const Pf = t => 33 <= t && t <= 46;

const Tf = (t, n, e) => {
    let s = 0;
    for (;n < e; ) {
        const e = t.charCodeAt(n);
        if (e === 92) {
            n += 2;
        } else {
            if (s === 0 && Pf(e)) {
                break;
            }
            e === 123 ? s++ : e === 125 && s--;
            n++;
        }
    }
    return n;
};

function ve(t) {
    return t.nn === 3;
}

function be(t, n) {
    const e = t.en ||= {
        Zt: [],
        tn: null
    };
    t.nn = 2;
    e.Zt.push(n);
    _e(t, e);
}

const qf = (t, n) => {
    const e = t;
    if (ve(e) && e.document.qVNodeDataReady) {
        return n();
    }
    return new Promise((t, s) => {
        ((t, n) => {
            const e = t;
            const s = () => {
                if (!ve(e)) {
                    (e.rn ||= []).push(s);
                    return;
                }
                Rf(e.document, () => {
                    ve(e) ? n() : s();
                });
            };
            s();
        })(e, () => {
            try {
                t(n());
            } catch (t) {
                s(t);
            }
        });
    });
};

function _e(t, n) {
    if (n.tn) {
        return;
    }
    const e = n.Zt.shift();
    if (!e) {
        ge(t);
        return;
    }
    n.tn = lf(e, () => {
        n.tn = null;
        _e(t, n);
    }, e => {
        n.tn = null;
        Fe(e);
        ge(t);
    });
    of(n.tn);
}

function ge(t) {
    const n = t.nn;
    if (n !== 2) {
        return;
    }
    t.nn = 3;
    t.en = void 0;
    const e = t.rn;
    t.rn = void 0;
    if (e) {
        for (let t = 0; t < e.length; t++) {
            e[t]();
        }
    }
}

function Se(t) {
    const n = ke(t);
    if (!n) {
        throw Ye(24);
    }
    return Ee(n);
}

function Ee(t) {
    const n = t;
    return n.qContainer ||= new Af(n);
}

function ke(t) {
    return t.closest(Pi);
}

function Re(t, n) {
    const e = t + "";
    const s = n?.closest(Pi);
    const o = s?.qContainer;
    if (o) {
        const t = o.element.ownerDocument;
        (function s(t, n, e) {
            if (!__EXPERIMENTAL__.suspense || !e) {
                return;
            }
            const s = e.closest("[q\\:container]");
            if (!s) {
                return;
            }
            const o = s.querySelector(`script[type="qwik/vnode"][q\\:r="${n}"]:not([q\\:patch])`);
            const i = s.querySelectorAll(`script[type="qwik/vnode"][q\\:r="${n}"][q\\:patch]`);
            pe(t, function* r(t, n, e, s, o, i) {
                yield* we(t, n, e, s, o);
                for (let n = 0; n < i.length; n++) {
                    yield* me(t, i[n]);
                }
            }(t, n, s, e, o?.textContent || void 0, i));
        })(t, e, n);
        Rf(t, () => {
            o.element.qContainer === o && be(o, he(o, e));
        });
    }
}

class Af extends Cc {
    element;
    qContainer;
    qManifestHash;
    rootVNode;
    document;
    yt=new WeakMap;
    Je;
    Jt;
    Tt=null;
    vNodeLocate=t => Tl(this.rootVNode, t);
    nn=0;
    rn=void 0;
    en=void 0;
    Yt;
    Gt;
    Kt=null;
    Ye=null;
    constructor(t) {
        super({}, t.getAttribute("q:locale"));
        this.qContainer = t.getAttribute(Ei);
        if (!this.qContainer) {
            throw Ye(25);
        }
        const n = t.ownerDocument;
        this.document = n;
        this.element = t;
        this.Ue = t.getAttribute(vi);
        this.Jt = t.getAttribute("q:instance");
        this.qManifestHash = t.getAttribute("q:manifest-hash");
        this.rootVNode = fl(this.element);
        this.Yt = [];
        this.Gt = [];
        __EXPERIMENTAL__.suspense && n.querySelector("template[q\\:r]") && (n.qProcessOOOS ||= Re);
        this.Je = wi(n, this.Jt) || ds;
        this.Ge();
        t.qContainer = this;
        t.qDestroy = () => this.an();
        this.nn = 1;
        (function e(t, n) {
            const e = t;
            if (n?.qVNodeRefs) {
                return;
            }
            if (e.qVNodeDataStarted && !e.qVNodeDataProcessed) {
                return;
            }
            e.qVNodeDataStarted = !0;
            e.qVNodeData ||= new WeakMap;
            pe(e, function* s(t) {
                yield* we(t);
                const n = t;
                n.qVNodeDataProcessed = !0;
                n.qVNodeDataStarted = !1;
            }(t));
        })(n, t);
        Rf(n, () => {
            this.nn === 1 && be(this, this.Ke());
        });
    }
    * Ke() {
        const t = this.element;
        if (t.qContainer !== this) {
            return;
        }
        const n = t.querySelector(`script[type="qwik/state"][q\\:instance="${this.Jt}"]:not(${fi})`) || t.querySelector(`script[type="qwik/state"]:not([q\\:instance]):not(${fi})`);
        if (n) {
            this.Yt = JSON.parse(n.textContent);
            yield* Xn(this.Yt, this);
            this.Kt = this.Tt;
            const e = this.Yt.length / 2;
            const s = t.getAttribute("q:prewarm");
            this.Gt = s !== null && e > 0 && e >= +s ? yield* ne(this, this.Yt) : rf(this, this.Yt);
        }
        __EXPERIMENTAL__.suspense && (yield* he(this));
        this.Ze();
        t.setAttribute(Ei, "resumed");
        t.isConnected && t.dispatchEvent(new CustomEvent("qresume", {
            bubbles: !0
        }));
    }
    an() {
        this.vNodeLocate = () => null;
        this.Yt.length = 0;
        this.Gt.length = 0;
        this.k = () => {};
        const t = this.element;
        t.qContainer = void 0;
        t.qVnodeData = void 0;
        t.qVNodeRefs = void 0;
        __EXPERIMENTAL__.suspense && (t.qSegmentVnodeData = void 0);
        t.removeAttribute(Ei);
        const n = t.ownerDocument;
        this.en = void 0;
        this.nn = 0;
        const e = n.querySelector(Pi) !== null;
        if (!e) {
            n.qVNodeData = void 0;
            n.qVNodeDataStarted = void 0;
            n.qVNodeDataReady = void 0;
            n.qVNodeDataState = void 0;
            n.qVNodeDataCallbacks = void 0;
            n.qVNodeDataProcessed = void 0;
            n.qProcessVNodeDataPatch = void 0;
        }
        __EXPERIMENTAL__.suspense && (e || (n.qProcessOOOS = void 0));
    }
    Ze() {
        const t = this.element.ownerDocument;
        const n = t.head;
        const e = t.body.querySelectorAll(pi);
        const s = e.length;
        if (s) {
            const o = t.createDocumentFragment();
            for (let t = 0; t < s; t++) {
                o.appendChild(e[t]);
            }
            n.appendChild(o);
        }
    }
    Hn(t, n) {
        this.Gt[t] = n;
    }
    parseQRL(t) {
        const n = Ln(t, this);
        return n;
    }
    handleError(t, n) {
        const e = n && this.resolveContext(n, _f);
        if (!e) {
            throw t;
        }
        e.error = t;
    }
    setContext(t, n, e) {
        let s = this.getHostProp(t, yi);
        s == null && this.setHostProp(t, yi, s = []);
        We(s, n.id, e, 0, !0);
    }
    resolveContext(t, n) {
        for (;t; ) {
            const e = this.getHostProp(t, yi);
            if (e != null && Ue(e, n.id, 0)) {
                return Ve(e, n.id, 0);
            }
            t = this.getParentHost(t);
        }
        return;
    }
    getParentHost(t) {
        let n = t.parent;
        for (;n; ) {
            if (wl(n)) {
                if (bl(n, si, null) !== null) {
                    return n;
                }
                n = n.parent || n.slotParent;
            } else {
                n = n.parent;
            }
        }
        return null;
    }
    setHostProp(t, n, e) {
        const s = t;
        _l(s, n, e);
    }
    getHostProp(t, n) {
        const e = t;
        let s = null;
        switch (n) {
          case Ci:
          case Ni:
          case si:
          case yi:
          case mi:
            s = this.k;
            break;

          case Oi:
          case Xi:
            s = parseInt;
            break;
        }
        return bl(e, n, s);
    }
    ensureProjectionResolved(t) {
        if ((t.flags & 16) === 0) {
            t.flags |= 16;
            const n = t.props;
            if (n) {
                const t = Object.keys(n);
                for (let e = 0; e < t.length; e++) {
                    const s = t[e];
                    if (E(s)) {
                        const t = n[s];
                        if (typeof t == "string") {
                            const e = this.vNodeLocate(t);
                            n[s] = e;
                        }
                    }
                }
            }
        }
    }
    k=t => ce(t, this.Gt);
    Ht(t) {
        return this.Kt?.[t];
    }
    getSyncFn(t) {
        const n = this.Je[t];
        return n;
    }
    ti(t, n, e, s) {
        if (s) {
            const t = this.getHostProp(e, $i);
            const s = new Set(function o(t) {
                return t?.split(" ") ?? null;
            }(t));
            s.add(n);
            this.setHostProp(e, $i, function i(t) {
                return Array.from(t).join(" ");
            }(s));
        }
        if (this.Ye == null) {
            this.Ye = new Set;
            const t = this.document.querySelectorAll(di);
            for (let n = 0; n < t.length; n++) {
                const e = t[n];
                this.Ye.add(e.getAttribute(hi));
            }
        }
        if (!this.Ye.has(n)) {
            this.Ye.add(n);
            const e = this.document.createElement("style");
            e.setAttribute(hi, n);
            e.textContent = t;
            this.document.head.appendChild(e);
        }
    }
    Ge() {
        const t = {};
        const n = this.element.attributes;
        if (n) {
            for (let e = 0; e < n.length; e++) {
                const s = n[e];
                if (s.name === zi) {
                    continue;
                }
                t[s.name] = s.value;
            }
        }
        this.fn = {
            containerAttributes: t
        };
    }
}

let Mf;

let md;

if (Ce) {
    const t = Ic();
    t && (md = new t);
}

function Pe(t) {
    if (md) {
        const t = md.getStore();
        if (t) {
            return t;
        }
    }
    if (Mf === void 0) {
        const n = If();
        if (n && n.sn) {
            return n.sn;
        }
        if (t !== void 0) {
            return t;
        }
        throw Error("Reading `locale` outside of context.");
    }
    return Mf;
}

function Te(t, n) {
    if (md) {
        return md.run(t, n);
    }
    const e = Mf;
    try {
        Mf = t;
        return n();
    } finally {
        Mf = e;
    }
}

let xf;

const If = () => xf;

const Nf = () => {
    const t = If();
    if (!t) {
        throw Ye(9);
    }
    return t;
};

const Cf = () => {
    const t = If();
    if (!t || t.ln !== Mi) {
        throw Ye(10);
    }
    return t;
};

function qe(t, n, ...e) {
    return Ae.call(this, t, n, e);
}

function Ae(t, n, e) {
    const s = xf;
    try {
        xf = t;
        return n.apply(this, e);
    } finally {
        xf = s;
    }
}

const Of = (t, n, e = Se(n)) => {
    const s = Tl(e.rootVNode, n);
    const o = e.sn;
    o && function i(t) {
        if (md) {
            md.enterWith(t);
            return;
        }
        Mf = t;
    }(o);
    const r = xe(o, s, t);
    r.$ = e;
    return r;
};

function Me(t, n, e) {
    const s = {
        _: n,
        ln: Mi,
        un: void 0,
        sn: t,
        $: e,
        cn: void 0
    };
    return s;
}

function xe(t, n, e) {
    const s = t || (e && Be(e) && "locale" in e ? e.locale : void 0);
    const o = {
        _: n,
        ln: e,
        un: void 0,
        sn: s,
        $: void 0
    };
    return o;
}

const jf = (t, ...n) => {
    if (typeof t === "function") {
        if (!xf) {
            return t(...n);
        }
        {
            const e = xf.un;
            try {
                xf.un = void 0;
                return t(...n);
            } finally {
                xf.un = e;
            }
        }
    }
    if (Tu(t)) {
        return t.untrackedValue;
    }
    return Uu(t);
};

const Lf = /*#__PURE__*/ Me(void 0, void 0, void 0);

const Ff = (t, n, e, s, o) => {
    const i = Lf.un;
    const r = Lf.$;
    try {
        Lf.un = w(n, e, o);
        Lf.$ = s;
        return Ae(Lf, t);
    } finally {
        Lf.un = i;
        Lf.$ = r;
    }
};

const Df = (t, n, e, s, o) => {
    t instanceof Js && t._ !== n && n && (t._ = n);
    return Ff(() => t.value, n, e, s, o);
};

const Xf = () => If()?._;

const Wf = () => {
    const t = If();
    if (t) {
        return t.ln;
    }
};

const Vf = () => {
    const t = If();
    if (t) {
        return t.$;
    }
};

const Uf = t => t;

const zf = t => t.l || Promise.resolve();

let Bf;

let Qf = (t, n, e, s, o) => new Hf(t, n, e, s, o);

class Hf {
    St;
    gt;
    ni;
    ei;
    $;
    constructor(t, n, e, s, o) {
        this.St = t;
        this.gt = n;
        this.ni = e;
        this.ei = s;
        s && this.ii(s);
        !o || s || typeof t !== "string" || e || (this.$ = o);
        Oe && t && Ne(t, .8);
    }
    get ot() {
        return sd(this.gt);
    }
    ii(t) {
        this.ei = t;
        Ji(t) && t.then(t => this.ei = t, t => {
            const n = `qrl ${this.gt} failed to load`;
            if (Ce) {
                console.error(n, t);
            } else if (Oe) {
                const e = this.St === null ? "symbol:" + this.gt : "chunk:" + this.St;
                const s = this.$;
                let o = s && Bf?.get(s);
                if (!o?.has(e)) {
                    if (s) {
                        if (!o) {
                            o = new Set;
                            (Bf ||= new WeakMap).set(s, o);
                        }
                        o.add(e);
                    }
                    console.error(n, t);
                }
            }
            this.ei = null;
        });
    }
    ri() {
        if (this.ei != null) {
            return this.ei;
        }
        if (this.St === "") {
            const t = this.$.Jt;
            const n = this.$.element?.ownerDocument || document;
            const e = wi(n, t);
            return this.ei = e[+this.gt];
        }
        Oe && this.St && Ne(this.St, 1);
        const t = this.gt;
        const n = this.ni ? this.ni().then(n => n[t]) : mr().importSymbol(this.$?.element, this.St, t);
        this.ii(n);
        return this.ei;
    }
}

Oe && import.meta.hot && (t => {
    if (!Oe || !import.meta.hot) {
        return;
    }
    const n = new Map;
    (() => {
        Qf = (e, s, o, i, r) => {
            let c = n.get(s);
            if (!c) {
                c = new t(e, s, o, i, r);
                e !== "" && n.set(s, c);
            }
            return c;
        };
    })();
    const e = (t, n) => {
        const [e, s] = t.split("?", 2);
        if (!s) {
            return `${e}?t=${n}`;
        }
        const o = s.split("&").filter(t => !t.startsWith("t="));
        o.push("t=" + n);
        return `${e}?${o.join("&")}`;
    };
    document.addEventListener("qHmr", t => {
        const s = t.detail.files;
        const o = t.detail.t || document.__hmrT || Date.now();
        let i = !1;
        for (const t of n.values()) {
            const n = t.dev?.file || t.St;
            if (!n || !s.some(t => n.startsWith(t))) {
                continue;
            }
            const r = t.St;
            if (r) {
                t.St = e(r, o);
                i = !0;
            }
            const c = t.ni?.toString();
            if (c) {
                const n = c.replace(/import\((['"])(.+?)\1\)/, (t, n, s) => {
                    const i = e(s, o);
                    return `import(${n}${i}${n})`;
                });
                if (n !== c) {
                    try {
                        t.ni = Function(`return (${n})`)();
                        i = !0;
                    } catch (n) {
                        console.error("Failed to update symbolFn for " + t.gt, n);
                    }
                } else {
                    console.warn(`Couldn't find import() in symbolFn for ${t.gt}, cannot update it for HMR`, c);
                }
            }
            if (i) {
                t.ei = void 0;
                if (t.qrls) {
                    for (const n of t.qrls) {
                        const e = n.deref();
                        e ? e.resolved && (e.resolved = void 0) : t.qrls.delete(n);
                    }
                }
            }
        }
    }, !0);
})(Hf);

const Jf = Symbol();

const Yf = t => t?.[Jf] ?? t;

class Gf {
    si;
    resolved=void 0;
    xt;
    $;
    constructor(t, n, e) {
        this.si = t;
        if (n) {
            this.xt = n;
            typeof n === "string" && (this.$ = e);
        }
        t.ei == null || this.xt && typeof this.xt === "string" || Ji(t.ei) || (this.resolved = sa(this, t.ei));
    }
}

const Kf = function(t, ...n) {
    const e = Yf(this);
    if (e.resolved) {
        return e.resolved.apply(t, n);
    }
    const s = If();
    return Zf.call(e, s?.$).then(() => Ae.call(t, s, e.resolved, n));
};

const Zf = async function(t) {
    const n = Yf(this);
    return Gi(oa(n, t), () => n.resolved);
};

const ta = Object.create(Function.prototype, {
    resolved: {
        get() {
            return this[Jf].resolved;
        },
        set(t) {
            this[Jf].resolved = t;
        }
    },
    xt: {
        get() {
            return this[Jf].xt;
        },
        set(t) {
            this[Jf].xt = t;
        }
    },
    It: {
        get() {
            return this[Jf].si.It;
        }
    },
    $: {
        get() {
            return this[Jf].$;
        },
        set(t) {
            this[Jf].$ = t;
        }
    },
    si: {
        get() {
            return this[Jf].si;
        }
    },
    St: {
        get() {
            return this[Jf].si.St;
        }
    },
    gt: {
        get() {
            return this[Jf].si.gt;
        }
    },
    ot: {
        get() {
            return this[Jf].si.ot;
        }
    },
    dev: {
        get() {
            return this[Jf].si.dev;
        }
    },
    oi: {
        value: Kf
    },
    w: {
        value: function(t) {
            const n = Yf(this);
            const e = new Gf(n.si, t, n.xt ? n.$ : void 0);
            return ua(e);
        }
    },
    m: {
        value: function() {
            this[Jf].si.It = !0;
            return this;
        }
    },
    s: {
        value: function(t) {
            const n = Yf(this);
            n.si.ii(t);
            n.resolved = sa(n, t);
        }
    },
    resolve: {
        value: Zf
    },
    getSymbol: {
        value: function() {
            return Yf(this).si.gt;
        }
    },
    getHash: {
        value: function() {
            return Yf(this).si.ot;
        }
    },
    getCaptured: {
        value: function() {
            const t = Yf(this);
            ra(t);
            return t.xt;
        }
    },
    getFn: {
        value: function(t, n) {
            const e = Yf(this);
            const s = (...o) => {
                if (!e.resolved) {
                    return Zf.call(e).then(() => s(...o));
                }
                if (n && n() === !1) {
                    return;
                }
                return Ae(t, e.resolved, o);
            };
            return s;
        }
    }
});

let na = null;

const ea = t => {
    na = t;
};

const ia = (t, n, e = 0, s) => {
    const o = [];
    let i = s;
    let r = e;
    for (let s = e; s <= n.length; s++) {
        if (s === n.length || n.charCodeAt(s) === 32) {
            if (s > r) {
                const e = +n.slice(r, s);
                i = i === void 0 ? e : i + e;
                o.push(t.k(i));
            }
            r = s + 1;
        }
    }
    return o;
};

const ra = t => {
    const n = t.xt;
    const e = t.$;
    if (typeof n === "string") {
        if (!e) {
            throw Ye(13);
        }
        const s = Gc;
        na = t.xt = ((t, n) => {
            const e = n.indexOf("#");
            if (e === -1) {
                return ia(t, n);
            }
            const s = n.indexOf("#", e + 1);
            const o = +n.slice(0, e) + +n.slice(e + 1, s);
            return ia(t, n, s + 1, o);
        })(e, n);
        if (Gc !== s) {
            return Gc;
        }
    } else {
        na = n || null;
    }
};

const sa = (t, n) => {
    if (typeof n !== "function" || !t.xt) {
        return n;
    }
    return function e(...s) {
        ra(t);
        return n.apply(this, s);
    };
};

const oa = (t, n) => {
    const e = t.si;
    const s = typeof t.xt === "string";
    s && !t.$ && (t.$ = n || If()?.$);
    if (t.resolved) {
        return;
    }
    const o = ha();
    const i = If();
    const r = e.ri();
    const c = Gi(r, n => {
        t.resolved = sa(t, n);
    });
    if (c) {
        const t = e.gt;
        fa(t, i?._ instanceof Gr ? i?._.node : void 0, o);
    }
    const l = s && t.$ && ra(t);
    if (l) {
        return l.then(() => c);
    }
    return c;
};

const la = (t, n, e, s, o, i) => {
    const r = Qf(t, n, s, e, i);
    const c = new Gf(r, o, i);
    return ua(c);
};

const ua = t => {
    const n = async function(...t) {
        return Kf.call(n, this, ...t);
    };
    n[Jf] = t;
    Object.setPrototypeOf(n, ta);
    return n;
};

const ca = /*#__PURE__*/ new Set;

const fa = (t, n, e) => {
    if (!ca.has(t)) {
        ca.add(t);
        aa("qsymbol", {
            symbol: t,
            element: n,
            reqTime: e
        });
    }
};

const aa = (t, n) => {
    cd() || typeof document !== "object" || document.dispatchEvent(new CustomEvent(t, {
        bubbles: !1,
        detail: n
    }));
};

const ha = () => {
    if (cd()) {
        return 0;
    }
    if (typeof performance === "object") {
        return performance.now();
    }
    return 0;
};

let da = 0;

const pa = t => la(null, "s" + da++, t, null, null);

const $a = pa;

const ya = t => t;

const ma = t => la("", Ge, t, null, null);

const wa = (t, n) => {
    n === void 0 && (n = t.toString());
    t.serialized = n;
    return la("", Ge, t, null, null);
};

const va = t => {
    function n(n, e, s = 0) {
        const o = t.ot.slice(0, 4);
        const i = o + ":" + (e || "");
        const r = () => {};
        r[ba] = [ t ];
        return fo(r, n, null, n.children, s, i);
    }
    n[ba] = [ t ];
    return n;
};

const ba = Symbol();

const _a = t => typeof t == "function" && t[ba] !== void 0;

const ga = t => va($a(t));

const Sa = xs(ya);

const Ea = () => {
    const t = globalThis.__QWIK_MANIFEST__;
    if (!globalThis.__QWIK_MANIFEST__) {
        throw Error("Client manifest is not available. It should have been automatically injected during the build process. Make sure that @qwik.dev/core is internal to the build.");
    }
    return t;
};

const ka = async (t, n, e = {}) => {
    if ((t => t.nodeType === 9)(t)) {
        let n = t.firstChild;
        for (;n && !Wr(n); ) {
            n = n.nextSibling;
        }
        t = n;
    }
    t.setAttribute(Ei, "resumed");
    const s = Se(t);
    s.fn = e.serverData || {};
    const o = s.rootVNode;
    _l(o, is, n);
    yn(s, o, 2);
    await s.l;
    return {
        cleanup: () => {
            St(s, [], s.rootVNode);
        }
    };
};

const Ra = (t, n) => {
    const {val: e, set: s, iCtx: o} = Wo();
    if (e != null) {
        return e;
    }
    const i = Je(t) ? qe(void 0, t) : t;
    if (n?.reactive === !1) {
        s(i);
        return i;
    }
    {
        const t = o.$;
        const e = n?.deep ?? !0;
        const r = e ? 1 : 0;
        const c = Bu(i, r, t);
        s(c);
        return c;
    }
};

const Pa = () => {
    const {val: t, set: n, iCtx: e} = Wo();
    if (t != null) {
        return t;
    }
    const s = e.$.Ue || "";
    const o = s ? lr(s).substring(0, 3) : "";
    const i = e.$.getHostProp(e._, si);
    const r = i?.getHash().substring(0, 3) || "";
    const c = (t => {
        const n = (t => {
            const n = t.We;
            return n || t;
        })(t);
        return (t => t.toString(36))(n.Ve++);
    })(e.$) || "";
    let l = `${o}${r}${c}`;
    let u = l.charCodeAt(0);
    if (u >= 48 && u <= 57) {
        u += 17;
        l = String.fromCharCode(u) + l.substring(1);
    }
    return n(l);
};

function Ie(t, n) {
    const e = If();
    return e?.$?.fn[t] ?? n;
}

const Ta = /*#__PURE__*/ new Map;

const qa = (t, n) => {
    let e = Ta.get(n);
    e || Ta.set(n, e = Aa(t, n));
    return e;
};

const Aa = (t, n) => {
    const e = t.length;
    const s = [];
    const o = [];
    let i = 0;
    let r = i;
    let c = Ca;
    let l = 0;
    for (;i < e; ) {
        const n = i;
        let e = t.charCodeAt(i++);
        if (e === uh) {
            i++;
            e = sh;
        }
        const s = yh[c];
        for (let d = 0; d < s.length; d++) {
            const p = s[d];
            const [$, y, w] = p;
            if (($ === l || $ === Ua || $ === za && Ma(l) || $ === Qa && Na(l)) && (y === e || y === Ua || y === za && Ma(e) || y === Ba && !Ma(e) && e !== nh || y === Qa && Na(e)) && (p.length == 3 || a(p))) {
                p.length > 3 && (e = t.charCodeAt(i - 1));
                if (w === Wa || w == Va) {
                    if (w === Va) {
                        if (c !== Oa || h()) {
                            if (!xa(e)) {
                                const t = y == Ba ? 1 : y == Za ? 2 : 0;
                                f(i - t);
                            }
                        } else {
                            xa(e) ? u(i - 2) : f(i - 2);
                            r++;
                        }
                    }
                    if (y === Ba) {
                        i--;
                        e = l;
                    }
                    do {
                        c = o.pop() || Ca;
                        if (c === ja) {
                            u(i - 1);
                            r++;
                        }
                    } while (Ia(c));
                } else {
                    o.push(c);
                    if (c === ja && w === Ca) {
                        u(i - 8);
                        r = i;
                    } else {
                        w === La && f(n);
                    }
                    c = w;
                }
                break;
            }
        }
        l = e;
    }
    u(i);
    return s.join("");
    function u(n) {
        s.push(t.substring(r, n));
        r = n;
    }
    function f(t) {
        if (c === ja || h()) {
            return;
        }
        u(t);
        s.push(".", li, n);
    }
    function a(n) {
        let e = 0;
        if (t.charCodeAt(i) === th) {
            for (let n = 1; n < 10; n++) {
                if (t.charCodeAt(i + n) === th) {
                    e = n + 1;
                    break;
                }
            }
        }
        t: for (let s = 3; s < n.length; s++) {
            const o = n[s];
            for (let n = 0; n < o.length; n++) {
                if ((t.charCodeAt(i + n + e) | fh) !== o.charCodeAt(n)) {
                    continue t;
                }
            }
            i += o.length + e;
            return !0;
        }
        return !1;
    }
    function h() {
        return o.indexOf(ja) !== -1 || o.indexOf(Fa) !== -1;
    }
};

const Ma = t => t >= eh && t <= ih || t >= sh && t <= oh || t >= ah && t <= hh || t >= 128 || t === ch || t === th;

const xa = t => t === rh || t === nh || t === lh || t === Ka || Ma(t);

const Ia = t => t === Da || t === Fa || t === Xa || t === ja;

const Na = t => t === Ga || t === Ha || t === Ja || t === Ya;

const Ca = 0;

const Oa = 2;

const ja = 5;

const La = 6;

const Fa = 10;

const Da = 11;

const Xa = 12;

const Wa = 17;

const Va = 18;

const Ua = 0;

const za = 1;

const Ba = 2;

const Qa = 3;

const Ha = 9;

const Ja = 10;

const Ya = 13;

const Ga = 32;

const Ka = 35;

const Za = 41;

const th = 45;

const nh = 46;

const eh = 48;

const ih = 57;

const rh = 58;

const sh = 65;

const oh = 90;

const lh = 91;

const uh = 92;

const ch = 95;

const fh = 32;

const ah = 97;

const hh = 122;

const dh = 123;

const ph = 125;

const $h = /*@__PURE__*/ (() => [ [ Ua, 39, 14 ], [ Ua, 34, 15 ], [ Ua, 47, 16, "*" ] ])();

const yh = /*@__PURE__*/ (() => [ [ [ Ua, 42, Oa ], [ Ua, lh, 7 ], [ Ua, rh, La, ":", "before", "after", "first-letter", "first-line" ], [ Ua, rh, ja, "global" ], [ Ua, rh, 3, "has", "host-context", "not", "where", "is", "matches", "any" ], [ Ua, rh, 4 ], [ Ua, za, 1 ], [ Ua, nh, 1 ], [ Ua, Ka, 1 ], [ Ua, 64, Fa, "keyframe" ], [ Ua, 64, Da, "media", "supports", "container" ], [ Ua, 64, Xa ], [ Ua, dh, 13 ], [ 47, 42, 16 ], [ Ua, 59, Wa ], [ Ua, ph, Wa ], [ Ua, Za, Wa ], ...$h ], [ [ Ua, Ba, Va ] ], [ [ Ua, Ba, Va ] ], [ [ Ua, 40, Ca ], [ Ua, Ba, Va ] ], [ [ Ua, 40, 8 ], [ Ua, Ba, Va ] ], [ [ Ua, 40, Ca ], [ Ua, Ba, Wa ] ], [ [ Ua, Ba, Wa ] ], [ [ Ua, 93, Va ], [ Ua, 39, 14 ], [ Ua, 34, 15 ] ], [ [ Ua, Za, Wa ], ...$h ], [ [ Ua, ph, Wa ], ...$h ], [ [ Ua, ph, Wa ], [ Qa, za, 1 ], [ Ua, rh, ja, "global" ], [ Ua, dh, 13 ], ...$h ], [ [ Ua, dh, Ca ], [ Ua, 59, Wa ], ...$h ], [ [ Ua, 59, Wa ], [ Ua, dh, 9 ], ...$h ], [ [ Ua, ph, Wa ], [ Ua, dh, 13 ], [ Ua, 40, 8 ], ...$h ], [ [ Ua, 39, Wa ] ], [ [ Ua, 34, Wa ] ], [ [ 42, 47, Wa ] ] ])();

const mh = t => ({
    styleId: _h(t, t => t, !1)
});

const wh = /*#__PURE__*/ xs(mh);

const vh = t => ({
    scopeId: li + _h(t, qa, !0)
});

const bh = /*#__PURE__*/ xs(vh);

const _h = (t, n, e) => {
    let {val: s, set: o, iCtx: i, i: r} = Wo();
    if (s) {
        return s;
    }
    const c = ((t, n) => `${lr(t.ot)}-${n}`)(t, r);
    const l = i._;
    o(c);
    if (!t.resolved) {
        throw t.resolve().then(t => i.$.ti(n(t, c), c, l, e));
    }
    i.$.ti(n(t.resolved, c), c, l, e);
    return c;
};

const gh = (t, n) => {
    t.resolve();
    return Os(t, n);
};

const Sh = (t, n) => zo(gh, t, n);

const Eh = xs(Sh);

const kh = t => {
    t.resolve();
    return Ls(t);
};

const Rh = t => zo(kh, t);

const Ph = xs(Rh);

const Th = (t, n) => {
    const {val: e, set: s, i: o, iCtx: i} = Wo();
    const r = n?.strategy ?? "intersection-observer";
    if (e) {
        if (!(e.h & 32) && !cd()) {
            e.h |= 32;
            qh(e, r);
        }
        return;
    }
    let c;
    if (cd()) {
        c = 1;
    } else {
        c = 5;
        t.resolve();
        yn(i.$, i._, 1);
    }
    const l = new ku(c, o, i._, t, null);
    s(l);
    qh(l, r);
};

const qh = (t, n) => {
    n === "intersection-observer" ? Uc("qvisible", Ah(t)) : n === "document-ready" ? zc("qinit", Ah(t)) : n === "document-idle" && zc("qidle", Ah(t));
};

const Ah = t => la(null, "_task", An, null, [ t ]);

const Mh = xs(Xc);

const xh = /*#__PURE__*/ xs(Su);

const Ih = /*#__PURE__*/ xs(Th);

const Nh = (t, n) => {
    t.resolve();
    return js(t, n);
};

const Ch = (t, n) => zo(Nh, t, n);

const Oh = xs(Ch);

const jh = () => {
    const t = Ra({
        error: void 0
    });
    wf(_f, t);
    return t;
};

const Lh = async ({track: t}) => {
    const n = na[0];
    t(() => n.items);
    const e = If();
    const s = e._;
    const o = e.$;
    const i = yn(o, s, 256);
    const r = Ce;
    r && await i;
};

const Fh = t => {
    if (!__EXPERIMENTAL__.each) {
        throw Error('Each is experimental and must be enabled with `experimental: ["each"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ kc(Lh, "_eaT", [ t ]));
    return go;
};

const Dh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Fh, "_eaC"));

const Xh = (t, n, e) => Ke(t) ? t.getFn(n)(e) : t(e);

const Wh = ({track: t}) => {
    const n = na[0];
    const e = If();
    const s = e._;
    const o = e.$;
    const i = Ce;
    return Gi(t(() => Xh(n.when$, If(), void 0)), t => {
        const r = t ? n.then$ : n.else$;
        return Gi(r ? Xh(r, e, t) : null, t => {
            const n = r ? [ t ] : [];
            if (i) {
                const t = o;
                return t.renderJSX(n, {
                    currentStyleScoped: null,
                    parentComponentFrame: t.getComponentFrame(0)
                });
            }
            Ut(s, n);
            yn(o, s, 2);
        });
    });
};

const Vh = t => {
    if (!__EXPERIMENTAL__.show) {
        throw Error('Show is experimental and must be enabled with `experimental: ["show"]` in the `qwikVite` plugin.');
    }
    Su(/*#__PURE__*/ kc(Wh, "_shT", [ t ]));
    return go;
};

const Uh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Vh, "_shC"));

const zh = /*#__PURE__*/ mf("qk-reveal");

const Bh = t => ({
    order: t.order ?? "parallel",
    collapsed: t.collapsed === !0,
    items: [],
    version: Fs(0)
});

const Qh = () => {
    const t = na[0];
    if (t !== null && t.reveal.version.value < 0) {
        return !1;
    }
    if (!Oe) {
        const n = t?.reveal.ooos;
        if (n) {
            return n.canReveal(t);
        }
    }
    return dd(t);
};

const Hh = ({cleanup: t}) => {
    const n = na[0];
    t(() => {
        if (!Oe) {
            return;
        }
        const t = n.reveal.items;
        const e = t.indexOf(n.item);
        if (e !== -1) {
            t.splice(e, 1);
            n.reveal.version.value++;
        }
    });
};

const Jh = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Reveal is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = zo(Bh, t);
    wf(zh, n);
    const e = !Oe;
    if (__EXPERIMENTAL__.suspense && e && wd()) {
        const t = (t => {
            const n = t.ooos;
            if (n) {
                return n;
            }
            const e = ((t, n) => {
                const e = If().$;
                const s = (pd.get(e) || 0) + 1;
                pd.set(e, s);
                return new $d(s, t, n);
            })(t.order, t.collapsed);
            t.ooos = pf(e);
            return e;
        })(n);
        return /* @__PURE__ */ co(bd, {
            coordinator: t
        }, null, null, 0, "u7_0");
    }
    return /* @__PURE__ */ co(_o, null, null, null, 0, "u7_0");
};

const Yh = /*#__PURE__*/ va(
/*#__PURE__*/ kc(Jh, "_reC"));

const bd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd((t, n, e, s) => {
    const o = n.varProps.coordinator;
    s(() => {
        const n = o.script();
        if (!n) {
            return;
        }
        t.emitOutOfOrderExecutorIfNeeded();
        t.emitInlineScript(n);
    });
    s(/*#__PURE__*/ co(_o, null, null, null, 0, "u7_0"));
}) : null;

const Gh = (t, n, e, s) => ({
    display: n.value !== "fallback" || t.fallback == null || t.fallback === !1 || !e.value && s.reveal.collapsed ? "none" : "contents"
});

const vd = '{display:p1.value==="fallback"&&p0.fallback!=null&&p0.fallback!==false&&(p2.value||!p3.reveal.collapsed)?"contents":"none"}';

const Kh = (t, n) => ({
    display: t.value === "content" && n.value ? "contents" : "none"
});

const Zh = ({track: t, cleanup: n}) => {
    const e = na[0], s = na[1], o = na[2], i = na[3];
    const r = t(e);
    const c = Oe;
    i !== null && c && i.reveal.version.value++;
    if (!c || r === 0) {
        o.value = "content";
        return;
    }
    const l = setTimeout(() => {
        e.value > 0 && (o.value = "fallback");
    }, s.delay ?? 0);
    n(() => clearTimeout(l));
};

const td = t => {
    if (!__EXPERIMENTAL__.suspense) {
        throw Error('Suspense is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
    }
    const n = Uo("content");
    const e = (() => {
        if (!__EXPERIMENTAL__.suspense) {
            throw Error('useCursorBoundary is experimental and must be enabled with `experimental: ["suspense"]` in the `qwikVite` plugin.');
        }
        return Uo(0);
    })();
    const s = (t => {
        const n = vf(zh, null);
        const e = zo(() => {
            if (n === null) {
                return null;
            }
            const e = {
                boundary: t
            };
            n.items.push(e);
            return {
                reveal: n,
                item: e
            };
        });
        e !== null && Su(/*#__PURE__*/ kc(Hh, "_reT", [ e ]), {
            deferUpdates: !1
        });
        return e;
    })(e);
    const o = Sh(
    /*#__PURE__*/ kc(Qh, "_reR", [ s ]));
    Su(
    /*#__PURE__*/ kc(Zh, "_suT", [ e, t, n, s ]));
    const i = !Oe;
    const r = i && wd();
    const c = r ? (() => If().$.nextOutOfOrderId())() : 0;
    const l = r ? s?.reveal.ooos?.register(s) ?? null : null;
    const u = r && jf(() => t.fallback != null && t.fallback !== !1) && (l === null || l.showFallback);
    const f = u && function a(t) {
        return typeof t === "number" && Number.isFinite(t) && t > 0;
    }(t.delay) ? {
        contentResolved: !1,
        delay: t.delay,
        delayTimer: null
    } : null;
    const h = /*#__PURE__*/ Nc(Kh, [ n, o ], '{display:p0.value==="content"&&p1.value?"contents":"none"}');
    const d = r ? /*#__PURE__*/ co(_d, {
        boundary: f,
        fallbackStyle: Nc(Gh, [ t, n, o, s ], vd),
        showFallback: u,
        state: n
    }, null, Bs(t, "fallback"), 1, null) : /*#__PURE__*/ co("div", {
        style: Nc(Gh, [ t, n, o, s ], vd)
    }, null, Bs(t, "fallback"), 1, null);
    return [ d, 
    /*#__PURE__*/ co("div", null, r ? {
        [od]: c + "",
        style: h
    } : {
        style: h
    }, 
    /*#__PURE__*/ co(r ? gd : _o, r ? {
        [Vi]: e,
        boundary: f,
        boundaryId: c,
        contentStyle: h,
        reveal: l
    } : {
        [Vi]: e
    }, null, null, 3, "u6_0"), 1, null) ];
};

const nd = /*#__PURE__*/ va(
/*#__PURE__*/ kc(td, "_suC"));

const _d = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd((t, n, e, s) => {
    const o = n.varProps.boundary;
    const i = n.varProps.fallbackStyle;
    const r = n.varProps.showFallback === !0;
    const c = n.varProps.state;
    r && (o ? s(() => function n(t, e, s) {
        e.delayTimer = setTimeout(() => {
            e.delayTimer = null;
            t.S(async () => {
                if (e.contentResolved) {
                    return;
                }
                s.value = "fallback";
                t.emitBackpatchDataAndExecutorIfNeeded();
                await t.streamHandler.flush();
            });
        }, e.delay);
    }(t, o, c)) : c.value = "fallback");
    s(
    /*#__PURE__*/ co("div", {
        style: i
    }, null, n.children, 1, null));
}) : null;

const gd = __EXPERIMENTAL__.suspense ? /*#__PURE__*/ hd(async (t, n, e) => {
    const s = n.varProps.boundaryId;
    const o = "" + s;
    const i = n.varProps.boundary;
    const r = n.varProps.contentStyle;
    const c = n.varProps.reveal;
    const l = t.segment(o, function u(t, n, e) {
        const s = e.parentComponentFrame;
        if (!s) {
            return /* @__PURE__ */ co(_o, n.varProps, n.constProps, n.children, n.flags, n.key);
        }
        const o = k(s.componentNode, n, t);
        const i = n.children || null;
        const r = s.claimChildrenForSlot(o) || i;
        i && r !== i && t.addUnclaimedProjection(s, "", i);
        return /* @__PURE__ */ co(_o, n.varProps, n.constProps, r, n.flags, n.key);
    }(t, n, e), e);
    t.write(`<template ${ai}="${s}"></template>`);
    t.emitOutOfOrderExecutorIfNeeded();
    t.queueOutOfOrderSegment(l.then(n => async function e(t, n, s, o, i, r, c) {
        if (c) {
            c.contentResolved = !0;
            if (c.delayTimer) {
                clearTimeout(c.delayTimer);
                c.delayTimer = null;
            }
        }
        r?.resolve();
        await t.S(async () => {
            t.addRoot(i);
            const e = await o.container.P(s, o);
            t.write(`<template ${ai}="${n}"${r?.attrs ?? ""}>`);
            t.write(e.html);
            t.write("</template>");
            t.emitOutOfOrderSegmentScripts(e.scripts);
            t.emitInlineScript(`qO(${n})`);
            await t.streamHandler.flush();
        });
    }(t, s, o, n, r, c, i)));
}) : null;

const ed = t => {
    const n = import.meta.env?.BASE_URL || "/";
    const e = {
        path: "qwik-prefetch-service-worker.js",
        ...t
    };
    t?.path?.startsWith?.("/") ? e.path = t.path : e.path = n + e.path;
    let s = id.replace('"_URL_"', JSON.stringify(e.path.split("/").pop()));
    s = s.replaceAll(/\s\s+/gm, "");
    const o = {
        dangerouslySetInnerHTML: "(" + s + ")(navigator.serviceWorker);",
        nonce: e.nonce
    };
    return co("script", null, o, null, 0, "prefetch-service-worker");
};

const id =  "" + (t => {
    "getRegistrations" in t && t.getRegistrations().then(t => {
        for (let n = 0; n < t.length; n++) {
            const e = t[n];
            e.active && e.active.scriptURL.endsWith("_URL_") && e.unregister().catch(console.error);
        }
    });
    "caches" in window && caches.keys().then(t => {
        const n = t.find(t => t.startsWith("QwikBundles"));
        n && caches.delete(n).catch(console.error);
    }).catch(console.error);
});

const rd = () => null;

globalThis.__qwik && Ye(30, [ globalThis.__qwik, Xr ]);

globalThis.__qwik = Xr;

import.meta.hot && import.meta.hot.dispose(() => {
    globalThis.__qwik = void 0;
});

export { pa as $, Dh as Each, vo as Fragment, $f as NoSerializeSymbol, rd as PrefetchGraph, ed as PrefetchServiceWorker, bo as RenderOnce, Wc as Resource, Yh as Reveal, Eo as SSRComment, So as SSRRaw, Ro as SSRStream, ko as SSRStreamBlock, yf as SerializerSymbol, Uh as Show, go as SkipRender, _o as Slot, nd as Suspense, ls as _CONST_PROPS, Af as _DomContainer, Vr as _EFFECT_BACK_REF, Ci as _ELEMENT_SEQ, ds as _EMPTY_ARRAY, ps as _EMPTY_OBJ, as as _IMMUTABLE, Cc as _SharedContainer, Ys as _SubscriptionData, Ku as _SubscriptionPatch, ku as _Task, hs as _UNINITIALIZED, us as _VAR_PROPS, Yn as _addProjection, na as _captures, b as _chk, fe as _createDeserializeContainer, la as _createQRL, xn as _createStore, Ki as _delay, ue as _deserialize, yc as _dumpState, Fh as _eaC, Lh as _eaT, pn as _executeSsrChores, Nc as _fnSignal, Ic as _getAsyncLocalStorage, _s as _getConstProps, Vf as _getContextContainer, Wf as _getContextEvent, Xf as _getContextHostElement, Se as _getDomContainer, ke as _getQContainerElement, w as _getSubscriber, bs as _getVarProps, Vu as _hasStoreEffects, Jc as _hmr, Cs as _injectAsyncSignalValue, qe as _invoke, Zs as _isJSXNode, ju as _isSignalNotInvalid, zu as _isStore, Vn as _isStringifiable, Ru as _isTask, Uf as _jsxBranch, ao as _jsxC, po as _jsxQ, ho as _jsxS, co as _jsxSorted, fo as _jsxSplit, Xe as _mapApp_findIndx, Ve as _mapArray_get, We as _mapArray_set, Ou as _markSignalAsExternallyOwned, xe as _newInvokeContext, Rc as _noopQrl, Pc as _noopQrlDEV, Dn as _preprocessState, wa as _qrlSync, On as _qrlToString, Tc as _qrlWithChunk, qc as _qrlWithChunkDEV, Jh as _reC, Qh as _reR, Hh as _reT, xc as _regSymbol, Zn as _removeProjection, _ as _res, bf as _resolveContextWithoutSequentialScope, Mo as _restProps, n as _retryOnPromise, Dc as _rsc, I as _run, le as _serialize, Qn as _setEvent, Gn as _setProjectionTarget, Vh as _shC, Wh as _shT, td as _suC, Zh as _suT, An as _task, Kn as _updateProjectionProps, Jn as _useHmr, v as _val, cf as _verifySerializable, El as _vnode_ensureElementInflated, du as _vnode_getAttrKeys, Bl as _vnode_getElementName, Jl as _vnode_getFirstChild, bl as _vnode_getProp, Ml as _vnode_getVNodeForChildNode, Xl as _vnode_insertBefore, pl as _vnode_isElementVNode, yl as _vnode_isMaterialized, ml as _vnode_isTextVNode, wl as _vnode_isVirtualVNode, hl as _vnode_newVirtual, Ul as _vnode_remove, _l as _vnode_setProp, Sn as _vnode_toString, zf as _waitUntilRendered, zn as _walkJSX, Bs as _wrapProp, Hs as _wrapSignal, ga as component$, va as componentQrl, Xs as createAsync$, js as createAsyncQrl, Ds as createComputed$, Os as createComputedQrl, mf as createContextId, g as createElement, Ws as createSerializer$, Ls as createSerializerQrl, Fs as createSignal, Sa as event$, ya as eventQrl, Wu as forceStoreEffects, Ea as getClientManifest, Se as getDomContainer, Pe as getLocale, mr as getPlatform, g as h, xs as implicit$FirstArg, kc as inlinedQrl, Mc as inlinedQrlDEV, je as isDev, Tu as isSignal, yo as jsx, mo as jsxDEV, wo as jsxs, pf as noSerialize, Ec as qrl, Ac as qrlDEV, ka as render, yr as setPlatform, ma as sync$, jf as untrack, Uu as unwrapStore, Oh as useAsync$, Ch as useAsyncQrl, Eh as useComputed$, Sh as useComputedQrl, zo as useConstant, vf as useContext, wf as useContextProvider, jh as useErrorBoundary, Pa as useId, Fc as useLexicalScope, Uc as useOn, zc as useOnDocument, Bc as useOnWindow, Mh as useResource$, Xc as useResourceQrl, Ph as useSerializer$, Rh as useSerializerQrl, Ie as useServerData, Uo as useSignal, Ra as useStore, wh as useStyles$, mh as useStylesQrl, bh as useStylesScoped$, vh as useStylesScopedQrl, xh as useTask$, Su as useTaskQrl, Ih as useVisibleTask$, Th as useVisibleTaskQrl, Xr as version, Te as withLocale };
